/*! shopify_app_compiler 2025-07-03 */
var requirejs, require, define;

!function(global, setTimeout) {
    var req, s, head, baseElement, dataMain, src, interactiveScript, currentlyAddingScript, mainScript, subPath, version = "2.3.6", commentRegExp = /\/\*[\s\S]*?\*\/|([^:"'=]|^)\/\/.*$/gm, cjsRequireRegExp = /[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g, jsSuffixRegExp = /\.js$/, currDirRegExp = /^\.\//, op = Object.prototype, ostring = op.toString, hasOwn = op.hasOwnProperty, isBrowser = !("undefined" == typeof window || "undefined" == typeof navigator || !window.document), isWebWorker = !isBrowser && "undefined" != typeof importScripts, readyRegExp = isBrowser && "PLAYSTATION 3" === navigator.platform ? /^complete$/ : /^(complete|loaded)$/, defContextName = "_", isOpera = "undefined" != typeof opera && "[object Opera]" === opera.toString(), contexts = {}, cfg = {}, globalDefQueue = [], useInteractive = !1;
    function commentReplace(e, t) {
        return t || "";
    }
    function isFunction(e) {
        return "[object Function]" === ostring.call(e);
    }
    function isArray(e) {
        return "[object Array]" === ostring.call(e);
    }
    function each(e, t) {
        var i;
        if (e) for (i = 0; i < e.length && (!e[i] || !t(e[i], i, e)); i += 1);
    }
    function eachReverse(e, t) {
        var i;
        if (e) for (i = e.length - 1; -1 < i && (!e[i] || !t(e[i], i, e)); i -= 1);
    }
    function hasProp(e, t) {
        return hasOwn.call(e, t);
    }
    function getOwn(e, t) {
        return hasProp(e, t) && e[t];
    }
    function eachProp(e, t) {
        var i;
        for (i in e) if (hasProp(e, i) && t(e[i], i)) break;
    }
    function mixin(i, e, r, n) {
        return e && eachProp(e, function(e, t) {
            !r && hasProp(i, t) || (!n || "object" != typeof e || !e || isArray(e) || isFunction(e) || e instanceof RegExp ? i[t] = e : (i[t] || (i[t] = {}), 
            mixin(i[t], e, r, n)));
        }), i;
    }
    function bind(e, t) {
        return function() {
            return t.apply(e, arguments);
        };
    }
    function scripts() {
        return document.getElementsByTagName("script");
    }
    function defaultOnError(e) {
        throw e;
    }
    function getGlobal(e) {
        if (!e) return e;
        var t = global;
        return each(e.split("."), function(e) {
            t = t[e];
        }), t;
    }
    function makeError(e, t, i, r) {
        var n = new Error(t + "\nhttps://requirejs.org/docs/errors.html#" + e);
        return n.requireType = e, n.requireModules = r, i && (n.originalError = i), 
        n;
    }
    if (void 0 === define) {
        if (void 0 !== requirejs) {
            if (isFunction(requirejs)) return;
            cfg = requirejs, requirejs = void 0;
        }
        void 0 === require || isFunction(require) || (cfg = require, require = void 0), 
        req = requirejs = function(e, t, i, r) {
            var n, o, a = defContextName;
            return isArray(e) || "string" == typeof e || (o = e, isArray(t) ? (e = t, 
            t = i, i = r) : e = []), o && o.context && (a = o.context), (n = getOwn(contexts, a)) || (n = contexts[a] = req.s.newContext(a)), 
            o && n.configure(o), n.require(e, t, i);
        }, req.config = function(e) {
            return req(e);
        }, req.nextTick = void 0 !== setTimeout ? function(e) {
            setTimeout(e, 4);
        } : function(e) {
            e();
        }, require || (require = req), req.version = version, req.jsExtRegExp = /^\/|:|\?|\.js$/, 
        req.isBrowser = isBrowser, s = req.s = {
            contexts: contexts,
            newContext: newContext
        }, req({}), each([ "toUrl", "undef", "defined", "specified" ], function(t) {
            req[t] = function() {
                var e = contexts[defContextName];
                return e.require[t].apply(e, arguments);
            };
        }), isBrowser && (head = s.head = document.getElementsByTagName("head")[0], 
        baseElement = document.getElementsByTagName("base")[0], baseElement && (head = s.head = baseElement.parentNode)), 
        req.onError = defaultOnError, req.createNode = function(e, t, i) {
            var r = e.xhtml ? document.createElementNS("http://www.w3.org/1999/xhtml", "html:script") : document.createElement("script");
            return r.type = e.scriptType || "text/javascript", r.charset = "utf-8", 
            r.async = !0, r;
        }, req.load = function(t, i, r) {
            var e, n = t && t.config || {};
            if (isBrowser) return (e = req.createNode(n, i, r)).setAttribute("data-requirecontext", t.contextName), 
            e.setAttribute("data-requiremodule", i), !e.attachEvent || e.attachEvent.toString && e.attachEvent.toString().indexOf("[native code") < 0 || isOpera ? (e.addEventListener("load", t.onScriptLoad, !1), 
            e.addEventListener("error", t.onScriptError, !1)) : (useInteractive = !0, 
            e.attachEvent("onreadystatechange", t.onScriptLoad)), e.src = r, n.onNodeCreated && n.onNodeCreated(e, n, i, r), 
            currentlyAddingScript = e, baseElement ? head.insertBefore(e, baseElement) : head.appendChild(e), 
            currentlyAddingScript = null, e;
            if (isWebWorker) try {
                setTimeout(function() {}, 0), importScripts(r), t.completeLoad(i);
            } catch (e) {
                t.onError(makeError("importscripts", "importScripts failed for " + i + " at " + r, e, [ i ]));
            }
        }, isBrowser && !cfg.skipDataMain && eachReverse(scripts(), function(e) {
            if (head || (head = e.parentNode), dataMain = e.getAttribute("data-main")) return mainScript = dataMain, 
            cfg.baseUrl || -1 !== mainScript.indexOf("!") || (mainScript = (src = mainScript.split("/")).pop(), 
            subPath = src.length ? src.join("/") + "/" : "./", cfg.baseUrl = subPath), 
            mainScript = mainScript.replace(jsSuffixRegExp, ""), req.jsExtRegExp.test(mainScript) && (mainScript = dataMain), 
            cfg.deps = cfg.deps ? cfg.deps.concat(mainScript) : [ mainScript ], 
            !0;
        }), define = function(e, i, t) {
            var r, n;
            "string" != typeof e && (t = i, i = e, e = null), isArray(i) || (t = i, 
            i = null), !i && isFunction(t) && (i = [], t.length && (t.toString().replace(commentRegExp, commentReplace).replace(cjsRequireRegExp, function(e, t) {
                i.push(t);
            }), i = (1 === t.length ? [ "require" ] : [ "require", "exports", "module" ]).concat(i))), 
            useInteractive && (r = currentlyAddingScript || getInteractiveScript()) && (e || (e = r.getAttribute("data-requiremodule")), 
            n = contexts[r.getAttribute("data-requirecontext")]), n ? (n.defQueue.push([ e, i, t ]), 
            n.defQueueMap[e] = !0) : globalDefQueue.push([ e, i, t ]);
        }, define.amd = {
            jQuery: !0
        }, req.exec = function(text) {
            return eval(text);
        }, req(cfg);
    }
    function newContext(u) {
        var i, e, l, c, d, g = {
            waitSeconds: 7,
            baseUrl: "./",
            paths: {},
            bundles: {},
            pkgs: {},
            shim: {},
            config: {}
        }, p = {}, f = {}, r = {}, h = [], m = {}, n = {}, v = {}, x = 1, b = 1;
        function q(e, t, i) {
            var r, n, o, a, s, u, c, d, p, f, l = t && t.split("/"), h = g.map, m = h && h["*"];
            if (e && (u = (e = e.split("/")).length - 1, g.nodeIdCompat && jsSuffixRegExp.test(e[u]) && (e[u] = e[u].replace(jsSuffixRegExp, "")), 
            "." === e[0].charAt(0) && l && (e = l.slice(0, l.length - 1).concat(e)), 
            function(e) {
                var t, i;
                for (t = 0; t < e.length; t++) if ("." === (i = e[t])) e.splice(t, 1), 
                t -= 1; else if (".." === i) {
                    if (0 === t || 1 === t && ".." === e[2] || ".." === e[t - 1]) continue;
                    0 < t && (e.splice(t - 1, 2), t -= 2);
                }
            }(e), e = e.join("/")), i && h && (l || m)) {
                e: for (o = (n = e.split("/")).length; 0 < o; o -= 1) {
                    if (s = n.slice(0, o).join("/"), l) for (a = l.length; 0 < a; a -= 1) if ((r = getOwn(h, l.slice(0, a).join("/"))) && (r = getOwn(r, s))) {
                        c = r, d = o;
                        break e;
                    }
                    !p && m && getOwn(m, s) && (p = getOwn(m, s), f = o);
                }
                !c && p && (c = p, d = f), c && (n.splice(0, d, c), e = n.join("/"));
            }
            return getOwn(g.pkgs, e) || e;
        }
        function E(t) {
            isBrowser && each(scripts(), function(e) {
                if (e.getAttribute("data-requiremodule") === t && e.getAttribute("data-requirecontext") === l.contextName) return e.parentNode.removeChild(e), 
                !0;
            });
        }
        function w(e) {
            var t = getOwn(g.paths, e);
            if (t && isArray(t) && 1 < t.length) return t.shift(), l.require.undef(e), 
            l.makeRequire(null, {
                skipMap: !0
            })([ e ]), !0;
        }
        function y(e) {
            var t, i = e ? e.indexOf("!") : -1;
            return -1 < i && (t = e.substring(0, i), e = e.substring(i + 1, e.length)), 
            [ t, e ];
        }
        function S(e, t, i, r) {
            var n, o, a, s, u = null, c = t ? t.name : null, d = e, p = !0, f = "";
            return e || (p = !1, e = "_@r" + (x += 1)), u = (s = y(e))[0], e = s[1], 
            u && (u = q(u, c, r), o = getOwn(m, u)), e && (u ? f = i ? e : o && o.normalize ? o.normalize(e, function(e) {
                return q(e, c, r);
            }) : -1 === e.indexOf("!") ? q(e, c, r) : e : (u = (s = y(f = q(e, c, r)))[0], 
            f = s[1], i = !0, n = l.nameToUrl(f))), {
                prefix: u,
                name: f,
                parentMap: t,
                unnormalized: !!(a = !u || o || i ? "" : "_unnormalized" + (b += 1)),
                url: n,
                originalName: d,
                isDefine: p,
                id: (u ? u + "!" + f : f) + a
            };
        }
        function k(e) {
            var t = e.id, i = getOwn(p, t);
            return i || (i = p[t] = new l.Module(e)), i;
        }
        function M(e, t, i) {
            var r = e.id, n = getOwn(p, r);
            !hasProp(m, r) || n && !n.defineEmitComplete ? (n = k(e)).error && "error" === t ? i(n.error) : n.on(t, i) : "defined" === t && i(m[r]);
        }
        function O(i, e) {
            var t = i.requireModules, r = !1;
            e ? e(i) : (each(t, function(e) {
                var t = getOwn(p, e);
                t && (t.error = i, t.events.error && (r = !0, t.emit("error", i)));
            }), r || req.onError(i));
        }
        function j() {
            globalDefQueue.length && (each(globalDefQueue, function(e) {
                var t = e[0];
                "string" == typeof t && (l.defQueueMap[t] = !0), h.push(e);
            }), globalDefQueue = []);
        }
        function P(e) {
            delete p[e], delete f[e];
        }
        function R() {
            var e, r, t = 1e3 * g.waitSeconds, n = t && l.startTime + t < new Date().getTime(), o = [], a = [], s = !1, u = !0;
            if (!i) {
                if (i = !0, eachProp(f, function(e) {
                    var t = e.map, i = t.id;
                    if (e.enabled && (t.isDefine || a.push(e), !e.error)) if (!e.inited && n) w(i) ? s = r = !0 : (o.push(i), 
                    E(i)); else if (!e.inited && e.fetched && t.isDefine && (s = !0, 
                    !t.prefix)) return u = !1;
                }), n && o.length) return (e = makeError("timeout", "Load timeout for modules: " + o, null, o)).contextName = l.contextName, 
                O(e);
                u && each(a, function(e) {
                    !function n(o, a, s) {
                        var e = o.map.id;
                        o.error ? o.emit("error", o.error) : (a[e] = !0, each(o.depMaps, function(e, t) {
                            var i = e.id, r = getOwn(p, i);
                            !r || o.depMatched[t] || s[i] || (getOwn(a, i) ? (o.defineDep(t, m[i]), 
                            o.check()) : n(r, a, s));
                        }), s[e] = !0);
                    }(e, {}, {});
                }), n && !r || !s || !isBrowser && !isWebWorker || d || (d = setTimeout(function() {
                    d = 0, R();
                }, 50)), i = !1;
            }
        }
        function a(e) {
            hasProp(m, e[0]) || k(S(e[0], null, !0)).init(e[1], e[2]);
        }
        function o(e, t, i, r) {
            e.detachEvent && !isOpera ? r && e.detachEvent(r, t) : e.removeEventListener(i, t, !1);
        }
        function s(e) {
            var t = e.currentTarget || e.srcElement;
            return o(t, l.onScriptLoad, "load", "onreadystatechange"), o(t, l.onScriptError, "error"), 
            {
                node: t,
                id: t && t.getAttribute("data-requiremodule")
            };
        }
        function T() {
            var e;
            for (j(); h.length; ) {
                if (null === (e = h.shift())[0]) return O(makeError("mismatch", "Mismatched anonymous define() module: " + e[e.length - 1]));
                a(e);
            }
            l.defQueueMap = {};
        }
        return c = {
            require: function(e) {
                return e.require ? e.require : e.require = l.makeRequire(e.map);
            },
            exports: function(e) {
                if (e.usingExports = !0, e.map.isDefine) return e.exports ? m[e.map.id] = e.exports : e.exports = m[e.map.id] = {};
            },
            module: function(e) {
                return e.module ? e.module : e.module = {
                    id: e.map.id,
                    uri: e.map.url,
                    config: function() {
                        return getOwn(g.config, e.map.id) || {};
                    },
                    exports: e.exports || (e.exports = {})
                };
            }
        }, (e = function(e) {
            this.events = getOwn(r, e.id) || {}, this.map = e, this.shim = getOwn(g.shim, e.id), 
            this.depExports = [], this.depMaps = [], this.depMatched = [], this.pluginMaps = {}, 
            this.depCount = 0;
        }).prototype = {
            init: function(e, t, i, r) {
                r = r || {}, this.inited || (this.factory = t, i ? this.on("error", i) : this.events.error && (i = bind(this, function(e) {
                    this.emit("error", e);
                })), this.depMaps = e && e.slice(0), this.errback = i, this.inited = !0, 
                this.ignore = r.ignore, r.enabled || this.enabled ? this.enable() : this.check());
            },
            defineDep: function(e, t) {
                this.depMatched[e] || (this.depMatched[e] = !0, this.depCount -= 1, 
                this.depExports[e] = t);
            },
            fetch: function() {
                if (!this.fetched) {
                    this.fetched = !0, l.startTime = new Date().getTime();
                    var e = this.map;
                    if (!this.shim) return e.prefix ? this.callPlugin() : this.load();
                    l.makeRequire(this.map, {
                        enableBuildCallback: !0
                    })(this.shim.deps || [], bind(this, function() {
                        return e.prefix ? this.callPlugin() : this.load();
                    }));
                }
            },
            load: function() {
                var e = this.map.url;
                n[e] || (n[e] = !0, l.load(this.map.id, e));
            },
            check: function() {
                if (this.enabled && !this.enabling) {
                    var t, e, i = this.map.id, r = this.depExports, n = this.exports, o = this.factory;
                    if (this.inited) {
                        if (this.error) this.emit("error", this.error); else if (!this.defining) {
                            if (this.defining = !0, this.depCount < 1 && !this.defined) {
                                if (isFunction(o)) {
                                    if (this.events.error && this.map.isDefine || req.onError !== defaultOnError) try {
                                        n = l.execCb(i, o, r, n);
                                    } catch (e) {
                                        t = e;
                                    } else n = l.execCb(i, o, r, n);
                                    if (this.map.isDefine && void 0 === n && ((e = this.module) ? n = e.exports : this.usingExports && (n = this.exports)), 
                                    t) return t.requireMap = this.map, t.requireModules = this.map.isDefine ? [ this.map.id ] : null, 
                                    t.requireType = this.map.isDefine ? "define" : "require", 
                                    O(this.error = t);
                                } else n = o;
                                if (this.exports = n, this.map.isDefine && !this.ignore && (m[i] = n, 
                                req.onResourceLoad)) {
                                    var a = [];
                                    each(this.depMaps, function(e) {
                                        a.push(e.normalizedMap || e);
                                    }), req.onResourceLoad(l, this.map, a);
                                }
                                P(i), this.defined = !0;
                            }
                            this.defining = !1, this.defined && !this.defineEmitted && (this.defineEmitted = !0, 
                            this.emit("defined", this.exports), this.defineEmitComplete = !0);
                        }
                    } else hasProp(l.defQueueMap, i) || this.fetch();
                }
            },
            callPlugin: function() {
                var u = this.map, c = u.id, e = S(u.prefix);
                this.depMaps.push(e), M(e, "defined", bind(this, function(e) {
                    var o, t, i, r = getOwn(v, this.map.id), n = this.map.name, a = this.map.parentMap ? this.map.parentMap.name : null, s = l.makeRequire(u.parentMap, {
                        enableBuildCallback: !0
                    });
                    return this.map.unnormalized ? (e.normalize && (n = e.normalize(n, function(e) {
                        return q(e, a, !0);
                    }) || ""), M(t = S(u.prefix + "!" + n, this.map.parentMap, !0), "defined", bind(this, function(e) {
                        this.map.normalizedMap = t, this.init([], function() {
                            return e;
                        }, null, {
                            enabled: !0,
                            ignore: !0
                        });
                    })), void ((i = getOwn(p, t.id)) && (this.depMaps.push(t), this.events.error && i.on("error", bind(this, function(e) {
                        this.emit("error", e);
                    })), i.enable()))) : r ? (this.map.url = l.nameToUrl(r), void this.load()) : ((o = bind(this, function(e) {
                        this.init([], function() {
                            return e;
                        }, null, {
                            enabled: !0
                        });
                    })).error = bind(this, function(e) {
                        this.inited = !0, (this.error = e).requireModules = [ c ], 
                        eachProp(p, function(e) {
                            0 === e.map.id.indexOf(c + "_unnormalized") && P(e.map.id);
                        }), O(e);
                    }), o.fromText = bind(this, function(e, t) {
                        var i = u.name, r = S(i), n = useInteractive;
                        t && (e = t), n && (useInteractive = !1), k(r), hasProp(g.config, c) && (g.config[i] = g.config[c]);
                        try {
                            req.exec(e);
                        } catch (e) {
                            return O(makeError("fromtexteval", "fromText eval for " + c + " failed: " + e, e, [ c ]));
                        }
                        n && (useInteractive = !0), this.depMaps.push(r), l.completeLoad(i), 
                        s([ i ], o);
                    }), void e.load(u.name, s, o, g));
                })), l.enable(e, this), this.pluginMaps[e.id] = e;
            },
            enable: function() {
                (f[this.map.id] = this).enabled = !0, this.enabling = !0, each(this.depMaps, bind(this, function(e, t) {
                    var i, r, n;
                    if ("string" == typeof e) {
                        if (e = S(e, this.map.isDefine ? this.map : this.map.parentMap, !1, !this.skipMap), 
                        this.depMaps[t] = e, n = getOwn(c, e.id)) return void (this.depExports[t] = n(this));
                        this.depCount += 1, M(e, "defined", bind(this, function(e) {
                            this.undefed || (this.defineDep(t, e), this.check());
                        })), this.errback ? M(e, "error", bind(this, this.errback)) : this.events.error && M(e, "error", bind(this, function(e) {
                            this.emit("error", e);
                        }));
                    }
                    i = e.id, r = p[i], hasProp(c, i) || !r || r.enabled || l.enable(e, this);
                })), eachProp(this.pluginMaps, bind(this, function(e) {
                    var t = getOwn(p, e.id);
                    t && !t.enabled && l.enable(e, this);
                })), this.enabling = !1, this.check();
            },
            on: function(e, t) {
                var i = this.events[e];
                i || (i = this.events[e] = []), i.push(t);
            },
            emit: function(e, t) {
                each(this.events[e], function(e) {
                    e(t);
                }), "error" === e && delete this.events[e];
            }
        }, (l = {
            config: g,
            contextName: u,
            registry: p,
            defined: m,
            urlFetched: n,
            defQueue: h,
            defQueueMap: {},
            Module: e,
            makeModuleMap: S,
            nextTick: req.nextTick,
            onError: O,
            configure: function(e) {
                if (e.baseUrl && "/" !== e.baseUrl.charAt(e.baseUrl.length - 1) && (e.baseUrl += "/"), 
                "string" == typeof e.urlArgs) {
                    var i = e.urlArgs;
                    e.urlArgs = function(e, t) {
                        return (-1 === t.indexOf("?") ? "?" : "&") + i;
                    };
                }
                var r = g.shim, n = {
                    paths: !0,
                    bundles: !0,
                    config: !0,
                    map: !0
                };
                eachProp(e, function(e, t) {
                    n[t] ? (g[t] || (g[t] = {}), mixin(g[t], e, !0, !0)) : g[t] = e;
                }), e.bundles && eachProp(e.bundles, function(e, t) {
                    each(e, function(e) {
                        e !== t && (v[e] = t);
                    });
                }), e.shim && (eachProp(e.shim, function(e, t) {
                    isArray(e) && (e = {
                        deps: e
                    }), !e.exports && !e.init || e.exportsFn || (e.exportsFn = l.makeShimExports(e)), 
                    r[t] = e;
                }), g.shim = r), e.packages && each(e.packages, function(e) {
                    var t;
                    t = (e = "string" == typeof e ? {
                        name: e
                    } : e).name, e.location && (g.paths[t] = e.location), g.pkgs[t] = e.name + "/" + (e.main || "main").replace(currDirRegExp, "").replace(jsSuffixRegExp, "");
                }), eachProp(p, function(e, t) {
                    e.inited || e.map.unnormalized || (e.map = S(t, null, !0));
                }), (e.deps || e.callback) && l.require(e.deps || [], e.callback);
            },
            makeShimExports: function(t) {
                return function() {
                    var e;
                    return t.init && (e = t.init.apply(global, arguments)), e || t.exports && getGlobal(t.exports);
                };
            },
            makeRequire: function(o, a) {
                function s(e, t, i) {
                    var r, n;
                    return a.enableBuildCallback && t && isFunction(t) && (t.__requireJsBuild = !0), 
                    "string" == typeof e ? isFunction(t) ? O(makeError("requireargs", "Invalid require call"), i) : o && hasProp(c, e) ? c[e](p[o.id]) : req.get ? req.get(l, e, o, s) : (r = S(e, o, !1, !0).id, 
                    hasProp(m, r) ? m[r] : O(makeError("notloaded", 'Module name "' + r + '" has not been loaded yet for context: ' + u + (o ? "" : ". Use require([])")))) : (T(), 
                    l.nextTick(function() {
                        T(), (n = k(S(null, o))).skipMap = a.skipMap, n.init(e, t, i, {
                            enabled: !0
                        }), R();
                    }), s);
                }
                return a = a || {}, mixin(s, {
                    isBrowser: isBrowser,
                    toUrl: function(e) {
                        var t, i = e.lastIndexOf("."), r = e.split("/")[0];
                        return -1 !== i && (!("." === r || ".." === r) || 1 < i) && (t = e.substring(i, e.length), 
                        e = e.substring(0, i)), l.nameToUrl(q(e, o && o.id, !0), t, !0);
                    },
                    defined: function(e) {
                        return hasProp(m, S(e, o, !1, !0).id);
                    },
                    specified: function(e) {
                        return e = S(e, o, !1, !0).id, hasProp(m, e) || hasProp(p, e);
                    }
                }), o || (s.undef = function(i) {
                    j();
                    var e = S(i, o, !0), t = getOwn(p, i);
                    t.undefed = !0, E(i), delete m[i], delete n[e.url], delete r[i], 
                    eachReverse(h, function(e, t) {
                        e[0] === i && h.splice(t, 1);
                    }), delete l.defQueueMap[i], t && (t.events.defined && (r[i] = t.events), 
                    P(i));
                }), s;
            },
            enable: function(e) {
                getOwn(p, e.id) && k(e).enable();
            },
            completeLoad: function(e) {
                var t, i, r, n = getOwn(g.shim, e) || {}, o = n.exports;
                for (j(); h.length; ) {
                    if (null === (i = h.shift())[0]) {
                        if (i[0] = e, t) break;
                        t = !0;
                    } else i[0] === e && (t = !0);
                    a(i);
                }
                if (l.defQueueMap = {}, r = getOwn(p, e), !t && !hasProp(m, e) && r && !r.inited) {
                    if (!(!g.enforceDefine || o && getGlobal(o))) return w(e) ? void 0 : O(makeError("nodefine", "No define call for " + e, null, [ e ]));
                    a([ e, n.deps || [], n.exportsFn ]);
                }
                R();
            },
            nameToUrl: function(e, t, i) {
                var r, n, o, a, s, u, c = getOwn(g.pkgs, e);
                if (c && (e = c), u = getOwn(v, e)) return l.nameToUrl(u, t, i);
                if (req.jsExtRegExp.test(e)) a = e + (t || ""); else {
                    for (r = g.paths, o = (n = e.split("/")).length; 0 < o; o -= 1) if (s = getOwn(r, n.slice(0, o).join("/"))) {
                        isArray(s) && (s = s[0]), n.splice(0, o, s);
                        break;
                    }
                    a = n.join("/"), a = ("/" === (a += t || (/^data\:|^blob\:|\?/.test(a) || i ? "" : ".js")).charAt(0) || a.match(/^[\w\+\.\-]+:/) ? "" : g.baseUrl) + a;
                }
                return g.urlArgs && !/^blob\:/.test(a) ? a + g.urlArgs(e, a) : a;
            },
            load: function(e, t) {
                req.load(l, e, t);
            },
            execCb: function(e, t, i, r) {
                return t.apply(r, i);
            },
            onScriptLoad: function(e) {
                if ("load" === e.type || readyRegExp.test((e.currentTarget || e.srcElement).readyState)) {
                    interactiveScript = null;
                    var t = s(e);
                    l.completeLoad(t.id);
                }
            },
            onScriptError: function(e) {
                var i = s(e);
                if (!w(i.id)) {
                    var r = [];
                    return eachProp(p, function(e, t) {
                        0 !== t.indexOf("_@r") && each(e.depMaps, function(e) {
                            if (e.id === i.id) return r.push(t), !0;
                        });
                    }), O(makeError("scripterror", 'Script error for "' + i.id + (r.length ? '", needed by: ' + r.join(", ") : '"'), e, [ i.id ]));
                }
            }
        }).require = l.makeRequire(), l;
    }
    function getInteractiveScript() {
        return interactiveScript && "interactive" === interactiveScript.readyState || eachReverse(scripts(), function(e) {
            if ("interactive" === e.readyState) return interactiveScript = e;
        }), interactiveScript;
    }
}(this, "undefined" == typeof setTimeout ? void 0 : setTimeout);

var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || {
            __proto__: []
        } instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, 
        new __());
    };
}();

var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var __generator = this && this.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        throw: verb(1),
        return: verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([ n, v ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 
            0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [ op[0] & 2, t.value ];
            switch (op[0]) {
              case 0:
              case 1:
                t = op;
                break;

              case 4:
                _.label++;
                return {
                    value: op[1],
                    done: false
                };

              case 5:
                _.label++;
                y = op[1];
                op = [ 0 ];
                continue;

              case 7:
                op = _.ops.pop();
                _.trys.pop();
                continue;

              default:
                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                }
                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                }
                if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                }
                if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                }
                if (t[2]) _.ops.pop();
                _.trys.pop();
                continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [ 6, e ];
            y = 0;
        } finally {
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

define("core/shopify-app/st-modules/_general-methods/dom-loaded", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDOMLoaded = void 0;
    var StDOMLoaded = function() {
        function StDOMLoaded() {
            var _this = this;
            this.className = "DOMLoaded";
            this.domLoaded = false;
            this.domLoadedCallbacks = [];
            this.readyStateChange = function() {
                if (document.readyState === "interactive") {
                    _this.domLoaded = true;
                    _this.fireDOMLoadedCallbacks();
                }
            };
            this.fireDOMLoadedCallbacks = function() {
                for (var i = 0; i < _this.domLoadedCallbacks.length; i++) {
                    _this.domLoadedCallbacks[i]();
                }
            };
            this.subscribeDOMLoaded = function(cb) {
                if (_this.domLoaded) {
                    cb();
                } else {
                    _this.domLoadedCallbacks.push(cb);
                }
            };
        }
        StDOMLoaded.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        StDOMLoaded.prototype.initDOMLoaded = function() {
            if (!StDOMLoaded.initStarted) {
                StDOMLoaded.initStarted = true;
                if (document.readyState === "interactive" || document.readyState === "complete") {
                    this.domLoaded = true;
                    this.fireDOMLoadedCallbacks();
                } else {
                    document.addEventListener("readystatechange", this.readyStateChange, false);
                }
            }
        };
        StDOMLoaded.initStarted = false;
        return StDOMLoaded;
    }();
    exports.StDOMLoaded = StDOMLoaded;
});

define("core/connector-app/_shared/routes.config", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.endpointData = void 0;
    const AWS_API = 'https://t1l4iwe5jb.execute-api.us-east-2.amazonaws.com';

    exports.endpointData = {
        webalias: {
            repSite: `${AWS_API}/sc-rep-site`,
            getReferralInformation: "||-API-ROOT-||/webalias/sca/getReferralInformation"
        },
        customer: {
            updatePersonalInfo: "||-API-ROOT-||/customer/sca/updatePersonalInfo",
            updateWebAlias: "||-API-ROOT-||/customer/sca/updateWebAlias",
            updateSponsor: "||-API-ROOT-||/customer/sca/updateSponsor",
            getReferralInfo: "||-API-ROOT-||/customer/gar/getReferralInfo",
            getReferredCustomers: "||-API-ROOT-||/customer/sca/getReferredCustomers",
            "customer-validation": `${AWS_API}/sc-test`,
            "generate-upload-url": `${AWS_API}/sc-avatar-url`,
            getTotalPagesCountOfReferredCustomers: "||-API-ROOT-||/customer/sca/getTotalPagesCountOfReferredCustomers"
        },
        order: {},
        product: {
            getVariantIdsBySkus: "||-API-ROOT-||/product/sca/getVariantIdsBySkus"
        },
        enrollment: {
            "validate-data": "||-API-ROOT-||/enrollment/sca/validate-data",
            submit: "||-API-ROOT-||/enrollment/sca/submit",
            createAccount: "||-API-ROOT-||/enrollment/sca/createAccount"
        },
        searchSponsor: {
            getSponsorInfo: `${AWS_API}/sc-sponsor-search`,
            getSponsorByPersonalInfo: `${AWS_API}/sc-sponsor-search`
        }
    };
});

define("core/shopify-app/st-modules/_static/static", [ "require", "exports", "core/connector-app/_shared/routes.config" ], function(require, exports, routes_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StStatic = void 0;
    var StStatic = function() {
        function StStatic() {
            var _this = this;
            this.className = "Static";
            this.shopConfig = window.stAppConfig;
            this.apiRoot = this.shopConfig.apiRoot;
            this.init = function() {};
            this.setup = function() {};
            this.obtainStaticEndpoints = function() {
                return _this.endpoint;
            };
            this.obtainMainScope = function() {
                return window.stApp;
            };
            this.obtainCart = function() {
                return window.shopifyCartData;
            };
            this.injectRootToEndpoints = function(endpoints) {
                for (var controllerKey in endpoints) {
                    for (var endpoint in endpoints[controllerKey]) {
                        endpoints[controllerKey][endpoint] = endpoints[controllerKey][endpoint].replace(/\|\|-API-ROOT-\|\|/g, _this.apiRoot);
                    }
                }
                return endpoints;
            };
            this.endpoint = this.injectRootToEndpoints(routes_config_1.endpointData);
        }
        StStatic.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        return StStatic;
    }();
    exports.StStatic = StStatic;
});

define("core/shopify-app/st-modules/_general-methods/ajax", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAjax = void 0;
    var StAjax = function() {
        function StAjax() {}
        StAjax.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        StAjax.prototype.setupFormatting = function(objectToQueryStringFn) {
            this.objectToQueryString = objectToQueryStringFn;
        };
        StAjax.prototype.determineContentType = function(contentType) {
            var output = {
                type: "application/x-www-form-urlencoded",
                prepFn: this.objectToQueryString
            };
            switch (contentType) {
              case "form":
                output.type = "application/x-www-form-urlencoded";
                output.prepFn = this.objectToQueryString;
                break;

              case "json":
                output.type = "application/json";
                output.prepFn = JSON.stringify;
                break;
            }
            return output;
        };
        StAjax.prototype.send = function(options) {
            var fnReference = this;
            if (typeof options == "object") {
                var defaultOptions = {
                    endpoint: "",
                    method: "POST",
                    contentType: "json",
                    data: {},
                    callback: function() {},
                    callbackParams: [],
                    headers: {}
                };
                var completeOptions_1 = __assign(__assign({}, defaultOptions), options);
                var contentTypeData = this.determineContentType(completeOptions_1.contentType);
                var requestMethod = completeOptions_1.method.toUpperCase();
                var allowedMethods = [ "POST", "GET", "PUT", "PATCH", "DELETE" ];
                completeOptions_1.method = allowedMethods.indexOf(requestMethod) >= 0 ? requestMethod : "POST";
                var request_1 = new XMLHttpRequest();
                request_1.open(completeOptions_1.method, completeOptions_1.endpoint, true);
                request_1.withCredentials = true;
                request_1.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                request_1.setRequestHeader("Content-Type", contentTypeData.type);
                request_1.setRequestHeader("credentials", "include");
                request_1.onreadystatechange = function() {
                    if (request_1.readyState === 4) {
                        completeOptions_1.callbackParams.unshift(request_1);
                        completeOptions_1.callback.apply(fnReference, completeOptions_1.callbackParams);
                    }
                };
                request_1.send(contentTypeData.prepFn(completeOptions_1.data));
                return request_1;
            }
        };
        return StAjax;
    }();
    exports.StAjax = StAjax;
});

define("core/shopify-app/st-modules/_di-container/st.module.interface", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/_di-container/di.container.public", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, dom_loaded_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.DiContainerPublic = void 0;
    var DiContainerPublic = function() {
        function DiContainerPublic() {
            this.className = "DI";
            this.subscribeDOMLoaded = function(cb) {
                dom_loaded_1.StDOMLoaded.Instance().subscribeDOMLoaded(cb);
            };
            this.init = function() {};
            this.setup = function() {};
        }
        return DiContainerPublic;
    }();
    exports.DiContainerPublic = DiContainerPublic;
});

define("core/shopify-app/st-modules/_di-container/st.module", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/ajax", "core/shopify-app/st-modules/_static/static", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, ajax_1, static_1, dom_loaded_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StModule = void 0;
    var StModule = function() {
        function StModule(args) {
            var _this = this;
            this.dependency = [];
            this.init = function() {};
            this.setup = function() {
                if (!_this.setupFlag) {
                    if (_this.hasOwnProperty("init")) {
                        if(window.stLog()) {
                            console.log("Init : ", _this.className);
                        }
                        _this.setupFlag = true;
                        _this.init();
                        _this.dependency.forEach(function(dependency) {
                            dependency.setup();
                        });
                    }
                }
            };
            this.dependency = args && args.length > 0 ? __spreadArray([], args, true) : [];
            this.Static = static_1.StStatic.Instance();
            this.endpoint = this.Static.obtainStaticEndpoints();
            this.cart = this.Static.obtainCart();
            this.ajax = ajax_1.StAjax.Instance();
            this.subscribeDOMLoaded = dom_loaded_2.StDOMLoaded.Instance().subscribeDOMLoaded;
            this.setupFlag = false;
        }
        return StModule;
    }();
    exports.StModule = StModule;
});

define("core/shopify-app/st-modules/_di-container/di.container.setup", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, dom_loaded_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDIContainerSetup = void 0;
    var StDIContainerSetup = function() {
        function StDIContainerSetup(appName, StAppDIConfig) {
            var _this = this;
            this.className = "DI";
            this.getModules = function(appName) {
                return _this.StAppDIConfig.Instance.hierarchy(appName);
            };
            if (!window.stApp) window.stApp = {};
            this.StAppDIConfig = StAppDIConfig;
            this.init(appName);
        }
        StDIContainerSetup.prototype.init = function(appName) {
            document.querySelector("body").classList.add("st_app-".concat(appName));
            this.mainServices = this.getModules(appName);
            this.mainServices.forEach(function(service) {
                if (service.className) {
                    window.stApp[service.className] = service;
                    service.setup();
                } else {
                    console.error("Instance has no className: ", service);
                }
            });
            dom_loaded_3.StDOMLoaded.Instance().initDOMLoaded();
        };
        return StDIContainerSetup;
    }();
    exports.StDIContainerSetup = StDIContainerSetup;
});

define("core/shopify-app/st-modules/_general-methods/cookies/cookies", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCookies = void 0;
    var StCookies = function(_super) {
        __extends(StCookies, _super);
        function StCookies() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Cookies";
            _this_1.init = function() {
                var _this = _this_1;
                _this_1.subscribeDOMLoaded(function() {
                    _this.initCookieApi();
                    _this.onPrivacyBannerAction();
                });
            };
            _this_1.initCookieApi = function() {
                var wShopify = window.Shopify;
                if (!!wShopify) {
                    wShopify.loadFeatures([ {
                        name: "consent-tracking-api",
                        version: "0.1"
                    } ], function(error) {
                        if (error) {
                            throw error;
                        }
                        _this_1.showPrivacyBanner();
                    });
                }
            };
            _this_1.showPrivacyBanner = function() {
                var wShopify = window.Shopify;
                var shouldShowBanner = wShopify.customerPrivacy.shouldShowGDPRBanner();
                var banner = document.querySelector(".st_privacy-bar_JS");
                if (!!banner && shouldShowBanner) {
                    banner.removeAttribute("hidden");
                }
            };
            _this_1.hidePrivacyBanner = function() {
                var banner = document.querySelector(".st_privacy-bar_JS");
                if (!!banner) {
                    banner.setAttribute("hidden", "");
                }
            };
            _this_1.onPrivacyBannerAction = function() {
                var _this = _this_1;
                var privacyBannerBtnList = document.querySelectorAll(".st_privacy-banner-btn_JS");
                if ((privacyBannerBtnList === null || privacyBannerBtnList === void 0 ? void 0 : privacyBannerBtnList.length) > 0) {
                    privacyBannerBtnList.forEach(function(btn) {
                        btn.addEventListener("click", function() {
                            var btnDataAction = btn.getAttribute("data-action");
                            var wShopify = window === null || window === void 0 ? void 0 : window.Shopify;
                            wShopify.customerPrivacy.setTrackingConsent(btnDataAction === "accept", _this.hidePrivacyBanner);
                        });
                    });
                }
            };
            _this_1.getCookie = function(cookieKey) {
                return window.localStorage.getItem(cookieKey);
            };
            _this_1.setCookies = function(cookieKey, cookieValue) {
                window.localStorage.setItem(cookieKey, cookieValue);
            };
            _this_1.clearCookie = function(cookieKey) {
                window.localStorage.removeItem(cookieKey);
            };
            _this_1.clearAllCookie = function() {
                window.localStorage.clear();
            };
            return _this_1;
        }
        return StCookies;
    }(st_module_1.StModule);
    exports.StCookies = StCookies;
});

define("_features.config", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.restrictedStateList = exports.stateList = exports.replacementItemVariantId = exports.irreplaceableItemsOnEnrollment = exports.enrollmentKit3Skus = exports.enrollmentKit2Skus = exports.enrollmentKit1Skus = exports.enrollmentFeeSku = exports.sc_shareCartItemsPerPage = exports.sc_OpenCartDrawerUrlParam = exports.sc_lineItemTagNotAvailableForShareCart = exports.sc_isEditCartEnabled = exports.sc_isPromoCodeEnabled = exports.sc_isLinkShorteningEnabled = exports.sc_isNameEnabled = exports.sc_isShareCartEnabled = exports.sc_tokenURLKey = exports.shopifyCustomerIdPrefix = exports.refLinkMetafield = exports.referralLinkLength = exports.rechargeCreditAjustmentNote = exports.rechargeCreditAjustmentType = exports.firstOrderTag = exports.sc_referralItemsPerPage = exports.referralCreditsAmount = exports.useCommissionEngineIdInRewardCode = exports.rewardItemCollectionId = exports.rewardDiscountMinimum = exports.rewardCodePrefix = exports.rewardAmount = exports.rewardType = exports.discountUsageLimit = exports.discountCollectionSpend = exports.discountMinimumRequirement = exports.discountSegmentConditionTag = exports.discountNamePrefix = exports.discountAmount = exports.discountType = exports.enrollmentParams = exports.reasonForRefundWhenReturnMoney = exports.sponsorGenealogyTimeout = exports.searchSponsorsMinNumOfResult = exports.searchSponsorsFetchAttemptsLimit = exports.representative = exports.commissionEngine = exports.autoshipItems = exports.productVolumesConfig = exports.EProductPriceType = exports.ECustomerType = exports.defaultCorporationImage = exports.shareRefCodeFunctionality = exports.availableRechargeUsage = exports.downgradeRepresentativeByDesignWebhook = exports.cronJobReSyncOrders = exports.repDiscountWithPromoCode = exports.additionalRepInfo = exports.activeLastSponsorFeature = exports.canGoUnderCorporateSite = exports.lockedRepresentativeSite = exports.corporationName = exports.refQueryParam = exports.aliasQueryParam = exports.defaultWebAlias = void 0;
    exports.defaultWebAlias = "";
    exports.aliasQueryParam = "u";
    exports.refQueryParam = "cref";
    exports.corporationName = "Scout and Cellar";
    exports.lockedRepresentativeSite = false;
    exports.canGoUnderCorporateSite = true;
    exports.activeLastSponsorFeature = true;
    exports.additionalRepInfo = true;
    exports.repDiscountWithPromoCode = false;
    exports.cronJobReSyncOrders = false;
    exports.downgradeRepresentativeByDesignWebhook = false;
    exports.availableRechargeUsage = true;
    exports.shareRefCodeFunctionality = true;
    exports.defaultCorporationImage = "";
    var ECustomerType;
    (function(ECustomerType) {
        ECustomerType["retail"] = "Retail";
        ECustomerType["representative"] = "consultant";
        ECustomerType["guest"] = "guest";
        ECustomerType["noType"] = "";
    })(ECustomerType = exports.ECustomerType || (exports.ECustomerType = {}));
    var EProductPriceType;
    (function(EProductPriceType) {
        EProductPriceType["retail"] = "retail";
        EProductPriceType["representative"] = "representative";
        EProductPriceType["noSpecificType"] = "";
    })(EProductPriceType = exports.EProductPriceType || (exports.EProductPriceType = {}));
    exports.productVolumesConfig = {
        cv: true,
        qv: true,
        bv: false,
        cvMetafieldKey: "cvolume",
        qvMetafieldKey: "qvolume",
        bvMetafieldKey: "bvolume",
        Volume: "cv",
        Volume2: "qv",
        Volume3: "bv",
        calculatePriceAsVolume: false,
        generalPriceVolumePercentage: 1,
        retailVolumeAndPricePercentage: 1,
        representativeVolumeAndPricePercentage: 1
    };
    exports.autoshipItems = [ "AUTOSHIP-1", "AUTOSHIP-2", "consultant-kit", "enrollment-bundle" ];
    exports.commissionEngine = "GoAffPro";
    exports.representative = "representative";
    exports.searchSponsorsFetchAttemptsLimit = 3;
    exports.searchSponsorsMinNumOfResult = 3;
    exports.sponsorGenealogyTimeout = 6e5;
    exports.reasonForRefundWhenReturnMoney = "refundmoney";
    exports.enrollmentParams = [ "SSN", "dateOfBirth", "day", "email", "firstName", "lastName", "month", "optionalKitRecurring", "optionalKits", "phoneNumber", "requiredKitRecurring", "requiredKits", "shopifyId", "sponsorWebAlias", "sponsorsWebAlias", "webAlias", "year" ];
    exports.discountType = "fixed_amount";
    exports.discountAmount = 10;
    exports.discountNamePrefix = "Core_";
    exports.discountSegmentConditionTag = "no_order";
    exports.discountMinimumRequirement = "1.00";
    exports.discountCollectionSpend = 405622423800;
    exports.discountUsageLimit = 10;
    exports.rewardType = "fixed_amount";
    exports.rewardAmount = 20;
    exports.rewardCodePrefix = "RewardedFrom-";
    exports.rewardDiscountMinimum = 1;
    exports.rewardItemCollectionId = 405622423800;
    exports.useCommissionEngineIdInRewardCode = true;
    exports.referralCreditsAmount = 25;
    exports.sc_referralItemsPerPage = 10;
    exports.firstOrderTag = "newCustomer";
    exports.rechargeCreditAjustmentType = {
        add: "credit",
        subtract: "debit"
    };
    exports.rechargeCreditAjustmentNote = "Referral reward";
    exports.referralLinkLength = 10;
    exports.refLinkMetafield = {
        key: "refLink",
        namespace: "shapetech"
    };
    exports.shopifyCustomerIdPrefix = "gid://shopify/Customer/";
    exports.sc_tokenURLKey = "shareCartToken";
    exports.sc_isShareCartEnabled = false;
    exports.sc_isNameEnabled = true;
    exports.sc_isLinkShorteningEnabled = true;
    exports.sc_isPromoCodeEnabled = true;
    exports.sc_isEditCartEnabled = false;
    exports.sc_lineItemTagNotAvailableForShareCart = "no-shared-cart";
    exports.sc_OpenCartDrawerUrlParam = "openCartDrawer";
    exports.sc_shareCartItemsPerPage = 10;
    exports.enrollmentFeeSku = "SC25Q3CONSULTANTFEE";
    exports.enrollmentKit1Skus = [ "SC25Q3CONSULTANTFEE", "SC25Q3CJMIX-4BTL", "SCM10025-FILLED" ];
    exports.enrollmentKit2Skus = [ "SC25Q3CONSULTANTFEE", "SC25Q3CJMIX-4BTL", "SC25Q3CJMIX-2BTL", "SCM10025-FILLED" ];
    exports.enrollmentKit3Skus = [ "SC25Q3CONSULTANTFEE", "SC25Q3CJMIX-4BTL", "SC25Q3CJMIX-2BTL", "SC25Q3CJMIX-6BTL", "SCM10025-FILLED" ];
    exports.irreplaceableItemsOnEnrollment = [ 42289430790249, 42273617838185 ];
    exports.replacementItemVariantId = 42301613768809;
    exports.stateList = [ "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming" ];
    exports.restrictedStateList = [ "Delaware", "Rhode Island", "Utah" ];
});

define("core/shopify-app/st-modules/_general-methods/form/customer-type", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_2, _features_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCustomerType = void 0;
    var StCustomerType = function(_super) {
        __extends(StCustomerType, _super);
        function StCustomerType() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "CustomerType";
            _this.init = function() {};
            _this.get = function() {
                var customerType;
                if (!!window.customerInfoMetafields.customerType) {
                    customerType = window.customerInfoMetafields.customerType;
                } else {
                    customerType = _features_config_1.ECustomerType.guest;
                }
                return customerType;
            };
            return _this;
        }
        return StCustomerType;
    }(st_module_2.StModule);
    exports.StCustomerType = StCustomerType;
});

define("core/shopify-app/st-modules/_general-methods/object-formatting", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StObjectFormatting = void 0;
    var StObjectFormatting = function(_super) {
        __extends(StObjectFormatting, _super);
        function StObjectFormatting() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ObjectFormatting";
            _this.convertObjectToQueryString = function(object) {
                var string = "", i = 0;
                for (var j in object) {
                    var s = encodeURIComponent(j) + "=" + encodeURIComponent(object[j]);
                    string += i > 0 ? "&" + s : s;
                    i++;
                }
                return "?" + string;
            };
            _this.convertQueryStringToObject = function(query) {
                query = typeof query != "string" ? "" : query.substr(query.indexOf("?") + 1);
                var query_string = {};
                if (query !== "") {
                    var vars = query.split("&");
                    for (var i = 0; i < vars.length; i++) {
                        var pair = vars[i].split("=");
                        var key = decodeURIComponent(pair[0]);
                        var value = decodeURIComponent(pair[1]);
                        if (typeof query_string[key] === "undefined") {
                            query_string[key] = decodeURIComponent(value);
                        } else if (typeof query_string[key] === "string") {
                            query_string[key] = [ query_string[key], decodeURIComponent(value) ];
                        } else {
                            query_string[key].push(decodeURIComponent(value));
                        }
                    }
                } else {
                    console.warn("Invalid query string supplied to convertQueryStringToObject.");
                }
                return query_string;
            };
            _this.ajax.setupFormatting(_this.convertObjectToQueryString);
            return _this;
        }
        return StObjectFormatting;
    }(st_module_3.StModule);
    exports.StObjectFormatting = StObjectFormatting;
});

define("core/shopify-app/st-modules/_general-methods/browser-history", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StBrowserHistory = void 0;
    var StBrowserHistory = function(_super) {
        __extends(StBrowserHistory, _super);
        function StBrowserHistory(objectFormatting) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "BrowserHistory";
            _this.pushHistory = function(rootURL, urlParams) {
                var serializedUrlParams = _this.objectFormatting.convertObjectToQueryString(urlParams);
                window.history.replaceState(urlParams, "", rootURL + serializedUrlParams);
            };
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        return StBrowserHistory;
    }(st_module_4.StModule);
    exports.StBrowserHistory = StBrowserHistory;
});

define("core/connector-app/_shared/models/webalias/webalias.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/_general-methods/general-methods", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGeneralMethods = void 0;
    var StGeneralMethods = function(_super) {
        __extends(StGeneralMethods, _super);
        function StGeneralMethods() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "GeneralMethods";
            _this.scrollTo = function(element, duration, offset) {
                if (offset === void 0) {
                    offset = 150;
                }
                var startingY = window.scrollY;
                var elementY = window.scrollY + element.getBoundingClientRect().top - offset;
                var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
                var diff = targetY - startingY;
                var easing = function(t) {
                    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
                };
                var start;
                if (!diff) return;
                window.requestAnimationFrame(function step(timestamp) {
                    if (!start) start = timestamp;
                    var time = timestamp - start;
                    var percent = Math.min(time / duration, 1);
                    percent = easing(percent);
                    window.scrollTo(0, startingY + diff * percent);
                    if (time < duration) {
                        window.requestAnimationFrame(step);
                    }
                });
            };
            return _this;
        }
        StGeneralMethods.prototype.getClosestByClass = function(el, cls) {
            var res = el;
            while ((res = res.parentElement) && !res.classList.contains(cls));
            return res;
        };
        StGeneralMethods.prototype.getClosestByTag = function(el, tagName) {
            var res = el;
            while ((res = res.parentElement) && !res.tagName === tagName);
            return res;
        };
        return StGeneralMethods;
    }(st_module_5.StModule);
    exports.StGeneralMethods = StGeneralMethods;
});

define("core/shopify-app/st-modules/webalias/webalias-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAliasClassConfig = void 0;
    var StWebAliasClassConfig = function(_super) {
        __extends(StWebAliasClassConfig, _super);
        function StWebAliasClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StWebAliasClassConfig";
            _this.classNameRepId = "st_representative-id_JS";
            _this.selectorRepId = "." + _this.classNameRepId;
            _this.classNameRepAlias = "st_representative-alias_JS";
            _this.selectorRepAlias = "." + _this.classNameRepAlias;
            _this.classNameRepFullName = "st_representative-fullname_JS";
            _this.selectorRepFullName = "." + _this.classNameRepFullName;
            _this.classNameRepInitials = "st_representative-initials_JS";
            _this.selectorRepInitials = "." + _this.classNameRepInitials;
            _this.classNameRepSite = "st_representative-site_JS";
            _this.selectorRepSite = "." + _this.classNameRepSite;
            _this.classNameRepBio = "st_representative-site-bio_JS";
            _this.selectorRepBio = "." + _this.classNameRepBio;
            _this.classNameRepAddress = "st_representative-address_JS";
            _this.selectorRepAddress = "." + _this.classNameRepAddress;
            _this.classNameNonSponsor = "st_non-sponsor_JS";
            _this.selectorNonSponsor = "." + _this.classNameNonSponsor;
            _this.classRepresentativeBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepresentativeBannerWrapper = "." + _this.classRepresentativeBannerWrapper;
            _this.classNameBusinessContentRepName = "st_account-business--rep-name_JS";
            _this.selectorBusinessContentRepName = "." + _this.classNameBusinessContentRepName;
            _this.classNamePersonalInfoForm = "st_personal-info-form_JS";
            _this.selectorPersonalInfoForm = "." + _this.classNamePersonalInfoForm;
            _this.classNamePersonalInfoRepFullName = "st_representative-info-fullname_JS";
            _this.selectorPersonalInfoRepFullName = "." + _this.classNamePersonalInfoRepFullName;
            return _this;
        }
        return StWebAliasClassConfig;
    }(st_module_6.StModule);
    exports.StWebAliasClassConfig = StWebAliasClassConfig;
});

define("core/shopify-app/st-modules/webalias/inject-representative-info", [ "require", "exports", "_features.config", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, _features_config_2, st_module_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInjectRepresentativeInfo = void 0;
    var StInjectRepresentativeInfo = function(_super) {
        __extends(StInjectRepresentativeInfo, _super);
        function StInjectRepresentativeInfo(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "InjectRepresentativeInfo";
            _this.injectToFields = function(repInfo) {
                var repId = repInfo.repId, webAlias = repInfo.webAlias, firstName = repInfo.firstName, lastName = repInfo.lastName, imageUrl = repInfo.imageUrl;
                if (!!repId) {
                    _this.appendIdToField(repInfo.repId);
                }
                if (!!webAlias) {
                    _this.appendAlsToField(webAlias);
                    _this.appendRepSiteUrlToField(webAlias);
                }
                if (!!firstName || !!lastName) {
                    _this.appendRepFullNameToField(firstName, lastName, webAlias);
                }
                if (!!imageUrl && _features_config_2.additionalRepInfo) {
                    _this.appendRepBioToField(imageUrl);
                }
            };
            _this.injectSponsorInfoToField = function(firstName, lastName) {
                var repNameSelector = document.querySelector(_this.classConfig.selectorBusinessContentRepName);
                if (!!repNameSelector) {
                    repNameSelector.innerHTML = firstName + " " + lastName;
                }
                var personalInformationRep = document.querySelector(_this.classConfig.selectorPersonalInfoRepFullName);
                if (!!personalInformationRep) {
                    personalInformationRep.value = firstName + " " + lastName;
                }
            };
            _this.appendIdToField = function(id) {
                var repAliasFields = document.querySelectorAll(_this.classConfig.selectorRepId);
                if (repAliasFields.length > 0) {
                    _this.appendValueToFields(repAliasFields, id);
                }
            };
            _this.appendAlsToField = function(alias) {
                var repAliasFields = document.querySelectorAll(_this.classConfig.selectorRepAlias);
                if (repAliasFields.length > 0) {
                    _this.appendValueToFields(repAliasFields, alias);
                }
            };
            _this.appendRepSiteUrlToField = function(alias) {
                var repSiteFields = document.querySelectorAll(_this.classConfig.selectorRepSite);
                var repSite = window.location.origin + "/?u=" + alias;
                if (repSiteFields.length > 0) {
                    _this.appendValueToFields(repSiteFields, repSite);
                }
            };
            _this.appendRepFullNameToField = function(repFirstName, repLastName, webAlias) {
                var repFullNameFields = document.querySelectorAll(_this.classConfig.selectorRepFullName);
                var fullName = _this.getFullName(repFirstName, repLastName, webAlias);
                if (repFullNameFields.length > 0) {
                    _this.appendValueToFields(repFullNameFields, fullName);
                }
            };
            _this.appendRepBioToField = function(imageUrl) {
                var repImages = document.querySelectorAll(_this.classConfig.selectorRepBio);
                var imageString = 'BIO: <img class="" style="width: 50px; height: auto;" alt="representatve image" src="' + imageUrl + '">';
                if (repImages.length > 0) {
                    repImages.forEach(function(field) {
                        return field.innerHTML = imageString;
                    });
                }
            };
            _this.getFullName = function(repFirstName, repLastName, webAlias) {
                var fullName = "";
                if (!!repFirstName) {
                    fullName = repFirstName;
                    if (!!repLastName) {
                        fullName += " " + repLastName;
                    }
                }
                if (webAlias === _features_config_2.defaultWebAlias) {
                    fullName = _features_config_2.corporationName;
                }
                return fullName;
            };
            _this.appendValueToFields = function(fields, value) {
                fields.forEach(function(field) {
                    if (field.tagName.toLowerCase() === "input") {
                        field.value = value;
                    } else if (field.tagName.toLowerCase() === "a") {
                        field.setAttribute("href", value);
                    } else {
                        field.innerHTML = value;
                    }
                });
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StInjectRepresentativeInfo;
    }(st_module_7.StModule);
    exports.StInjectRepresentativeInfo = StInjectRepresentativeInfo;
});

define("core/shopify-app/st-modules/cart/cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_8) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCart = void 0;
    var StCart = function(_super) {
        __extends(StCart, _super);
        function StCart() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Cart";
            _this_1.reloadSubscriber = [];
            _this_1.cartInterceptorEndpoints = [ "/cart/add.js", "/cart/update.js", "/cart/change.js", "/cart/clear.js", "/wallets/checkouts/" ];
            _this_1.shopifyCartApiEndpoints = {
                "get-cart": "/cart.js",
                "add-to-cart": "/cart/add.js",
                "clear-cart": "/cart/clear.js",
                "change-cart": "/cart/change.js",
                "update-cart": "/cart/update.js"
            };
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    //_this_1.initCartSetup();
                    //_this_1.cartFetchInterceptorInit();
                });
            };
            // _this_1.cartFetchInterceptorInit = function() {
            //     var originalFetch = window.fetch;
            //     window.fetch = function() {
            //         console.log(`doing fetch with override and arguments ${JSON.stringify(arguments)}`);
            //         var args = [];
            //         for (var _i = 0; _i < arguments.length; _i++) {
            //             args[_i] = arguments[_i];
            //         }
            //         return __awaiter(_this_1, void 0, void 0, function() {
            //             var resource, config, response;
            //             return __generator(this, function(_a) {
            //                 switch (_a.label) {
            //                   case 0:
            //                     resource = args[0], config = args[1];
            //                     return [ 4, originalFetch(resource, config) ];

            //                   case 1:
            //                     response = _a.sent();
            //                     if (this.isCartChangeRequest(response.url)) {
            //                         this.getCart(this.handleChangeCartInterceptor);
            //                     }
            //                     if (this.isGetCartRequest(response.url)) {}
            //                     return [ 2, response ];
            //                 }
            //             });
            //         });
            //     };
            // };
            _this_1.handleChangeCartInterceptor = function(cartObj) {

                try {
                    _this_1.setShopifyCartData(cartObj);
                    _this_1.fireAllCallbacks(cartObj);
                } catch (err) {
                    console.log("handleChangeCartInterceptor ---\x3e Error:", err);
                }
            };
            _this_1.initCartSetup = function() {
                _this_1.getCart(function(cartObj) {
                    _this_1.setShopifyCartData(cartObj);
                });
            };
            _this_1.fireAllCallbacks = function(cartObject) {
                _this_1.fireChangeCartCallbacks(cartObject);
                setTimeout(function() {
                    _this_1.fireRenderCartCallbacks();
                }, 1e3);
            };
            _this_1.subscribeChangeCart = function(callback) {
                _this_1.subCallbacks.push(callback);
            };
            _this_1.fireChangeCartCallbacks = function(cartObject) {
                if (_this_1.subCallbacks.length > 0) {
                    _this_1.subCallbacks.forEach(function(callback) {
                        callback(cartObject);
                    });
                }
            };
            _this_1.subscribeRenderCart = function(callback) {
                _this_1.subRenderCartCallbacks.push(callback);
            };
            _this_1.fireRenderCartCallbacks = function() {
                if (_this_1.subRenderCartCallbacks.length > 0) {
                    _this_1.subRenderCartCallbacks.forEach(function(callback) {
                        callback();
                    });
                }
            };
            _this_1.matchUrlSnippet = function(url, urlSnippetArr) {
                for (var i = 0; i < urlSnippetArr.length; i++) {
                    if (url.includes(urlSnippetArr[i])) {
                        return true;
                    }
                }
                return false;
            };
            _this_1.isGetCartRequest = function(url) {
                return url.endsWith("/cart.json");
            };
            _this_1.isCartChangeRequest = function(url) {
                return _this_1.matchUrlSnippet(url, _this_1.cartInterceptorEndpoints);
            };
            _this_1.setShopifyCartData = function(cartObj) {
                window.shopifyCartData = cartObj;
                _this_1.setCartInfo(cartObj);
            };
            _this_1.handleChangeCartResponseGeneric = function(res, handleFunc, cartRefresh) {
                if (handleFunc === void 0) {
                    handleFunc = function() {};
                }
                if (cartRefresh === void 0) {
                    cartRefresh = true;
                }
                try {
                    var cartRes_1 = JSON.parse(res.response);
                    _this_1.getCart(function(cartObj) {
                        _this_1.setShopifyCartData(cartObj);
                        if (cartRefresh) {
                            _this_1.requestCartRefresh(cartObj);
                        }
                        _this_1.fireAllCallbacks(cartObj);
                        handleFunc(cartRes_1);
                    });
                } catch (err) {
                    console.log("handleChangeCartResponseGeneric ---\x3e Error: ", err);
                }
            };
            _this_1.getCart = function(responseHandle) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["get-cart"],
                        method: "GET",
                        contentType: "json",
                        callback: function(res) {
                            try {
                                var cartObj = JSON.parse(res.response);
                                responseHandle(cartObj);
                            } catch (err) {
                                console.log("Cart Api Error: ", err);
                            }
                        }
                    });
                } catch (err) {
                    console.log("Get Cart ---\x3e Error:", err);
                }
            };
            _this_1.clearCart = function(responseHandle) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["clear-cart"],
                        method: "POST",
                        contentType: "json",
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Clear Cart ---\x3e Error:", err);
                }
            };
            _this_1.changeCart = function(changeData, responseHandle, cartRefresh) {
                if (cartRefresh === void 0) {
                    cartRefresh = true;
                }
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["change-cart"],
                        method: "POST",
                        contentType: "json",
                        data: changeData,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle, cartRefresh);
                        }
                    });
                } catch (err) {
                    console.log("Change Cart ---\x3e Error:", err);
                }
            };
            _this_1.updateCart = function(updateData, responseHandle) {
                try {
                    var data = Array.isArray(updateData) ? {
                        updates: updateData
                    } : updateData;
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["update-cart"],
                        method: "POST",
                        contentType: "json",
                        data: data,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Update Cart ---\x3e Error:", err);
                }
            };
            _this_1.addCart = function(addData, responseHandle) {
                try {
                    var data = Array.isArray(addData) ? {
                        items: addData
                    } : addData;
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["add-to-cart"],
                        method: "POST",
                        contentType: "json",
                        data: data,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Add To Cart ---\x3e Error:", err);
                }
            };
            _this_1.requestCartRefresh = function(cart) {
                var isCartPage = location.pathname === "/cart";
                if (isCartPage) {
                    var _this_2 = _this_1;
                    var refreshIndex_1 = _this_1.subscribeCartReload();
                    setTimeout(function() {
                        _this_2.triggerCartReload(refreshIndex_1);
                    }, 500);
                }
                if (!isCartPage) {
                    _this_1.ajax.send({
                        endpoint: "".concat(window.Shopify.routes.root, "?section_id=cart-drawer"),
                        method: "GET",
                        callback: function(request) {
                            var cartDrawerTemplate = request.responseText;
                            _this_1.ajax.send({
                                endpoint: "".concat(window.Shopify.routes.root, "?section_id=variant-added"),
                                method: "GET",
                                callback: function(request) {
                                    var variantAddedTemplate = request.responseText;
                                    _this_1.triggerCartRefresh(cart, {
                                        "cart-drawer": cartDrawerTemplate,
                                        "variant-added": variantAddedTemplate
                                    });
                                }
                            });
                        }
                    });
                }
            };
            _this_1.triggerCartRefresh = function(cart, sections) {
                var addEvt = new CustomEvent("variant:add");
                var cartRefreshEvt = new CustomEvent("cart:refresh");
                var totalQuantity = cart.items.reduce(function(acc, item) {
                    return acc + item.quantity;
                }, 0);
                var cartChangeEvt = new CustomEvent("cart:change", {
                    detail: {
                        cart: __assign(__assign({}, cart), {
                            item_count: totalQuantity,
                            sections: sections
                        })
                    }
                });
                document.dispatchEvent(cartChangeEvt);
                document.dispatchEvent(cartRefreshEvt);
                document.dispatchEvent(addEvt);
            };
            _this_1.setCartInfo = function(shopifyCart) {
                _this_1.cart = __assign(__assign({}, _this_1.cart), shopifyCart);
            };
            _this_1.updateCartItemsProperies = function(alias) {
                _this_1.getCart(function(cartResponse) {
                    var attributes = cartResponse.attributes;
                    attributes = __assign(__assign({}, attributes), {
                        sponsorWebAlias: !!alias ? alias : ""
                    });
                    var updateAttributes = {
                        attributes: attributes
                    };
                    _this_1.updateCartAttributesOrNote(updateAttributes, function(cartRes) {
                        var items = cartRes.items;
                        _this_1.processCartItemsRecursive(items, 0, alias);
                    });
                });
            };
            _this_1.updateCartAttributesOrNote = function(updateData, responseHandle) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["update-cart"],
                        method: "POST",
                        contentType: "json",
                        data: updateData,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGenericNoRefresh(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Update Cart ---\x3e Error:", err);
                }
            };
            _this_1.processCartItemsRecursive = function(cartItems, index, alias) {
                if (index < cartItems.length) {
                    var item = cartItems[index];
                    var propertiesData = item.properties;
                    if (propertiesData._sponsorWebAlias !== alias) {
                        propertiesData = __assign(__assign({}, propertiesData), {
                            _sponsorWebAlias: !!alias ? alias : ""
                        });
                        var updateData = {
                            id: "" + item.key,
                            quantity: item.quantity,
                            properties: propertiesData
                        };
                        _this_1.changeCart(updateData, function(cartRes) {
                            _this_1.processCartItemsRecursive(cartRes.items, index + 1, alias);
                        }, false);
                    } else {
                        _this_1.processCartItemsRecursive(cartItems, index + 1, alias);
                    }
                }
            };
            _this_1.handleChangeCartResponseGenericNoRefresh = function(res, handleFunc) {
                try {
                    var cartRes = JSON.parse(res.response);
                    handleFunc(cartRes);
                    _this_1.getCart(function(cartObj) {
                        _this_1.setShopifyCartData(cartObj);
                        _this_1.handleChangeCartInterceptor(cartObj);
                    });
                } catch (err) {
                    console.log("handleChangeCartResponseGenericNoRefresh ---\x3e Error: ", err);
                }
            };
            _this_1.subscribeCartReload = function() {
                _this_1.reloadSubscriber.push(false);
                return _this_1.reloadSubscriber.length - 1;
            };
            _this_1.triggerCartReload = function(index) {
                var shouldRefresh = true;
                _this_1.reloadSubscriber[index] = true;
                for (var i = 0; i < _this_1.reloadSubscriber.length; i++) {
                    if (_this_1.reloadSubscriber[i] === false) {
                        shouldRefresh = false;
                        break;
                    }
                }
                if (shouldRefresh) window.location.reload();
            };
            _this_1.subCallbacks = [];
            _this_1.subRenderCartCallbacks = [];
            return _this_1;
        }
        Object.defineProperty(StCart.prototype, "getShopifyCartData", {
            get: function() {
                return window.shopifyCartData;
            },
            enumerable: false,
            configurable: true
        });
        return StCart;
    }(st_module_8.StModule);
    exports.StCart = StCart;
});

define("core/shopify-app/st-modules/search-sponsor/sponsor-search-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_9) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorClassConfig = void 0;
    var StSearchSponsorClassConfig = function(_super) {
        __extends(StSearchSponsorClassConfig, _super);
        function StSearchSponsorClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorClassConfig";
            _this.classNameSponsorId = "st_sponsor-id_JS";
            _this.selectorSponsorId = "." + _this.classNameSponsorId;
            _this.classNameSponsorAlias = "st_sponsor-alias_JS";
            _this.selectorSponsorAlias = "." + _this.classNameSponsorAlias;
            _this.classNameSponsorFullName = "st_sponsor-fullname_JS";
            _this.selectorSponsorFullName = "." + _this.classNameSponsorFullName;
            _this.classNameSponsorInitials = "st_sponsor-initials_JS";
            _this.selectorSponsorInitials = "." + _this.classNameSponsorInitials;
            _this.classNameSponsorAddress = "st_sponsor-address_JS";
            _this.selectorSponsorAddress = "." + _this.classNameSponsorAddress;
            _this.classNameSearchSponsorWrapperPage = "st_search-sponsor--wrapper_JS";
            _this.selectorSearchSponsorWrapperPage = "." + _this.classNameSearchSponsorWrapperPage;
            _this.classNameInputBoxPage = "st_search-sponsor--by-id_JS";
            _this.selectorInputBoxPage = "." + _this.classNameInputBoxPage;
            _this.classNameChangeSponsorWrapperlink = "st_change-sponsor--wrapper_JS";
            _this.selectorChangeSponsorWrapperLink = "." + _this.classNameChangeSponsorWrapperlink;
            _this.classNameChangeSponsorWrapper = "st_change-sponsor_JS";
            _this.selectorChangeSponsorWrapper = "." + _this.classNameChangeSponsorWrapper;
            _this.classNameSearchInput = "st_search-input_JS";
            _this.selectorSearchInput = "." + _this.classNameSearchInput;
            _this.classNameNonSponsor = "st_non-sponsor_JS";
            _this.selectorNonSponsor = "." + _this.classNameNonSponsor;
            _this.classNameChooseSponsor = "st_choose-sponsor_JS";
            _this.selectorChooseSponsor = "." + _this.classNameChooseSponsor;
            _this.classNameSearchResult = "st_search-result_JS";
            _this.selectorSearchResult = "." + _this.classNameSearchResult;
            _this.classNameRepresentativeAlias = "st_representative-alias_JS";
            _this.selectorRepresentativeAlias = "." + _this.classNameRepresentativeAlias;
            _this.classNameRepresentativeFullName = "st_representative-fullname_JS";
            _this.selectorRepresentativeFullName = "." + _this.classNameRepresentativeFullName;
            _this.classNameSponsorData = "st_sponsor-data_JS";
            _this.selectorSponsorData = "." + _this.classNameSponsorData;
            _this.classNameSearchSponsor = "st_search-sponsors_JS";
            _this.selectorSearchSponsor = "." + _this.classNameSearchSponsor;
            _this.classNameFoundSponsor = "st_found-sponsors_JS";
            _this.selectorFoundSponsor = "." + _this.classNameFoundSponsor;
            _this.classNameSearchSponsorBy = "st_search-sponsor-by_JS";
            _this.selectorSearchSponsorBy = "." + _this.classNameSearchSponsorBy;
            _this.classNameRadioText = "st_radio-text";
            _this.selectorRadioText = "." + _this.classNameRadioText;
            _this.classRepresentativeBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepresentativeBannerWrapper = "." + _this.classRepresentativeBannerWrapper;
            return _this;
        }
        return StSearchSponsorClassConfig;
    }(st_module_9.StModule);
    exports.StSearchSponsorClassConfig = StSearchSponsorClassConfig;
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor-guard", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_10, _features_config_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorGuard = void 0;
    var StSearchSponsorGuard = function(_super) {
        __extends(StSearchSponsorGuard, _super);
        function StSearchSponsorGuard(classConfig, browserHistory, objectFormatting, generalMethods, cartComponent) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorGuard";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.listenForSponsorChange();
                    _this.cartComponent.subscribeRenderCart(function() {
                        var u = _this.objectFormatting.convertQueryStringToObject(window.location.search)[_features_config_3.aliasQueryParam];
                        _this.toggleCantGoUnderCorporateSite(u === _features_config_3.defaultWebAlias);
                    });
                });
            };
            _this.toggleElementVisibility = function(element, hideElement) {
                if (hideElement) {
                    _this.hideElement(element);
                } else {
                    _this.showElement(element);
                }
            };
            _this.showElement = function(element) {
                if (_this.isElementHidden(element)) {
                    element.classList.remove("st_hidden");
                }
            };
            _this.hideElement = function(element) {
                if (!_this.isElementHidden(element)) {
                    element.classList.add("st_hidden");
                }
            };
            _this.isElementHidden = function(element) {
                return element.classList.contains("st_hidden");
            };
            _this.toggleShoppingWith = function(hideElement) {
                var banner = document.querySelector(_this.classConfig.selectorRepresentativeBannerWrapper);
                _this.toggleElementVisibility(banner, hideElement);
            };
            _this.disableNonSponsor = function() {
                var nonSponsorBtn = document.querySelector(_this.classConfig.selectorNonSponsor);
                nonSponsorBtn === null || nonSponsorBtn === void 0 ? void 0 : nonSponsorBtn.remove();
            };
            _this.toggleBuying = function(hideBuying) {
                _this.toggleCheckoutButtons(hideBuying);
                _this.togglePaymentButtons(hideBuying);
                _this.toggleSearchSponsor(hideBuying);
            };
            _this.toggleSearchSponsor = function(hideElement) {
                var searchSponsorWrappers = document.querySelectorAll(".st_search-sponsor--wrapper_JS");
                searchSponsorWrappers.forEach(function(searchSponsorWrapper) {
                    _this.toggleSearchSponsorInput(searchSponsorWrapper, !hideElement);
                    _this.toggleSearchSponsorResult(searchSponsorWrapper, hideElement);
                });
            };
            _this.toggleSearchSponsorResult = function(container, hideElement) {
                var searchSponsorResultWrapper = container.querySelector(".st_search-result_JS");
                if (!!searchSponsorResultWrapper) {
                    _this.toggleElementVisibility(searchSponsorResultWrapper, hideElement);
                }
            };
            _this.toggleSearchSponsorInput = function(container, hideElement) {
                var searchSponsorInputWrapper = container.querySelector(".st_search-input_JS");
                if (!!searchSponsorInputWrapper) {
                    _this.toggleElementVisibility(searchSponsorInputWrapper, hideElement);
                }
            };
            _this.toggleCheckoutButtons = function(hideElement) {
                var checkoutButtons = document.querySelectorAll('button[name="checkout"]');
                if (checkoutButtons.length > 0) {
                    checkoutButtons.forEach(function(btn) {
                        _this.toggleElementVisibility(btn, hideElement);
                    });
                }
            };
            _this.togglePaymentButtons = function(hideElement) {
                var paymentButtonsWrapper = document.querySelectorAll(".st_product-buy-now-wrapper_JS");
                if (paymentButtonsWrapper.length > 0) {
                    paymentButtonsWrapper.forEach(function(wrp) {
                        _this.toggleElementVisibility(wrp, hideElement);
                    });
                }
            };
            _this.toggleCantGoUnderCorporateSite = function(hideElements) {
                if (!_features_config_3.canGoUnderCorporateSite) {
                    _this.disableNonSponsor();
                    _this.toggleShoppingWith(hideElements);
                    _this.toggleBuying(hideElements);
                }
            };
            _this.listenForSponsorChange = function() {
                window.addEventListener("sponsorChange", function() {
                    var u = _this.objectFormatting.convertQueryStringToObject(window.location.search)[_features_config_3.aliasQueryParam];
                    _this.toggleCantGoUnderCorporateSite(u === _features_config_3.defaultWebAlias);
                });
            };
            _this.classConfig = classConfig;
            _this.browserHistory = browserHistory;
            _this.objectFormatting = objectFormatting;
            _this.generalMethods = generalMethods;
            _this.cartComponent = cartComponent;
            return _this;
        }
        return StSearchSponsorGuard;
    }(st_module_10.StModule);
    exports.StSearchSponsorGuard = StSearchSponsorGuard;
});

define("core/connector-app/_shared/models/customer/sponsor/customer.update.sponsor.request", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/connector-app/_shared/models/webalias/webalias.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/account/_general/account-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_11) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountClassConfig = void 0;
    var StAccountClassConfig = function(_super) {
        __extends(StAccountClassConfig, _super);
        function StAccountClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "AccountClassConfig";
            _this.classNameProvinceSelector = "st_province-selector_JS";
            _this.selectorProvinceSelector = "." + _this.classNameProvinceSelector;
            _this.classNameProvinceSource = "st_province-source_JS";
            _this.selectorProvinceSource = "." + _this.classNameProvinceSource;
            _this.classNameAccountPage = "st_account_JS";
            _this.selectorAccountPage = "." + _this.classNameAccountPage;
            _this.classNameAccountSection = "st_account-page--section_JS";
            _this.selectorAccountSection = "." + _this.classNameAccountSection;
            _this.classNameAccountContent = "st_account-page_JS";
            _this.selectorAccountContent = "." + _this.classNameAccountContent;
            _this.classNameAccountNavWrapper = "st_account-nav--wrapper_JS";
            _this.selectorAccountNavWrapper = "." + _this.classNameAccountNavWrapper;
            _this.classNameAccountNavHolder = "st_account-nav--holder_JS";
            _this.selectorAccountNavHolder = "." + _this.classNameAccountNavHolder;
            _this.classNameAccountNavHolderSingle = "st_account-nav--holder-single_JS";
            _this.selectorAccountNavHolderSingle = "." + _this.classNameAccountNavHolderSingle;
            _this.classNameAccountNavButton = "st_account-button_JS";
            _this.selectorAccountNavButton = "." + _this.classNameAccountNavButton;
            _this.classNameAccountIcon = "st_account--nav-icon_JS";
            _this.selectorAccountIcon = "." + _this.classNameAccountIcon;
            _this.classNameAccountCopyText = "st_copy-repsite_JS";
            _this.selectorAccountIconCopyText = "." + _this.classNameAccountCopyText;
            _this.classNameAccountCopyTextWrapper = "st_copy-repsite--wrapper_JS";
            _this.selectorAccountIconCopyTextWrapper = "." + _this.classNameAccountCopyTextWrapper;
            _this.classNameAccountLogout = "st_account-logout_JS";
            _this.selectorAccountLogout = "." + _this.classNameAccountLogout;
            _this.classNameAccountWebAlias = "st_input-wrapper_JS input";
            _this.selectorAccountWebAlias = "." + _this.classNameAccountWebAlias;
            _this.classNameAccountAddressesDropdown = "st_addresses-dots--button_JS";
            _this.selectorAccountAddressesDropdown = "." + _this.classNameAccountAddressesDropdown;
            _this.classNameAccountAddressesDropdownWrapper = "st_dropdown-address--wrapper";
            _this.selectorAccountAddressesDropdownWrapper = "." + _this.classNameAccountAddressesDropdownWrapper;
            _this.classNameAccountTabButton = "st_button-wrapper_JS";
            _this.selectorAccountTabButton = "." + _this.classNameAccountTabButton;
            _this.classNameAccountBackButton = "st_arrow-back--button_JS";
            _this.selectorAccountBackButton = "." + _this.classNameAccountBackButton;
            _this.classNamePasswordVisibilityButton = "st_toggle-visibility-button_JS";
            _this.selectorPasswordVisibilityButton = "." + _this.classNamePasswordVisibilityButton;
            _this.classNameSingleOrder = "st_single-order_JS";
            _this.selectorSingleOrder = "." + _this.classNameSingleOrder;
            _this.classNameOpenOrderCSSClass = "st_open-single-order";
            _this.selectorOpenOrderCSSClass = "." + _this.classNameOpenOrderCSSClass;
            _this.classNameOpenSingleOrderButton = "st_open-single-order_JS";
            _this.selectorOpenSingleOrderButton = "." + _this.classNameOpenSingleOrderButton;
            _this.classNameOrderHistory = "st_order-history_JS";
            _this.selectorOrderHistory = "." + _this.classNameOrderHistory;
            _this.classNameBackToHistoryOrders = "st_back-to-history-orders_JS";
            _this.selectorBackToHistoryOrders = "." + _this.classNameBackToHistoryOrders;
            _this.classNameBackOfficeLink = "st_backoffice-link_JS";
            _this.selectorBackOfficeLink = "." + _this.classNameBackOfficeLink;
            _this.classNameWebAliasFormatting = "st_formatting-web-alias_JS";
            _this.selectorWebAliasFormatting = "." + _this.classNameWebAliasFormatting;
            _this.classNameWebAliasWrapper = "st_web-alias-wrapper_JS";
            _this.selectorWebAliasWrapper = "." + _this.classNameWebAliasWrapper;
            _this.classNameWebAliasValue = "st_web-alias-readonly-input_JS";
            _this.selectorWebAliasValue = "." + _this.classNameWebAliasValue;
            _this.classNameAddressesWrapper = "st_addresses--wrapper_JS";
            _this.selectorAddressesWrapper = "." + _this.classNameAddressesWrapper;
            _this.classNameEditWebAliasForm = "st_edit-webalias-form_JS";
            _this.selectorEditWebAliasForm = "." + _this.classNameEditWebAliasForm;
            _this.classNameSubmitButton = "st_submit--btn_JS";
            _this.selectorSubmitButton = "." + _this.classNameSubmitButton;
            _this.classNameProvinceWrapper = "st_province-wrapper_JS";
            _this.selectorProvinceWrapper = "." + _this.classNameProvinceWrapper;
            _this.classNamePersonalInfoForm = "st_personal-info-form_JS";
            _this.selectorPersonalInfoForm = "." + _this.classNamePersonalInfoForm;
            _this.classNameBusinessContent = "st_account-business--content_JS";
            _this.selectorBusinessContent = "." + _this.classNameBusinessContent;
            _this.classNameBusinessContentName = "st_account-business--name_JS";
            _this.selectorBusinessContentName = "." + _this.classNameBusinessContentName;
            _this.classNameBusinessContentRepName = "st_account-business--rep-name_JS";
            _this.selectorBusinessContentRepName = "." + _this.classNameBusinessContentRepName;
            _this.classNameBusinessContentEmail = "st_account-business--email_JS";
            _this.selectorBusinessContentEmail = "." + _this.classNameBusinessContentEmail;
            return _this;
        }
        return StAccountClassConfig;
    }(st_module_11.StModule);
    exports.StAccountClassConfig = StAccountClassConfig;
});

define("core/shopify-app/st-modules/account/blocks/personal-site/personal-site", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_12, _features_config_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountPersonalSite = void 0;
    var StAccountPersonalSite = function(_super) {
        __extends(StAccountPersonalSite, _super);
        function StAccountPersonalSite(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountPersonalSite";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.copyRefToClipboard(_this_1.classConfig.selectorAccountIconCopyText, ".st_representative-site-link_JS");
                    _this_1.getRefCode();
                });
            };
            _this_1.getRefCode = function() {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_retail-personal-promo-code-link_JS");
                if (_features_config_4.shareRefCodeFunctionality) {
                    _this_1.copyRefToClipboard(".st_referral-link-copy-clipboard_JS", ".st_retail-personal-promo-code-link_JS");
                    _this_1.createLinkWithRef;
                    _this_1.showIncludePromoCode();
                    _this_1.showPersonalSiteRetailBlock();
                    if (!customersRef) {
                        _this_1.createLinkWithoutRef;
                    }
                } else {
                    _this_1.hideIncludePromoCode();
                    _this_1.hidePersonalSiteRetailBlock();
                    _this_1.createLinkWithoutRef;
                }
            };
            _this_1.createLinkWithRef = function(alias) {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_retail-personal-promo-code-link_JS");
                retailInput.forEach(function(input) {
                    input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_4.aliasQueryParam + "=" + alias + "&" + "ref=" + customersRef;
                });
            };
            _this_1.createLinkWithoutRef = function(als) {
                var inputEl = document.querySelectorAll(".st_representative-site-link_JS");
                if (inputEl) {
                    inputEl.forEach(function(input) {
                        var als = localStorage.getItem("webAlias");
                        input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_4.aliasQueryParam + "=" + als;
                    });
                }
            };
            _this_1.hidePersonalSiteRetailBlock = function() {
                var personalSiteRetailBlockWrapper = document.querySelector(".st_personal-site-retail--wrapper_JS");
                if (!!personalSiteRetailBlockWrapper) {
                    personalSiteRetailBlockWrapper.classList.add("st_hidden");
                }
            };
            _this_1.showPersonalSiteRetailBlock = function() {
                var personalSiteRetailBlockWrapper = document.querySelector(".st_personal-site-retail--wrapper_JS");
                if (!!personalSiteRetailBlockWrapper) {
                    personalSiteRetailBlockWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.createLinkWithRefRep = function(alias) {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_representative-site-link_JS");
                retailInput.forEach(function(input) {
                    var hisAlias = localStorage.getItem("webAlias");
                    input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_4.aliasQueryParam + "=" + hisAlias + "&" + "ref=" + customersRef;
                });
            };
            _this_1.createLinkWithoutRefRep = function(als) {
                var inputEl = document.querySelectorAll(".st_representative-site-link_JS");
                if (inputEl) {
                    inputEl.forEach(function(input) {
                        var hisAlias = localStorage.getItem("webAlias");
                        input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_4.aliasQueryParam + "=" + hisAlias;
                    });
                }
            };
            _this_1.includePromoCode = function(als) {
                var _this = _this_1;
                var includeInput = document.querySelector(".st_include-promo-code-input_JS");
                if (!!includeInput) {
                    var inputEl_1 = document.querySelectorAll(".st_representative-site-link_JS");
                    if (includeInput.checked) {
                        _this.createLinkWithRefRep(als);
                    } else {
                        _this.createLinkWithoutRefRep(als);
                    }
                    includeInput.addEventListener("change", function(event) {
                        if (!!inputEl_1) {
                            if (includeInput.checked) {
                                _this.createLinkWithRefRep(als);
                            } else {
                                _this.createLinkWithoutRefRep(als);
                            }
                        }
                    });
                }
            };
            _this_1.hideIncludePromoCode = function() {
                var includePromoCodeWrapper = document.querySelector(".st_include-promo-code-wrapper_JS");
                if (!!includePromoCodeWrapper) {
                    includePromoCodeWrapper.classList.add("st_hidden");
                }
            };
            _this_1.showIncludePromoCode = function() {
                var includePromoCodeWrapper = document.querySelector(".st_include-promo-code-wrapper_JS");
                if (!!includePromoCodeWrapper) {
                    includePromoCodeWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.copyRefToClipboard = function(button, input) {
                var copyRepSiteButtonAll = document.querySelectorAll(button);
                if (!!copyRepSiteButtonAll) {
                    copyRepSiteButtonAll.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            var copyText = document.querySelectorAll(input);
                            if (!!copyText) {
                                copyText.forEach(function(input) {
                                    if (!!input) {
                                        input.select();
                                        input.setSelectionRange(0, 99999);
                                        navigator.clipboard.writeText(input.value);
                                        input.style.backgroundColor = "rgb(217, 218, 220)";
                                        input.style.transition = "0.2s";
                                        setTimeout(function() {
                                            input.style.backgroundColor = "rgb(249, 249, 249)";
                                        }, 1e3);
                                    }
                                });
                            }
                        });
                    });
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountPersonalSite;
    }(st_module_12.StModule);
    exports.StAccountPersonalSite = StAccountPersonalSite;
});

define("core/shopify-app/st-modules/webalias/webalias", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_13, _features_config_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAlias = void 0;
    var StWebAlias = function(_super) {
        __extends(StWebAlias, _super);
        function StWebAlias(classConfig, browserHistory, objectFormatting, cookies, customerType, generalMethods, injectRepresentativeInfo, cartComponent, searchSponsorGuard, accountPersonalSite) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "WebAlias";
            _this.cookieNameWebAlias = "webAlias";
            _this.cookieNameRepId = "repId";
            _this.cookieNameFirstName = "firstName";
            _this.cookieNameLastName = "lastName";
            _this.cookieNameImageUrl = "imageUrl";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.initWebAliasFlow();
                    _this.initSponsorCheck();
                    if (window.stLog()) {
                        console.log("lockedRepresentativeSite: ", _features_config_5.lockedRepresentativeSite);
                        console.log("canGoUnderCorporateSite: ", _features_config_5.canGoUnderCorporateSite);
                    }
                    _this.getSponsorInformation();
                });
            };
            _this.initWebAliasFlow = function() {
                if (_this.isCustomerRepresentative) {
                    _this.representativeAliasFlow();
                    return;
                }
                if (_this.isCustomerRetail) {
                    _this.retailAliasFlow();
                    return;
                }
                if (_this.isCustomerGuest) {
                    _this.guestAliasFlow();
                }
            };

            _this.representativeAliasFlow = function() {
                _this.getRepresentativesOwnInfo(_this.customerIdFromMetafields);
            };
            _this.guestAliasFlow = function() {
                var u = _this.objectFormatting.convertQueryStringToObject(window.location.search).u;
                var urlAliasExists = !!u;
                var cookieAliasExists = !!_this.cookies.getCookie("webAlias");
                if (urlAliasExists) {
                    _this.getRepresentativesOwnInfo(u);
                    return;
                }
                if (cookieAliasExists) {
                    _this.injectRepInfoFromCookie();
                    return;
                }
                //_this.injectDefaultRepInfo();
            };
            _this.retailAliasFlow = function() {
                var u = _this.objectFormatting.convertQueryStringToObject(window.location.search).u;
                var urlAliasExists = !!u;
                var cookieAliasExists = !!_this.cookies.getCookie("webAlias");
                var isLocked = _features_config_5.lockedRepresentativeSite;
                if (isLocked) {
                    var customerIdOrAls = _this.customerIdFromMetafields;
                    _this.getCustomersRepresentativeInfo(customerIdOrAls);
                    return;
                }
                if (!isLocked) {
                    if (urlAliasExists) {
                        _this.getRepresentativesOwnInfo(u);
                        return;
                    } else {
                        if (cookieAliasExists) {
                            _this.injectRepInfoFromCookie();
                            return;
                        } else {
                            _this.injectDefaultRepInfo();
                            return;
                        }
                    }
                }
            };
            _this.handleRepresentativeInfoResponse = function(response) {
                var data = response.data, status = response.status;
                var webAlias = data.webAlias, repId = data.repId;
                if (status !== 200) {
                    _this.nonExistentRepresentativeFlow();
                    return;
                }
                if (!webAlias && webAlias === "") {
                    data = __assign(__assign({}, data), {
                        webAlias: repId
                    });
                }
                _this.updateCurrentRepInfo(data);
            };
            _this.getRepresentativesOwnInfo = function(customerIdOrAlias) {
                if (customerIdOrAlias && customerIdOrAlias != '') {
                    _this.getRepresentativeInfo({
                        customerIdOrAlias: customerIdOrAlias,
                        isOwnInfo: true
                    }, _this.handleRepresentativeInfoResponse);
                }
            };
            _this.getCustomersRepresentativeInfo = function(customerIdOrAlias) {
                if (customerIdOrAlias && customerIdOrAlias != '') {
                    _this.getRepresentativeInfo({
                        customerIdOrAlias: customerIdOrAlias,
                        isOwnInfo: false
                    }, _this.handleRepresentativeInfoResponse);
                }
            };
            _this.getRepresentativeInfo = function(webAliasRequest, handleResponse) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["webalias"]["repSite"],
                        method: "post",
                        contentType: "json",
                        data: webAliasRequest,
                        callback: function(response) {
                            try {
                                var representativeInfoRes = JSON.parse(response.response);
                                handleResponse(representativeInfoRes);
                            } catch (error) {
                                _this.nonExistentRepresentativeFlow();
                                console.log("Response Error ------\x3e" + error);
                            }
                        }
                    });
                } catch (error) {}
            };
            _this.getSponsorInformation = function() {
                if (window.customerInfoMetafields && window.customerInfoMetafields.representativeId && window.customerInfoMetafields.representativeId != '') {
                    var repIdMetafield = window.customerInfoMetafields.representativeId;
                    var webAliasRequestedData = {
                        customerIdOrAlias: repIdMetafield,
                        isOwnInfo: true
                    };
                    _this.getRepresentativeInfo(webAliasRequestedData, _this.handleSponsorInfoResponse);
                }
            };
            _this.handleSponsorInfoResponse = function(response) {
                if (response.status === 200) {
                    var sponsorInfo = response.data;
                    _this.injectRepresentativeInfo.injectSponsorInfoToField(sponsorInfo.firstName, sponsorInfo.lastName);
                    _this.accountPersonalSite.createLinkWithRef(sponsorInfo.webAlias);
                    _this.accountPersonalSite.includePromoCode(sponsorInfo.webAlias);
                } else {
                    _this.injectRepresentativeInfo.injectSponsorInfoToField("", "");
                }
            };
            _this.updateCurrentRepInfo = function(repInfo) {
                var webAlias = repInfo.webAlias;
                if (!_this.isAliasEqualToStored(webAlias)) {
                    _this.setRepresentativeCookies(repInfo);
                }
                if (!_this.isAliasEqualToUrlAlias(webAlias)) {
                    _this.setNewAliasInUrl(webAlias);
                } else {
                    _this.cartComponent.updateCartItemsProperies(webAlias);
                }
                _this.searchSponsorGuard.toggleCantGoUnderCorporateSite(webAlias === _features_config_5.defaultWebAlias);
                _this.injectRepresentativeInfo.injectToFields(repInfo);
            };
            _this.nonExistentRepresentativeFlow = function() {
                if (!_this.isCustomerRetail) {
                    _this.injectDefaultRepInfo();
                    return;
                }
                _this.injectRepInfoFromCookie();
            };
            _this.injectRepInfoFromCookie = function() {
                var repInfo = {
                    firstName: _this.cookies.getCookie(_this.cookieNameFirstName),
                    lastName: _this.cookies.getCookie(_this.cookieNameLastName),
                    webAlias: _this.cookies.getCookie(_this.cookieNameWebAlias),
                    repId: _this.cookies.getCookie(_this.cookieNameRepId)
                };
                if (repInfo.webAlias == 'shop') {
                    _this.cookies.clearCookie(_this.cookieNameFirstName);
                    _this.cookies.clearCookie(_this.cookieNameLastName);
                    _this.cookies.clearCookie(_this.cookieNameWebAlias);
                    _this.cookies.clearCookie(_this.cookieNameRepId);
                } else {
                    var imageUrl = _this.cookies.getCookie(_this.cookieNameImageUrl);
                    if (!!imageUrl && _features_config_5.additionalRepInfo) {
                        repInfo = __assign(__assign({}, repInfo), {
                            imageUrl: imageUrl
                        });
                    }
                    _this.updateCurrentRepInfo(repInfo);
                }
            };
            _this.injectDefaultRepInfo = function() {
                //console.log('injectDefaultRepInfo');
                return;
                var repInfo = {
                    webAlias: _features_config_5.defaultWebAlias,
                    firstName: _features_config_5.corporationName,
                    lastName: ""
                };
                if (_features_config_5.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        imageUrl: _features_config_5.defaultCorporationImage
                    });
                }
                _this.updateCurrentRepInfo(repInfo);
            };
            _this.isAliasEqualToStored = function(alias) {
                return alias === _this.cookies.getCookie("webAlias");
            };
            _this.isAliasEqualToUrlAlias = function(alias) {
                var u = _this.objectFormatting.convertQueryStringToObject(window.location.search).u;
                return u === alias;
            };
            _this.setNewAliasInUrl = function(alias) {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var newUrlParams = __assign(__assign({}, urlParams), {
                    u: alias
                });
                var newURL = window.location.href.replace(window.location.search, "");
                _this.cartComponent.updateCartItemsProperies(alias);
                _this.browserHistory.pushHistory(newURL, newUrlParams);
            };
            _this.setRepresentativeCookies = function(repInfo) {
                _this.cookies.setCookies(_this.cookieNameWebAlias, repInfo.webAlias);
                _this.cookies.setCookies(_this.cookieNameRepId, repInfo.repId);
                _this.cookies.setCookies(_this.cookieNameFirstName, repInfo.firstName);
                _this.cookies.setCookies(_this.cookieNameLastName, repInfo.lastName);
                if (_features_config_5.additionalRepInfo) {
                    _this.cookies.setCookies(_this.cookieNameImageUrl, repInfo.imageUrl);
                }
            };
            _this.initSponsorWebAliasFieldChange = function() {
                var representativeWebAliasInput = document.querySelectorAll(".st_representative-alias_JS");
                representativeWebAliasInput.forEach(function(webAliasInput) {
                    webAliasInput.oninput = function() {
                        return _this.updateWebAliasOnSponsorFieldChange(webAliasInput);
                    };
                });
            };
            _this.updateWebAliasOnSponsorFieldChange = function(representativeWebAliasInput) {
                clearTimeout(_this.sponsorWebAliasInputTimeout);
                _this.sponsorWebAliasInputTimeout = setTimeout(function() {
                    var currentUrlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                    var newUrlParams = __assign(__assign({}, currentUrlParams), {
                        u: representativeWebAliasInput.value
                    });
                    var newQueryString = _this.objectFormatting.convertObjectToQueryString(newUrlParams);
                    _this.cartComponent.updateCartItemsProperies(representativeWebAliasInput.value);
                    var newURL = window.location.origin + window.location.pathname + newQueryString;
                    window.location.replace(newURL);
                }, 1e3);
            };
            _this.initSponsorCheck = function() {
                var shopifyCustomerId = _this.shopifyCustomerId;
                if (_this.isTimeForSponsorCheck() && shopifyCustomerId && shopifyCustomerId !== 0) {
                    _this.updateCustomerSponsor(shopifyCustomerId);
                }
            };
            _this.updateCustomerSponsor = function(shopifyCustomerId) {
                var updateSponsorData = {
                    shopifyCustomerId: shopifyCustomerId
                };
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["customer"]["updateSponsor"],
                        method: "post",
                        contentType: "json",
                        data: updateSponsorData
                    });
                } catch (error) {
                    console.log("Request Error ------\x3e " + error);
                }
            };
            _this.isTimeForSponsorCheck = function() {
                var timestamp = Date.now();
                var lastCheck = _this.customerSponsorLastCheck;
                var timeThreshold = _features_config_5.sponsorGenealogyTimeout ? _features_config_5.sponsorGenealogyTimeout : 9e5;
                return timestamp - lastCheck > timeThreshold;
            };
            _this.classConfig = classConfig;
            _this.browserHistory = browserHistory;
            _this.objectFormatting = objectFormatting;
            _this.cookies = cookies;
            _this.customerType = customerType;
            _this.generalMethods = generalMethods;
            _this.injectRepresentativeInfo = injectRepresentativeInfo;
            _this.cartComponent = cartComponent;
            _this.searchSponsorGuard = searchSponsorGuard;
            _this.accountPersonalSite = accountPersonalSite;

            _this.handleRepresentativeStoreOwnInfoResponse = function(response) {
                var data = response.data;
                var webAlias = data && data.webAlias;
                if (!!webAlias) window.myrefcode = webAlias;
            };

            if (_this.customerIdFromMetafields) {
                window.myrefcode = _this.getRepresentativeInfo({
                    customerIdOrAlias: _this.customerIdFromMetafields,
                    isOwnInfo: true
                }, _this.handleRepresentativeStoreOwnInfoResponse);
            }

            return _this;
        }
        Object.defineProperty(StWebAlias.prototype, "isCustomerGuest", {
            get: function() {
                return this.customerType.get() === _features_config_5.ECustomerType.guest;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "isCustomerRetail", {
            get: function() {
                return this.customerType.get() === _features_config_5.ECustomerType.retail;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "isCustomerRepresentative", {
            get: function() {
                return this.customerType.get() === _features_config_5.ECustomerType.representative;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "customerIdFromMetafields", {
            get: function() {
                return window.customerInfoMetafields.customerId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "shopifyCustomerId", {
            get: function() {
                return window.customerShopifyId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "customerSponsorLastCheck", {
            get: function() {
                return window.customerSponsorLastCheck;
            },
            enumerable: false,
            configurable: true
        });
        return StWebAlias;
    }(st_module_13.StModule);
    exports.StWebAlias = StWebAlias;
});

define("core/shopify-app/st-modules/_general-methods/button/button-actions", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_14) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StButtonActions = exports.EButtonAction = void 0;
    var EButtonAction;
    (function(EButtonAction) {
        EButtonAction["enable"] = "enable";
        EButtonAction["disable"] = "disable";
        EButtonAction["toggleState"] = "toggleState";
        EButtonAction["prevent"] = "prevent";
        EButtonAction["allow"] = "allow";
        EButtonAction["addLoader"] = "addLoader";
        EButtonAction["removeLoader"] = "removeLoader";
        EButtonAction["toggleLoader"] = "toggleLoader";
    })(EButtonAction = exports.EButtonAction || (exports.EButtonAction = {}));
    var StButtonActions = function(_super) {
        __extends(StButtonActions, _super);
        function StButtonActions() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ButtonActions";
            _this.applyToMultiple = function(buttons, action) {
                buttons.forEach(function(button) {
                    _this[action](button);
                });
            };
            _this.enable = function(button) {
                if (!!button) {
                    button.removeAttribute("disabled");
                    button.classList.remove("st-disabled");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.disable = function(button) {
                if (!!button) {
                    button.setAttribute("disabled", "");
                    button.classList.add("st-disabled");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.addLoader = function(button) {
                if (!!button) {
                    button.classList.add("st-loading");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.removeLoader = function(button) {
                if (!!button) {
                    button.classList.remove("st-loading");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.toggleState = function(button) {
                if (!!button) {
                    if (button.classList.contains("st-disabled")) {
                        _this.enable(button);
                    } else {
                        _this.disable(button);
                    }
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.toggleLoader = function(button) {
                if (!!button) {
                    if (button.classList.contains("st-loading")) {
                        _this.removeLoader(button);
                    } else {
                        _this.addLoader(button);
                    }
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.prevent = function(button) {
                if (!!button) {
                    _this.disable(button);
                    _this.addLoader(button);
                    button.classList.add("st-blocked");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.allow = function(button) {
                if (!!button) {
                    _this.enable(button);
                    _this.removeLoader(button);
                    button.classList.remove("st-blocked");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.isBlocked = function(button) {
                return button.classList.contains("st-blocked");
            };
            _this.isLoading = function(button) {
                return button.classList.contains("st-loading");
            };
            _this.isDisabled = function(button) {
                return button.classList.contains("st-disabled") || button.classList.contains("st-disabled");
            };
            return _this;
        }
        return StButtonActions;
    }(st_module_14.StModule);
    exports.StButtonActions = StButtonActions;
});

define("core/shopify-app/st-modules/_general-methods/form/form-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_15) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFormClassConfig = void 0;
    var StFormClassConfig = function(_super) {
        __extends(StFormClassConfig, _super);
        function StFormClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "FormClassConfig";
            _this.classNameDateWrp = "st_date_JS";
            _this.selectorDateWrp = "." + _this.classNameDateWrp;
            _this.classNameDateYearInput = "st_date--year_JS";
            _this.selectorDateYearInput = "." + _this.classNameDateYearInput;
            _this.classNameDateMonthInput = "st_date--month_JS";
            _this.selectorDateMonthInput = "." + _this.classNameDateMonthInput;
            _this.classNameDateDayInput = "st_date--day_JS";
            _this.selectorDateDayInput = "." + _this.classNameDateDayInput;
            _this.classNameDateCompleteInput = "st_date--complete_JS";
            _this.selectorDateCompleteInput = "." + _this.classNameDateCompleteInput;
            _this.months = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
            return _this;
        }
        return StFormClassConfig;
    }(st_module_15.StModule);
    exports.StFormClassConfig = StFormClassConfig;
});

define("core/shopify-app/st-modules/_general-methods/form/fields/date-input", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_16) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDateInput = void 0;
    var StDateInput = function(_super) {
        __extends(StDateInput, _super);
        function StDateInput(classConfig) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "DateInput";
            _this_1.setupDateFields = function() {
                var dateWraps = document.querySelectorAll(_this_1.classConfig.selectorDateWrp);
                dateWraps.forEach(function(dateWrp) {
                    _this_1.setupDateField(dateWrp);
                });
            };
            _this_1.setupDateField = function(dateWrap) {
                var _a;
                var dateYearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var dateMonthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dateDayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var now = new Date();
                var yearNow = now.getUTCFullYear();
                _this_1.generateYears(dateYearInput, 1900, yearNow);
                dateYearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var defaultYear = dateYearInput.getAttribute("data-default");
                var defaultYearIndex = !!defaultYear ? parseInt(dateYearInput.querySelector('[value="'.concat(defaultYear, '"]')).getAttribute("data-index")) : 0;
                _this_1.setSelectValue(dateYearInput, defaultYearIndex);
                _this_1.generateMonths(dateMonthInput);
                dateMonthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var defaultMonth = dateMonthInput.getAttribute("data-default");
                var defaultMonthIndex = !!defaultMonth ? parseInt(dateMonthInput.querySelector('[value="'.concat(defaultMonth, '"]')).getAttribute("data-index")) : 0;
                _this_1.setSelectValue(dateMonthInput, defaultMonthIndex);
                _this_1.generateDays(dateDayInput, (_a = parseInt(dateYearInput.value)) !== null && _a !== void 0 ? _a : yearNow, defaultMonthIndex);
                var defaultDay = dateDayInput.getAttribute("data-default");
                var defaultDayIndex = !!defaultDay ? parseInt(dateDayInput.querySelector('[value="'.concat(defaultDay, '"]')).getAttribute("data-index")) : 0;
                dateDayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                _this_1.setSelectValue(dateDayInput, defaultDayIndex);
                _this_1.setupEvents(dateWrap, dateYearInput, dateMonthInput, dateDayInput);
            };
            _this_1.getDays = function(year, month) {
                return new Date(year, month + 1, 0).getDate();
            };
            _this_1.generateDays = function(holder, year, month) {
                var days = _this_1.getDays(year, month);
                holder.replaceChildren();
                for (var i = 1; i <= days; i++) {
                    var option = _this_1.generateOption(i, undefined, undefined, i - 1);
                    holder.appendChild(option);
                }
                return days;
            };
            _this_1.generateMonths = function(holder) {
                for (var i = 0; i < _this_1.classConfig.months.length; i++) {
                    var option = _this_1.generateOption(i, _this_1.classConfig.months[i], undefined, i);
                    holder.appendChild(option);
                }
            };
            _this_1.generateYears = function(holder, startingYear, endYear) {
                for (var i = 0; i < endYear - startingYear; i++) {
                    var option = _this_1.generateOption(endYear - i, undefined, undefined, i);
                    holder.appendChild(option);
                }
            };
            _this_1.generateOption = function(value, displayValue, selected, elementIndex) {
                if (displayValue === void 0) {
                    displayValue = value;
                }
                if (selected === void 0) {
                    selected = false;
                }
                var option = document.createElement("option");
                option.value = "".concat(value);
                option.setAttribute("value", "".concat(value));
                option.innerHTML = "".concat(displayValue);
                if (selected) {
                    option.setAttribute("selected", "selected");
                }
                if (typeof elementIndex !== "undefined") {
                    option.setAttribute("data-index", "".concat(elementIndex));
                }
                return option;
            };
            _this_1.setSelectValue = function(holder, optionIndex) {
                var options = holder.querySelectorAll("option");
                var selected = options[holder.selectedIndex];
                if (!!selected) {
                    selected.removeAttribute("selected");
                    selected.selected = false;
                }
                optionIndex = optionIndex > options.length - 1 ? options.length - 1 : optionIndex;
                holder.selectedIndex = optionIndex;
                options[optionIndex].selected = true;
                options[optionIndex].setAttribute("selected", "selected");
            };
            _this_1.setInputValue = function(input, value) {
                input.value = value;
                input.setAttribute("value", value);
                input.dispatchEvent(new Event("change", {
                    bubbles: true
                }));
            };
            _this_1.setupEvents = function(dateWrap, yearInput, monthInput, dayInput) {
                var _this = _this_1;
                monthInput.addEventListener("change", function(e) {
                    _this.adaptDaysOnChange(dateWrap);
                    _this.completeDate(dateWrap);
                });
                yearInput.addEventListener("change", function(e) {
                    _this.adaptDaysOnChange(dateWrap);
                    _this.completeDate(dateWrap);
                });
                dayInput.addEventListener("change", function(e) {
                    _this.completeDate(dateWrap);
                });
            };
            _this_1.completeDate = function(dateWrap) {
                var yearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var monthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var completeInput = dateWrap.querySelector(_this_1.classConfig.selectorDateCompleteInput);
                var year = parseInt(yearInput.querySelectorAll("option")[yearInput.selectedIndex].value);
                var month = parseInt(monthInput.querySelectorAll("option")[monthInput.selectedIndex].value);
                var day = parseInt(dayInput.querySelectorAll("option")[dayInput.selectedIndex].value);
                var completeDate = "".concat(year, "-").concat(month + 1, "-").concat(day);
                _this_1.setInputValue(completeInput, completeDate);
            };
            _this_1.adaptDaysOnChange = function(dateWrap) {
                var yearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var monthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var year = parseInt(yearInput.querySelectorAll("option")[yearInput.selectedIndex].value);
                var month = parseInt(monthInput.querySelectorAll("option")[monthInput.selectedIndex].value);
                var day = parseInt(dayInput.querySelectorAll("option")[dayInput.selectedIndex].value);
                var maxDays = _this_1.generateDays(dayInput, year, month);
                var selectedIndex = day > maxDays ? maxDays : day;
                _this_1.setSelectValue(dayInput, selectedIndex - 1);
            };
            _this_1.classConfig = classConfig;
            return _this_1;
        }
        return StDateInput;
    }(st_module_16.StModule);
    exports.StDateInput = StDateInput;
});

define("core/shopify-app/st-modules/_general-methods/form/form", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_17) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StForm = void 0;
    var StForm = function(_super) {
        __extends(StForm, _super);
        function StForm(classConfig, dateInput) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Form";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.dateInput.setupDateFields();
                });
            };
            _this_1.liveTrim = function(inputs) {
                inputs = inputs ? inputs : document.querySelectorAll(".st_input");
                var trimOperation = function(trigger) {
                    trigger.value = trigger.value.replace(/  +/g, " ");
                    trigger.value = trigger.value.trimStart();
                };
                inputs.forEach(function(input) {
                    input.addEventListener("keyup", function() {
                        trimOperation(this);
                    });
                    input.addEventListener("change", function() {
                        trimOperation(this);
                    });
                });
            };
            _this_1.collectFormData = function(form) {
                if (form === undefined || form === null) {
                    return false;
                }
                var data = {};
                for (var i = 0; i < form.elements.length; i++) {
                    var field = form.elements[i];
                    data = __assign(__assign({}, data), _this_1.collectField(field));
                }
                return data;
            };
            _this_1.collectField = function(field) {
                var data = {};
                if (!field.name || field.type === "file" || field.type === "reset" || field.type === "submit" || field.type === "button") return data;
                if (field.disabled && field.tagName !== "SELECT") return data;
                if (field.type === "select-multiple") {
                    data[field.name] = [];
                    for (var n = 0; n < field.options.length; n++) {
                        if (!field.options[n].selected) continue;
                        data[field.name].push(field.options[n].value);
                    }
                } else if (field.type !== "checkbox" && field.type !== "radio") {
                    data[field.name] = field.value;
                    if (field.value.toLowerCase() === "true") {
                        data[field.name] = true;
                    } else if (field.value.toLowerCase() === "false") {
                        data[field.name] = false;
                    }
                } else if (field.type === "checkbox") {
                    data[field.name] = !!field.checked;
                }
                if (field.getAttribute("data-parse") === "true") {
                    if (field.getAttribute("data-decode") !== "false") {
                        data[field.name] = decodeURIComponent(data[field.name]);
                    }
                    data[field.name] = JSON.parse(data[field.name]);
                }
                return data;
            };
            _this_1.markValidation = function(page, inputName, isValid, invalidMessage) {
                if (invalidMessage === void 0) {
                    invalidMessage = "";
                }
                page.querySelectorAll('[data-validation-visual="'.concat(inputName, '"]')).forEach(function(validationVisual) {
                    var errorMessage = validationVisual.parentElement.querySelector(".st_message-error_JS");
                    if (isValid) {
                        validationVisual.classList.remove("st_input_invalid");
                        if (!!errorMessage) {
                            errorMessage.remove();
                        }
                    } else {
                        validationVisual.classList.add("st_input_invalid");
                        if (!errorMessage) {
                            var errorMessageBlock = document.createElement("span");
                            errorMessageBlock.className = "st_message-error st_message-error_JS";
                            validationVisual.parentElement.append(errorMessageBlock);
                            errorMessage = validationVisual.parentElement.querySelector(".st_message-error_JS");
                        }
                        errorMessage.innerHTML = invalidMessage;
                    }
                });
            };
            _this_1.markValidationResults = function(page, validationResponse) {
                if (Object.keys(validationResponse).length > 0) {
                    Object.keys(validationResponse).forEach(function(paramName) {
                        _this_1.markValidation(page, paramName, validationResponse[paramName].isValid, validationResponse[paramName].message);
                    });
                }
            };
            _this_1.numbersOnly = function() {
                var numberInputs = document.querySelectorAll(".nuv_only-number_JS");
                if (numberInputs && numberInputs.length > 0) {
                    for (var i = 0; i < numberInputs.length; i++) {
                        var inputSelector = numberInputs[i];
                        inputSelector.addEventListener("keyup", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                        inputSelector.addEventListener("input", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                        inputSelector.addEventListener("change", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                    }
                }
            };
            _this_1.formValidation = function() {
                var _this = _this_1;
                var taxId = document.querySelector('[name="enrollment[tax_id]"]');
                if (taxId && typeof taxId != "undefined") {
                    taxId.addEventListener("input", function(e) {
                        _this.applyFormatting(this);
                    });
                }
                var email = document.querySelector('[name="enrollment[email]"]');
                if (email && typeof email != "undefined") {
                    email.addEventListener("input", function(e) {
                        _this.validateEmail(this);
                    });
                }
                var upgradeEmail = document.querySelector('[name="address[email]"]');
                if (upgradeEmail && typeof upgradeEmail != "undefined") {
                    upgradeEmail.addEventListener("input", function(e) {
                        _this.validateEmail(this);
                    });
                }
            };
            _this_1.validateDateOfBirth = function() {
                var currentYear = new Date().getFullYear();
                var dateOfBirtd = document.querySelector('[name="enrollment[date_of_birtd]"]');
                if (dateOfBirtd && typeof dateOfBirtd != "undefined") {
                    var date = new Date(dateOfBirtd.value);
                    var year = date.getFullYear();
                    return year < currentYear && year > 1900;
                } else {
                    return false;
                }
            };
            _this_1.validateEmail = function(field) {
                var valid = false;
                var val = field.value;
                var at = val.indexOf("@");
                if (at >= 2) {
                    val = val.substr(at);
                    var dot = val.indexOf(".");
                    if (dot >= 2) {
                        val = val.substr(dot);
                        if (val.length >= 2) {
                            valid = true;
                            if (field.classList.contains("st-bds_invalid_input")) {
                                field.classList.remove("st-bds_invalid_input");
                            }
                        }
                    } else {
                        if (!field.classList.contains("st-bds_invalid_input")) {
                            field.classList.add("st-bds_invalid_input");
                        }
                    }
                } else {
                    if (!field.classList.contains("st-bds_invalid_input")) {
                        field.classList.add("st-bds_invalid_input");
                    }
                }
                return valid;
            };
            _this_1.applyFormatting = function(field) {
                var val = field.value;
                var format = "";
                var formatData = {
                    separator: "-",
                    format: "XXX-XX-XXXX",
                    type: "numeric"
                };
                if (formatData.type === "numeric") {
                    val = val.replace(/[^0-9]/g, "");
                }
                if (typeof formatData.format === "object") {
                    format = formatData.format[field.name];
                } else {
                    format = formatData.format;
                    var segments = formatData.separator ? formatData.format.split(formatData.separator) : [ formatData.format ];
                    var disp = [];
                    for (var i = 0; i < segments.length; i++) {
                        var it = val.substr(0, segments[i].length);
                        if (it !== "") {
                            disp.push(it);
                        }
                        val = val.replace(it, "");
                    }
                    val = disp.join(formatData.separator);
                }
                if (format.length > val.length) {
                    field.classList.add("st-bds_invalid_input");
                } else if (format.length === val.length) {
                    field.classList.remove("st-bds_invalid_input");
                } else {
                    val = val.substr(0, format.length);
                }
                field.value = val;
            };
            _this_1.clearFormatting = function(page, inputNames) {
                var _this = _this_1;
                inputNames.forEach(function(inputName) {
                    _this.markValidation(page, inputName, true, "");
                });
            };
            _this_1.dateInput = dateInput;
            _this_1.classConfig = classConfig;
            return _this_1;
        }
        return StForm;
    }(st_module_17.StModule);
    exports.StForm = StForm;
});

define("core/shopify-app/st-modules/_general-methods/notification", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_18) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StNotification = exports.ENotificationType = void 0;
    var ENotificationType;
    (function(ENotificationType) {
        ENotificationType["success"] = "success";
        ENotificationType["error"] = "error";
        ENotificationType["info"] = "info";
    })(ENotificationType = exports.ENotificationType || (exports.ENotificationType = {}));
    var StNotification = function(_super) {
        __extends(StNotification, _super);
        function StNotification() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Notification";
            _this.createNotification = function() {
                var element = document.createElement("div");
                element.setAttribute("class", "st_notification-wrapper");
                element.setAttribute("id", "st_notification");
                var trigger = document.createElement("button");
                trigger.setAttribute("type", "button");
                trigger.dataset.close = "notification";
                trigger.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 40 40"><path d="M23.868 20.015L39.117 4.78c1.11-1.108 1.11-2.77 0-3.877-1.109-1.108-2.773-1.108-3.882 0L19.986 16.137 4.737.904C3.628-.204 1.965-.204.856.904c-1.11 1.108-1.11 2.77 0 3.877l15.249 15.234L.855 35.248c-1.108 1.108-1.108 2.77 0 3.877.555.554 1.248.831 1.942.831s1.386-.277 1.94-.83l15.25-15.234 15.248 15.233c.555.554 1.248.831 1.941.831s1.387-.277 1.941-.83c1.11-1.109 1.11-2.77 0-3.878L23.868 20.015z" /></svg>';
                element.appendChild(trigger);
                var title = document.createElement("div");
                title.setAttribute("class", "st_notification-title");
                element.appendChild(title);
                var desc = document.createElement("div");
                desc.setAttribute("class", "st_notification-description");
                element.appendChild(desc);
                return element;
            };
            _this.assembleNotification = function(type, title, description) {
                if (title === void 0) {
                    title = "";
                }
                if (description === void 0) {
                    description = "";
                }
                var typeClass = "";
                var notification = _this.createNotification();
                if (typeof description === "string") {
                    description = [ description ];
                }
                switch (type) {
                  case "success":
                    typeClass = "st_success";
                    break;

                  case "error":
                    typeClass = "st_error";
                    break;

                  case "info":
                    typeClass = "st_info";
                    break;
                }
                notification.classList.add(typeClass);
                var t = notification.querySelector(".st_notification-title");
                t.innerHTML = title;
                var d = notification.querySelector(".st_notification-description");
                var message = "";
                for (var i = 0; i < description.length; i++) {
                    if (i !== 0) {
                        message += "<hr>";
                    }
                    message += description[i];
                }
                d.innerHTML = message;
                return notification;
            };
            _this.showNotification = function(type, title, description, duration, preventDisappear) {
                if (type === void 0) {
                    type = ENotificationType.error;
                }
                if (title === void 0) {
                    title = "";
                }
                if (description === void 0) {
                    description = "";
                }
                if (duration === void 0) {
                    duration = 5e3;
                }
                if (preventDisappear === void 0) {
                    preventDisappear = false;
                }
                var notif = document.getElementById("st_notification");
                if (notif !== null) {
                    notif.remove();
                }
                var notification = _this.assembleNotification(type, title, description);
                var button = notification.querySelectorAll('button[data-close="notification"]')[0];
                button.addEventListener("click", function(e) {
                    var el = this.closest(".st_notification-wrapper");
                    body.removeChild(el);
                });
                var body = document.getElementsByTagName("body")[0];
                body.appendChild(notification);
                if (!preventDisappear) {
                    clearTimeout(_this.globalShowTimeout);
                    _this.globalShowTimeout = setTimeout(function() {
                        if (notification && notification.parentNode) {
                            notification.parentNode.removeChild(notification);
                        }
                    }, duration);
                }
            };
            return _this;
        }
        return StNotification;
    }(st_module_18.StModule);
    exports.StNotification = StNotification;
});

define("core/shopify-app/st-modules/account-register/account-register-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_19) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountRegisterClassConfig = void 0;
    var StAccountRegisterClassConfig = function(_super) {
        __extends(StAccountRegisterClassConfig, _super);
        function StAccountRegisterClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountClassConfig";
            _this.classAccountRegisterForm = "st_account-register-form_JS";
            _this.selectorAccountRegisterForm = "." + _this.classAccountRegisterForm;
            _this.classAccountRegisterFormPreventDefault = "st_prevent-form-default_JS";
            _this.selectorAccountRegisterFormPreventDefault = "." + _this.classAccountRegisterFormPreventDefault;
            _this.classRepresentativeAlias = "st_representative-alias_JS";
            _this.selectorRepresentativeAlias = "." + _this.classRepresentativeAlias;
            _this.classNamePasswordVisibilityButton = "st_toggle-password-visibility-button_JS";
            _this.selectorPasswordVisibilityButton = "." + _this.classNamePasswordVisibilityButton;
            _this.classRegisterPasswordInput = "st_register-password-input_JS";
            _this.selectorRegisterPasswordInput = "." + _this.classRegisterPasswordInput;
            return _this;
        }
        return StAccountRegisterClassConfig;
    }(st_module_19.StModule);
    exports.StAccountRegisterClassConfig = StAccountRegisterClassConfig;
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor-service", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_20) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorService = void 0;
    var StSearchSponsorService = function(_super) {
        __extends(StSearchSponsorService, _super);
        function StSearchSponsorService() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorService";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {});
            };
            _this.getSponsorByPersonalInfo = function(inputValue, handleGetSponsorInfo) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["searchSponsor"]["getSponsorByPersonalInfo"],
                        method: "post",
                        contentType: "json",
                        data: {
                            query: inputValue,
                            mode: "name"
                        },
                        callback: handleGetSponsorInfo
                    });
                } catch (error) {
                    console.log("Error occurred while getting sponsor info ---\x3e", error);
                }
            };
            _this.getSponsorInfo = function(sponsorIdOrAlias, handleGetSponsorInfo) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["searchSponsor"]["getSponsorInfo"],
                        method: "post",
                        contentType: "json",
                        data: {
                            query: sponsorIdOrAlias
                        },
                        callback: handleGetSponsorInfo
                    });
                } catch (error) {
                    console.log("Error occurred while getting sponsor info ---\x3e", error);
                }
            };
            return _this;
        }
        return StSearchSponsorService;
    }(st_module_20.StModule);
    exports.StSearchSponsorService = StSearchSponsorService;
});

define("extension/shopify-app/st-modules/account/blocks/personal-site/personal-site", [ "require", "exports", "_features.config", "core/shopify-app/st-modules/account/blocks/personal-site/personal-site" ], function(require, exports, _features_config_6, personal_site_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountPersonalSiteExtended = void 0;
    var StAccountPersonalSiteExtended = function(_super) {
        __extends(StAccountPersonalSiteExtended, _super);
        function StAccountPersonalSiteExtended(classConfig, generalMethods) {
            var _this = _super.call(this, classConfig, generalMethods) || this;
            _this.className = "AccountPersonalSiteExtended";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.copyRefToClipboard(_this.classConfig.selectorAccountIconCopyText, ".st_representative-site-link_JS");
                    _this.getRefCode();
                });
            };
            _this.createLinkWithRef = function(alias) {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_retail-personal-promo-code-link_JS");
                retailInput.forEach(function(input) {
                    input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_6.aliasQueryParam + "=" + alias + "&" + _features_config_6.refQueryParam + "=" + customersRef;
                });
            };
            _this.createLinkWithRefRep = function(alias) {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_representative-site-link_JS");
                retailInput.forEach(function(input) {
                    var hisAlias = localStorage.getItem("webAlias");
                    input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_6.aliasQueryParam + "=" + hisAlias + "&" + _features_config_6.refQueryParam + "=" + customersRef;
                });
            };
            return _this;
        }
        return StAccountPersonalSiteExtended;
    }(personal_site_1.StAccountPersonalSite);
    exports.StAccountPersonalSiteExtended = StAccountPersonalSiteExtended;
});

define("core/shopify-app/st-modules/referral/referral", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, st_module_21, notification_1, _features_config_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StReferral = void 0;
    var StReferral = function(_super) {
        __extends(StReferral, _super);
        function StReferral(generalMethods, objectFormatting, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Referral";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.checkTags();
                    _this_1.handlerRefBanner();
                });
            };
            _this_1.checkTags = function() {
                if (_features_config_7.shareRefCodeFunctionality) {
                    var customerTagsWrapper = document.querySelector(".st_customer-tags");
                    if (!!customerTagsWrapper) {
                        var tags = customerTagsWrapper.getAttribute("data-tags");
                        var isLogged = customerTagsWrapper.getAttribute("data-customer-id");
                        var splitStr = tags.split(",");
                        var retail = splitStr.find(function(ret) {
                            return ret.includes("retail");
                        });
                        var noOrder = splitStr.find(function(el) {
                            return el.includes("no_order");
                        });
                        if (isLogged) {
                            if (retail && noOrder) {
                                _this_1.getRefFromLink();
                                _this_1.setRefInLink();
                            } else {
                                _this_1.deleteRefCode();
                            }
                        } else {
                            _this_1.getRefFromLink();
                            _this_1.setRefInLink();
                        }
                    }
                } else {
                    _this_1.deleteRefCode();
                    _this_1.hideRef();
                }
            };
            _this_1.getRefFromLink = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var ref = urlParams.ref;
                if (!!ref && ref != 'shop') {
                    localStorage.setItem("ref", ref);
                }
            };
            _this_1.getCode = function() {
                var tagFromNav = document.querySelector(".st_referral-code-div_JS");
                if (!!tagFromNav) {
                    return tagFromNav.getAttribute("data-customer-tags");
                }
            };
            _this_1.setRefInLink = function() {
                var refCode = localStorage.getItem("ref");
                var refCodeFromTag = _this_1.getCode();
                if (!refCode || refCode === "null" || refCode === "shop" || refCode === " " || refCode === "undefined" || refCode === "") {
                    _this_1.deleteRefCode();
                } else {
                    if (refCode === refCodeFromTag) {
                        _this_1.deleteRefCode();
                    } else {
                        var params = new URLSearchParams(window.location.search);
                        if (!params.get("ref")) {
                            params.append("ref", refCode);
                        }
                        var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + params;
                        window.history.replaceState({
                            path: newUrl
                        }, "", newUrl);
                    }
                }
            };
            _this_1.deleteRefCode = function() {
                var params = new URLSearchParams(window.location.search);
                params.delete("ref");
                var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                if (!!params.toString()) {
                    newUrl += "?" + params;
                }
                window.history.replaceState({
                    path: newUrl
                }, "", newUrl);
                localStorage.removeItem("ref");
            };
            _this_1.handlerRefBanner = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var ref = urlParams.ref;
                if (_features_config_7.shareRefCodeFunctionality) {
                    if (!!ref) {
                        _this_1.getReferralsData();
                    } else {
                        _this_1.hideRef();
                    }
                } else {
                    _this_1.hideRef();
                }
            };
            _this_1.showRef = function() {
                var refWrapper = document.querySelector(".st_referred-by-banner_JS");
                if (!!refWrapper) {
                    if (refWrapper.classList.contains("st_hidden")) {
                        refWrapper.classList.remove("st_hidden");
                    }
                }
            };
            _this_1.hideRef = function() {
                var refWrapper = document.querySelector(".st_referred-by-banner_JS");
                if (!!refWrapper) {
                    if (!refWrapper.classList.contains("st_hidden")) {
                        refWrapper.classList.add("st_hidden");
                    }
                }
            };
            _this_1.getReferralsData = function() {
                var _this = _this_1;
                var referralCode = localStorage.getItem("ref");
                if (referralCode == 'shop') {
                    _this.deleteRefCode();
                }
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var als = urlParams.als;
                var refCode = {
                    promoCode: referralCode,
                    webAlias: als
                };
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["customer"]["getReferralInfo"],
                    method: "post",
                    contentType: "json",
                    data: refCode,
                    callback: function(response) {
                        try {
                            var getReferralInfo = JSON.parse(response.response);
                            if (getReferralInfo.status === 200) {
                                var refType = getReferralInfo.data.customerType;
                                if (refType === "retail") {
                                    _this.showRef();
                                    var fullname = getReferralInfo.data.firstName + " " + getReferralInfo.data.lastName;
                                    _this.writeRefName(fullname);
                                    if (getReferralInfo.data.customerSponsorMatch === false) {
                                        _this.deleteRefCode();
                                        _this.hideRef();
                                    }
                                }
                                if (refType === "representative") {
                                    if (getReferralInfo.data.customerSponsorMatch === false) {
                                        _this.deleteRefCode();
                                        _this.hideRef();
                                    }
                                }
                                if (refType === "") {
                                    console.log("INVALID REF CODE !!!!!!!!!!!");
                                    _this.deleteRefCode();
                                    _this.hideRef();
                                }
                            } else {
                                _this.notification.showNotification(notification_1.ENotificationType.error, "An Error Occurred", getReferralInfo.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_1.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.writeRefName = function(fullname) {
                var refNameSpan = document.querySelector(".st_referral-fullname_JS");
                if (!!refNameSpan) {
                    refNameSpan.innerHTML = fullname;
                }
            };
            _this_1.generalMethods = generalMethods;
            _this_1.objectFormatting = objectFormatting;
            _this_1.notification = notification;
            return _this_1;
        }
        return StReferral;
    }(st_module_21.StModule);
    exports.StReferral = StReferral;
});

define("extension/shopify-app/st-modules/cart/cart", [ "require", "exports", "core/shopify-app/st-modules/cart/cart", "_features.config" ], function(require, exports, cart_1, _features_config_8) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCartExtended = void 0;
    var StCartExtended = function(_super) {
        __extends(StCartExtended, _super);
        function StCartExtended(objectFormatting) {
            var _this = _super.call(this) || this;
            _this.className = "CartExtended";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    //_this.initCartSetup();
                    //_this.cartFetchInterceptorInit();
                });
            };
            _this.updateCartItemsProperies = function(alias) {
                _this.getCart(function(cartResponse) {
                    var _a;
                    var attributes = cartResponse.attributes;
                    attributes = __assign(__assign({}, attributes), {
                        sponsorWebAlias: !!alias ? alias : ""
                    });
                    var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                    var cref = urlParams[_features_config_8.refQueryParam];
                    if (!cref && attributes[_features_config_8.refQueryParam]) {
                        attributes = __assign(__assign({}, attributes), (_a = {}, 
                        _a[_features_config_8.refQueryParam] = "", _a));
                    }
                    var updateAttributes = {
                        attributes: attributes
                    };
                    _this.updateCartAttributesOrNote(updateAttributes, function(cartRes) {
                        var items = cartRes.items;
                        _this.processCartItemsRecursive(items, 0, alias);
                    });
                });
            };
            _this.updateCartProperty = function(propertyName, property, cb) {
                _this.getCart(function(cartResponse) {
                    var _a;
                    var attributes = cartResponse.attributes;
                    attributes = __assign(__assign({}, attributes), (_a = {}, _a[propertyName] = !!property ? property : "", 
                    _a));
                    var updateAttributes = {
                        attributes: attributes
                    };
                    _this.updateCartAttributesOrNote(updateAttributes, function(cartRes) {
                        cb();
                    });
                });
            };
            _this.removeCartProperty = function(propertyName, cb) {
                _this.getCart(function(cartResponse) {
                    var _a;
                    var attributes = cartResponse.attributes;
                    if (!!attributes[propertyName]) {
                        attributes = __assign(__assign({}, attributes), (_a = {}, 
                        _a[propertyName] = "", _a));
                        var updateAttributes = {
                            attributes: attributes
                        };
                        _this.updateCartAttributesOrNote(updateAttributes, function(cartRes) {
                            cb();
                        });
                    } else {
                        cb();
                    }
                });
            };
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        return StCartExtended;
    }(cart_1.StCart);
    exports.StCartExtended = StCartExtended;
});

define("extension/shopify-app/st-modules/general-table/general-table", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_22) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGeneralTable = void 0;
    var StGeneralTable = function(_super) {
        __extends(StGeneralTable, _super);
        function StGeneralTable() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StGeneralTable";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {});
            };
            _this.renderDOMElement = function(element, classNames, parentElement) {
                var newElement = document.createElement(element);
                newElement.className = classNames;
                parentElement.appendChild(newElement);
                return newElement;
            };
            _this.renderTableTitle = function(headTitle, parentContainer) {
                var tableHeaderContainer = _this.renderDOMElement("div", "st_table-title-wrapper", parentContainer);
                var tableHeader = _this.renderDOMElement("h2", "st_table-title", tableHeaderContainer);
                tableHeader.innerText = headTitle;
            };
            _this.renderTable = function(columnNames, data, parentContainer) {
                var tableContainer = _this.renderDOMElement("div", "st_table-container", parentContainer);
                _this.renderTableHead(columnNames, tableContainer);
                _this.renderTableContent(columnNames, data, tableContainer);
            };
            _this.renderTableHead = function(columnNames, parentContainer) {
                var headContainer = _this.renderDOMElement("div", "st_table-head-container", parentContainer);
                columnNames.forEach(function(columnName, index) {
                    var columnHead = _this.renderDOMElement("div", "st_table-head st_table-head--column-".concat(index), headContainer);
                    columnHead.innerText = columnName.displayText;
                });
            };
            _this.renderTableContent = function(columnNames, data, parentContainer) {
                var contentContainer = _this.renderDOMElement("div", "st_table-content-container", parentContainer);
                data.forEach(function(entry, index) {
                    _this.renderTableRow(columnNames, entry, index, contentContainer);
                });
            };
            _this.renderTableRow = function(columnNames, data, rowNumber, parentContainer) {
                var row = _this.renderDOMElement("div", "st_table-row st_table-row--".concat(rowNumber), parentContainer);
                columnNames.forEach(function(columnName, index) {
                    var rowColumn = _this.renderDOMElement("div", "st_table-column st_table-column--".concat(index), row);
                    rowColumn.innerHTML = data[columnName.key];
                });
            };
            return _this;
        }
        return StGeneralTable;
    }(st_module_22.StModule);
    exports.StGeneralTable = StGeneralTable;
});

define("extension/shopify-app/st-modules/referral/referral", [ "require", "exports", "core/shopify-app/st-modules/referral/referral", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, referral_1, notification_2, _features_config_9) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StReferralExtended = void 0;
    var StReferralExtended = function(_super) {
        __extends(StReferralExtended, _super);
        function StReferralExtended(generalMethods, objectFormatting, notification, customerType, webAlias, cart, generalTable) {
            var _this_1 = _super.call(this, generalMethods, objectFormatting, notification) || this;
            _this_1.className = "ReferralExtended";
            _this_1.canUseReferralFeature = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var ref = urlParams[_features_config_9.refQueryParam];
                var customerShopifyId = window.customerShopifyId.toString();
                return _features_config_9.shareRefCodeFunctionality && (_this_1.customerType.get() === _features_config_9.ECustomerType.retail || _this_1.customerType.get() === _features_config_9.ECustomerType.guest || _this_1.customerType.get() === _features_config_9.ECustomerType.noType) && ref !== customerShopifyId;
            };
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.referralFlow();
                    _this_1.getInitialPageCount();
                    _this_1.getReferredCustomers();
                    _this_1.copyRefToClipboard(".st_referral-link-copy-clipboard_JS", ".st_retail-personal-promo-code-ref-link_JS");
                });
            };
            _this_1.copyRefToClipboard = function(button, input) {
                var copyRepSiteButtonAll = document.querySelectorAll(button);
                if (!!copyRepSiteButtonAll) {
                    copyRepSiteButtonAll.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            var copyText = document.querySelectorAll(input);
                            if (!!copyText) {
                                copyText.forEach(function(input) {
                                    if (!!input) {
                                        input.select();
                                        input.setSelectionRange(0, 99999);
                                        navigator.clipboard.writeText(input.value);
                                        input.style.backgroundColor = "rgb(217, 218, 220)";
                                        input.style.transition = "0.2s";
                                        setTimeout(function() {
                                            input.style.backgroundColor = "rgb(249, 249, 249)";
                                        }, 1e3);
                                    }
                                });
                            }
                        });
                    });
                }
            };
            _this_1.referralFlow = function() {
                var _this = _this_1;
                if (_this_1.canUseReferralFeature()) {
                    var customerTagsWrapper = document.querySelectorAll(".st_customer-tags");
                    customerTagsWrapper.forEach(function(tag) {
                        if (!!tag) {
                            _this.getRefFromUrl();
                            _this.setRefInUrl();
                            _this.handlerRefBanner();
                        }
                    });
                } else {
                    _this_1.cart.removeCartProperty("cref", function() {
                        _this_1.deleteRefCode();
                        _this_1.hideRef();
                    });
                }
            };
            _this_1.getRefFromUrl = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var ref = urlParams[_features_config_9.refQueryParam];
                var als = urlParams[_features_config_9.aliasQueryParam];
                if (!!ref) {
                    localStorage.setItem(_features_config_9.refQueryParam, ref);
                } else if (!!als) {
                    _this_1.repSiteGuard = true;
                }
            };
            _this_1.setRefInUrl = function() {
                if (!_this_1.repSiteGuard) {
                    var refCode = localStorage.getItem(_features_config_9.refQueryParam);
                    var refCodeFromTag = _this_1.getCode();
                    if (!refCode || refCode === "null" || refCode === " " || refCode === "undefined" || refCode === "") {
                        _this_1.deleteRefCode();
                    } else {
                        if (refCode === refCodeFromTag) {
                            _this_1.deleteRefCode();
                        } else {
                            var params = new URLSearchParams(window.location.search);
                            if (!params.get(_features_config_9.refQueryParam)) {
                                params.append(_features_config_9.refQueryParam, refCode);
                            }
                            var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + params;
                            window.history.replaceState({
                                path: newUrl
                            }, "", newUrl);
                        }
                    }
                } else {
                    _this_1.cart.removeCartProperty("cref", function() {
                        _this_1.deleteRefCode();
                        _this_1.hideRef();
                        _this_1.repSiteGuard = true;
                    });
                }
            };
            _this_1.deleteRefCode = function() {
                var params = new URLSearchParams(window.location.search);
                params.delete(_features_config_9.refQueryParam);
                var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                if (!!params.toString()) {
                    newUrl += "?" + params;
                }
                window.history.replaceState({
                    path: newUrl
                }, "", newUrl);
                localStorage.removeItem(_features_config_9.refQueryParam);
            };
            _this_1.handlerRefBanner = function() {
                var cref = _this_1.objectFormatting.convertQueryStringToObject(window.location.search).cref;
                if (!!cref) {
                    var refCode = localStorage.getItem(_features_config_9.refQueryParam);
                    if (cref != refCode) {
                        _this_1.setCrefInLocalStorage();
                    }
                    _this_1.getReferralsData();
                } else {
                    _this_1.hideRef();
                }
            };
            _this_1.showRef = function() {
                var refWrappers = document.querySelectorAll(".st_referred-by-banner_JS");
                if (!!refWrappers) {
                    refWrappers.forEach(function(refWrapper) {
                        if (refWrapper.classList.contains("st_hidden")) {
                            refWrapper.classList.remove("st_hidden");
                        }
                    });
                }
            };
            _this_1.hideRef = function() {
                var refWrappers = document.querySelectorAll(".st_referred-by-banner_JS");
                if (!!refWrappers) {
                    refWrappers.forEach(function(refWrapper) {
                        if (!refWrapper.classList.contains("st_hidden")) {
                            refWrapper.classList.add("st_hidden");
                        }
                    });
                }
            };
            _this_1.getReferralsData = function() {
                var _this = _this_1;
                var refCode = localStorage.getItem(_features_config_9.refQueryParam);
                if (!refCode) {
                    var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                    refCode = urlParams[_features_config_9.refQueryParam];
                }
                var payload = {
                    referralCode: refCode
                };
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["webalias"]["getReferralInformation"],
                    method: "post",
                    contentType: "json",
                    data: payload,
                    callback: function(response) {
                        try {
                            var getReferralInfo_1 = JSON.parse(response.response);
                            if (getReferralInfo_1.status === 200) {
                                _this.setRefInUrl();
                                _this.showRef();
                                var fullname = getReferralInfo_1.data.referralFirstName + " " + getReferralInfo_1.data.referralLastName;
                                _this.writeRefName(fullname);
                                _this.cart.updateCartProperty("cref", getReferralInfo_1.data.referralCode, function() {
                                    var localStorageAlias = localStorage.getItem("webAlias");
                                    if (!localStorageAlias || localStorageAlias === _features_config_9.defaultWebAlias) {
                                        _this.webAlias.getCustomersRepresentativeInfo(getReferralInfo_1.data.referralSponsorWebAlias);
                                    }
                                });
                            } else {
                                _this.deleteRefCode();
                                _this.hideRef();
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_2.ENotificationType.error, "Server Error", error);
                            _this.deleteRefCode();
                            _this.hideRef();
                        }
                    }
                });
            };
            _this_1.writeRefName = function(fullname) {
                var refNameSpan = document.querySelectorAll(".st_referral-fullname_JS");
                if (!!refNameSpan) {
                    refNameSpan.forEach(function(refName) {
                        refName.innerHTML = fullname;
                    });
                }
            };
            _this_1.setCrefInLocalStorage = function() {
                var cref = _this_1.objectFormatting.convertQueryStringToObject(window.location.search).cref;
                if (!!cref) {
                    localStorage.setItem(_features_config_9.refQueryParam, cref);
                }
            };

            // TODO This should do nothing if Referrals are hidden.
            _this_1.getReferredCustomers = function(nextPage) {
                return;
                // var _this = _this_1;
                // var customerId = window.customerShopifyId;
                // try {
                //     _this_1.ajax.send({
                //         endpoint: _this_1.endpoint["customer"]["getReferredCustomers"],
                //         method: "post",
                //         contentType: "json",
                //         data: {
                //             referrerId: customerId,
                //             nextPage: nextPage !== null && nextPage !== void 0 ? nextPage : 0
                //         },
                //         callback: function(response) {
                //             try {
                //                 if (response.status === 200) {
                //                     var referralData = JSON.parse(response.response);
                //                     _this.renderReferralTable(referralData.data);
                //                     if (referralData.data.length === 0) return;
                //                 }
                //             } catch (error) {
                //                 console.log("getReferredCustomers-response Response Error ------\x3e" + error);
                //             }
                //         }
                //     });
                // } catch (error) {
                //     console.log("getReferredCustomers Request Error ------\x3e" + error);
                // }
            };
            // END This should do nothing if Referrals are hidden.

            _this_1.renderReferralTable = function(data) {
                var _a;
                var _this = _this_1;
                var referralCartTable = document.querySelector(".st_render-referral-table_JS");
                if (!!referralCartTable) {
                    referralCartTable.replaceChildren();
                    if (data.length === 0) {
                        var noSharedCarts = _this_1.generalTable.renderDOMElement("p", "", referralCartTable);
                        if (window.customerInfoMetafields.customerType !== _features_config_9.ECustomerType.retail) {
                            noSharedCarts.innerText = "There are no referrals to display.";
                        }
                        return;
                    }
                    var shareCartColumnMap = _this_1.returnReferralTableColumnMap();
                    var parsedData = _this_1.parseAllDatesToDateString(data, "DateAcquired");
                    parsedData = _this_1.addFooterColumn(parsedData, "ProductCredits", [ "", "", "", "Lifetime Acquired", "".concat((_a = _this_1.lifetimeAcquiredTotal) !== null && _a !== void 0 ? _a : "") ]);
                    parsedData = _this_1.parseAllProductCredits(parsedData, "ProductCredits");
                    _this_1.generalTable.renderTable(shareCartColumnMap, parsedData, referralCartTable);
                    var shareCartRowList = document.querySelectorAll(".st_table-row");
                    shareCartRowList.forEach(function(row, index) {
                        var rowIndex = _this.getRowIndexFromClass(row);
                        var columns = row.querySelectorAll(".st_table-column");
                        columns.forEach(function(column) {});
                    });
                }
            };
            _this_1.getRowIndexFromClass = function(element) {
                for (var _i = 0, _a = element.classList; _i < _a.length; _i++) {
                    var className = _a[_i];
                    if (className.startsWith("st_table-row--")) {
                        var numberPart = className.split("--")[1];
                        return parseInt(numberPart, 10);
                    }
                }
                return null;
            };
            _this_1.paintRows = function(row, rowIndex, colorOdd, colorEven) {
                if (!!row) {
                    if (rowIndex % 2 === 0) {
                        row.style.backgroundColor = colorEven;
                    } else {
                        row.style.backgroundColor = colorOdd;
                    }
                }
            };
            _this_1.parseAllDatesToDateString = function(tableData, fieldKey) {
                return tableData.map(function(rowData) {
                    var _a, _b;
                    if (rowData[fieldKey] === "") {
                        return __assign(__assign({}, rowData), (_a = {}, _a[fieldKey] = "date missing", 
                        _a));
                    } else {
                        var parsedDate = new Date(rowData[fieldKey]);
                        var tableDateFormat = parsedDate.toLocaleDateString();
                        return __assign(__assign({}, rowData), (_b = {}, _b[fieldKey] = tableDateFormat, 
                        _b));
                    }
                });
            };
            _this_1.formatDateToCustomDateString = function(date) {
                var dateString = date.toDateString();
                return dateString.slice(3, dateString.length - 5) + "," + dateString.slice(dateString.length - 5);
            };
            _this_1.renderReferralResponsiveTable = function(data) {
                var _this = _this_1;
                var referralTable = document.querySelector(".st_render-referral-table-responsive_JS");
                if (!referralTable) return;
                referralTable.replaceChildren();
                _this_1.generalTable.renderTableTitle("Referred Customers", referralTable);
                if (data.length === 0) {
                    var noSharedCarts = _this_1.generalTable.renderDOMElement("p", "", referralTable);
                    noSharedCarts.innerText = "There are no referred carts.";
                    return;
                }
                data.forEach(function(cart, index) {
                    var cartContainer = document.createElement("div");
                    cartContainer.className = "st_cart-row-wrapper";
                    cartContainer.style.maxWidth = "700px";
                    cartContainer.style.margin = "0 auto 16px";
                    var parsedDate = new Date(cart.DateAcquired);
                    var parsed_date = parsedDate.toLocaleString().split(",")[0];
                    _this_1.rowIntoReferralCardGenerator(cartContainer, index, cart, parsed_date);
                    referralTable.appendChild(cartContainer);
                    var wrapper = document.getElementById("cartBodyWrapper-".concat(index));
                    wrapper.style.maxHeight = wrapper.scrollHeight + "px";
                    wrapper.style.opacity = "1";
                });
            };
            _this_1.rowIntoReferralCardGenerator = function(cartContainer, index, cart, date) {
                cartContainer.innerHTML = '\n            <div class="cart-panel" id="cartPanel-'.concat(index, '">\n                <div class="cart-header">\n                    <h2>').concat(cart.ReferredName, '</h2>\n                    <div class="cart-id">#').concat(cart.ReferredId, '</div>\n                </div>\n                \n                <div class="cart-body-wrapper" id="cartBodyWrapper-').concat(index, '" style="max-height: 0; opacity: 0;">\n                   <div class="cart-body">\n                    <div class="cart-row">\n                      <label>Referred Customer ID</label>\n                      <div class="input-box">').concat(cart.ReferredId, '</div>\n                      <label>Referred Customer Name</label>\n                      <div class="input-box green">').concat(cart.ReferredName, '</div>\n                    </div>\n                    <div class="cart-row">\n                      <label>Creation Date</label>\n                      <div class="input-box">').concat(date, '</div>\n                    </div>\n                    <div class="cart-row">\n                      <label>Referred Customer Email</label>\n                      <div class="input-box">').concat(cart.ReferredEmail, "</div>\n                    </div>\n                  </div>\n                </div>\n            </div>\n        ");
            };

            // TODO This should do nothing if Referrals are hidden
            _this_1.getInitialPageCount = function() {
                return;
                // var _this = _this_1;
                // var customerId = window.customerShopifyId;
                // try {
                //     _this_1.ajax.send({
                //         endpoint: _this_1.endpoint["customer"]["getTotalPagesCountOfReferredCustomers"],
                //         method: "post",
                //         contentType: "json",
                //         data: {
                //             referrerId: customerId
                //         },
                //         callback: function(response) {
                //             try {
                //                 if (response.status === 200) {
                //                     var referralData = JSON.parse(response.response);
                //                     _this.totalPageCount = referralData.data.totalPages;
                //                     _this.lifetimeAcquiredTotal = referralData.data.creditsEarned;
                //                     if (!referralData.data.creditsEarned) return;
                //                     _this.renderPaginationButtons();
                //                 }
                //             } catch (error) {
                //                 console.log("getInitialPageCount-response Response Error ------\x3e" + error);
                //             }
                //         }
                //     });
                // } catch (error) {
                //     console.log("getInitialPageCount Request Error ------\x3e" + error);
                // }
            };
            // END This should do nothing if Referrals are hidden

            _this_1.renderPaginationButtons = function() {
                var _this = _this_1;
                var tableContainerElement = document.querySelector(".st_table-and-pagination-wrapper");
                if (document.querySelectorAll(".st_referral-table-pagination-wrapper")[0]) return;
                var paginationButtonsWrapper = document.createElement("div");
                paginationButtonsWrapper.className = "st_referral-table-pagination-wrapper";
                if (!tableContainerElement) return;
                var _loop_1 = function(i) {
                    var pageBtnElement = document.createElement("button");
                    pageBtnElement.id = "st_pagination-btn-page-".concat(i);
                    pageBtnElement.innerHTML = "".concat(i + 1);
                    pageBtnElement.classList.add("st_referral-table-pagination-btn");
                    if (i === _this.currentPage - 1) {
                        pageBtnElement.classList.add("st_active-page-highlight");
                    }
                    pageBtnElement.addEventListener("click", function() {
                        _this.getReferredCustomers(i);
                        _this.currentPage = i + 1;
                        var paginationButtons = document.querySelectorAll(".st_referral-table-pagination-btn");
                        paginationButtons.forEach(function(paginationButton) {
                            if (paginationButton.innerHTML === "".concat(i + 1)) {
                                paginationButton.classList.add("st_active-page-highlight");
                            } else {
                                paginationButton.classList.remove("st_active-page-highlight");
                            }
                        });
                    });
                    paginationButtonsWrapper.appendChild(pageBtnElement);
                };
                for (var i = 0; i <= _this_1.totalPageCount; i++) {
                    _loop_1(i);
                }
                tableContainerElement.appendChild(paginationButtonsWrapper);
            };
            _this_1.customerType = customerType;
            _this_1.webAlias = webAlias;
            _this_1.repSiteGuard = false;
            _this_1.cart = cart;
            _this_1.generalTable = generalTable;
            _this_1.totalPageCount = -1;
            _this_1.lifetimeAcquiredTotal = 0;
            _this_1.currentPage = 1;
            return _this_1;
        }
        StReferralExtended.prototype.returnReferralTableColumnMap = function() {
            return [ {
                displayText: "Referred Customer ID",
                key: "ReferredId"
            }, {
                displayText: "Referred Customer Name",
                key: "ReferredName"
            }, {
                displayText: "Referred Customer Email",
                key: "ReferredEmail"
            }, {
                displayText: "Date Acquired",
                key: "DateAcquired"
            }, {
                displayText: "Product Credits",
                key: "ProductCredits"
            } ];
        };
        StReferralExtended.prototype.parseAllProductCredits = function(tableData, fieldKey) {
            return tableData.map(function(rowData) {
                var _a, _b;
                if (rowData[fieldKey] === "") {
                    return __assign(__assign({}, rowData), (_a = {}, _a[fieldKey] = "credits missing", 
                    _a));
                } else {
                    var parsedProductCredits = rowData[fieldKey].toLocaleString("en-US", {
                        style: "currency",
                        currency: window.shopifyCartData.currency
                    });
                    if (parsedProductCredits.includes(".")) {
                        parsedProductCredits = parsedProductCredits.split(".")[0];
                    }
                    if (parsedProductCredits.includes(",")) {
                        parsedProductCredits = parsedProductCredits.split(",")[0];
                    }
                    return __assign(__assign({}, rowData), (_b = {}, _b[fieldKey] = parsedProductCredits, 
                    _b));
                }
            });
        };
        StReferralExtended.prototype.addFooterColumn = function(tableData, fieldKey, footerData) {
            var totalCredits = footerData[footerData.length - 1].length !== 0 ? parseInt(footerData[footerData.length - 1]) : 0;
            var parsedFooterData = {};
            var keys = Object.keys(tableData[0]);
            if (totalCredits === 0) {
                tableData.forEach(function(rowData) {
                    totalCredits += rowData[fieldKey];
                });
            }
            footerData[footerData.length - 1] = totalCredits.toLocaleString("en-US", {
                style: "currency",
                currency: window.shopifyCartData.currency
            });
            keys.forEach(function(key, index) {
                var _a;
                parsedFooterData = __assign(__assign({}, parsedFooterData), (_a = {}, 
                _a[key] = footerData[index], _a));
            });
            tableData.push(parsedFooterData);
            return tableData;
        };
        return StReferralExtended;
    }(referral_1.StReferral);
    exports.StReferralExtended = StReferralExtended;
});

define("core/connector-app/_shared/models/search-sponsor/search.sponsor.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_23, _features_config_10) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsor = void 0;
    var SponsorRequestType;
    (function(SponsorRequestType) {
        SponsorRequestType[SponsorRequestType["GET_BY_ID_OR_ALIAS"] = 0] = "GET_BY_ID_OR_ALIAS";
        SponsorRequestType[SponsorRequestType["GET_BY_PERSONAL_INFORMATION"] = 1] = "GET_BY_PERSONAL_INFORMATION";
    })(SponsorRequestType || (SponsorRequestType = {}));
    var StSearchSponsor = function(_super) {
        __extends(StSearchSponsor, _super);
        function StSearchSponsor(generalMethods, objectFormatting, browserHistory, classConfig, cookies, cart, sponsorService) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "SearchSponsor";
            _this_1.endpointString = [ "getSponsorInfo", "getSponsorByPersonalInfo" ];
            _this_1.MIN_CHAR_SEARCH_REQUIREMENT = 2;
            _this_1.REQUEST_DELAY = 1e3;
            _this_1.inputValue = "";
            _this_1.cookieNameWebAlias = "webAlias";
            _this_1.cookieNameRepId = "repId";
            _this_1.cookieNameFirstName = "firstName";
            _this_1.cookieNameLastName = "lastName";
            _this_1.retryWebAliasFetch = false;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.initSearchBoxFunctionality();
                    _this_1.initRadioButtons();
                    _this_1.windowClick();
                    _this_1.triggerVisibilityOfSection();
                    _this_1.cart.subscribeRenderCart(function(callback) {
                        _this_1.changeCartEvents();
                    });
                });
            };
            _this_1.loaderOn = function(triggerBtn) {
                var label = _this_1.generalMethods.getClosestByTag(triggerBtn, "label");
                if (!!label && !label.classList.contains("st_loader-active")) {
                    label.classList.add("st_loader-active");
                }
            };
            _this_1.loaderOff = function(triggerBtn) {
                var label = _this_1.generalMethods.getClosestByTag(triggerBtn, "label");
                if (!!label && label.classList.contains("st_loader-active")) {
                    label.classList.remove("st_loader-active");
                }
            };
            _this_1.changeCartEvents = function() {
                _this_1.initSearchBoxFunctionality();
                _this_1.initRadioButtons();
                _this_1.triggerVisibilityOfSection();
            };
            _this_1.setRepCookies = function(repInfo) {
                _this_1.cookies.setCookies(_this_1.cookieNameWebAlias, repInfo.webAlias);
                _this_1.cookies.setCookies(_this_1.cookieNameRepId, repInfo.repId);
                _this_1.cookies.setCookies(_this_1.cookieNameFirstName, repInfo.firstName);
                _this_1.cookies.setCookies(_this_1.cookieNameLastName, repInfo.lastName);
            };
            _this_1.triggerVisibilityOfSection = function() {
                var searchSponsorWrappers = document.querySelectorAll(_this_1.classConfig.selectorSearchSponsorWrapperPage);
                searchSponsorWrappers === null || searchSponsorWrappers === void 0 ? void 0 : searchSponsorWrappers.forEach(function(searchSponsorWrapper) {
                    var customerType = window.customerInfoMetafields.customerType;
                    if (customerType == _features_config_10.ECustomerType.retail && _features_config_10.lockedRepresentativeSite || customerType == _features_config_10.ECustomerType.representative) {
                        var searchSponsorWrapperLink = searchSponsorWrapper.querySelector(_this_1.classConfig.selectorChangeSponsorWrapperLink);
                        searchSponsorWrapperLink === null || searchSponsorWrapperLink === void 0 ? void 0 : searchSponsorWrapperLink.classList.add("st_hidden");
                    } else {
                        var triggerForOpenSearchInput = searchSponsorWrapper.querySelector(_this_1.classConfig.selectorChangeSponsorWrapper);
                        triggerForOpenSearchInput === null || triggerForOpenSearchInput === void 0 ? void 0 : triggerForOpenSearchInput.addEventListener("click", function(e) {
                            e.preventDefault();
                            searchSponsorWrappers.forEach(function(wrapper) {
                                _this_1.defaultVisibility(wrapper);
                            });
                            _this_1.showSearchInput(searchSponsorWrapper);
                            _this_1.hideSearchResults(searchSponsorWrapper);
                        });
                        _this_1.nonSponsors(searchSponsorWrapper);
                    }
                });
            };
            _this_1.nonSponsors = function(searchSponsorWrapper) {
                var triggerForDefaultSponsorInput = searchSponsorWrapper.querySelector(_this_1.classConfig.selectorNonSponsor);
                triggerForDefaultSponsorInput === null || triggerForDefaultSponsorInput === void 0 ? void 0 : triggerForDefaultSponsorInput.addEventListener("click", function() {
                    _this_1.updateUrl(_features_config_10.defaultWebAlias);
                    _this_1.defaultVisibility(searchSponsorWrapper);
                    _this_1.getSponsorInfo(_features_config_10.defaultWebAlias);
                    _this_1.setSponsorWebAliasToForm(_features_config_10.defaultWebAlias);
                    _this_1.setNewSponsorInfoToHeader(_features_config_10.corporationName, "", _features_config_10.defaultWebAlias);
                });
            };
            _this_1.updateUrl = function(newAlias) {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var u = urlParams.u;
                if (u !== newAlias) {
                    urlParams = __assign(__assign({}, urlParams), {
                        u: newAlias
                    });
                    var newURL = window.location.href.replace(window.location.search, "");
                    _this_1.cart.updateCartItemsProperies(newAlias);
                    _this_1.browserHistory.pushHistory(newURL, urlParams);
                }
            };
            _this_1.windowClick = function() {
                document.addEventListener("click", function(e) {
                    var searchSponsorsResult = document.querySelector(_this_1.classConfig.selectorChooseSponsor);
                    if (!!searchSponsorsResult) {
                        if (!_this_1.generalMethods.getClosestByClass(e.target, "st_search-input-and-result")) {
                            var sponsorWrappers = document.querySelectorAll(_this_1.classConfig.selectorSearchSponsorWrapperPage);
                            sponsorWrappers === null || sponsorWrappers === void 0 ? void 0 : sponsorWrappers.forEach(function(sponsorWrapper) {
                                _this_1.clearSponsorSuggestions(sponsorWrapper);
                            });
                        }
                    }
                });
            };
            _this_1.defaultVisibility = function(searchSponsorWrapper) {
                if (!!searchSponsorWrapper) {
                    _this_1.hideSearchInput(searchSponsorWrapper);
                    _this_1.showSearchResults(searchSponsorWrapper);
                }
            };
            _this_1.setSponsorWebAliasToForm = function(alias) {
                if (_features_config_10.canGoUnderCorporateSite || !_features_config_10.canGoUnderCorporateSite && alias !== _features_config_10.defaultWebAlias) {
                    var sponsorWebAliasFields = document.querySelectorAll(_this_1.classConfig.selectorRepresentativeAlias);
                    sponsorWebAliasFields === null || sponsorWebAliasFields === void 0 ? void 0 : sponsorWebAliasFields.forEach(function(field) {
                        _this_1.appendValueToField(field, alias);
                    });
                }
            };
            _this_1.getSponsorInfo = function(sponsorIdOrAlias, retryCount) {

                if (!sponsorIdOrAlias) return;

                if (retryCount === void 0) {
                    retryCount = 0;
                }
                if (retryCount >= 3) {
                    return;
                }
                var _this = _this_1;
                _this_1.loadersOnForSponsorInfo();
                //console.log(`in getSponsorInfo, ${sponsorIdOrAlias}`);
                _this_1.sponsorService.getSponsorInfo(sponsorIdOrAlias, function(request) {
                    try {
                        if (request.status === 200) {
                            var sponsorInfoResponse = JSON.parse(request.response);
                            var sponsorInformation = sponsorInfoResponse.data.sponsors[0];
                            if (!sponsorInformation.webAlias && sponsorInformation.webAlias === "") {
                                sponsorInformation.webAlias = sponsorInformation.repId;
                            }
                            _this.setRepCookies(sponsorInformation);
                            _this.injectSponsorInfo(sponsorInformation);
                            var shoppingWith = document.querySelectorAll(".st_representative-fullname_JS");
                            var shoppingWIthInputs = document.querySelectorAll(".st_representative-fullname-input_JS");
                            var sponsorEmailInput = document.querySelectorAll("input.st_representative-sponsorEmail_JS");
                            var fullName = sponsorInformation.firstName + " " + sponsorInformation.lastName;
                            var sponsorEmail = sponsorInformation.email;
                            _this_1.appendValueToFields(shoppingWith, fullName);
                            _this_1.appendValueToFields(shoppingWIthInputs, fullName);
                            _this_1.appendValueToFields(sponsorEmailInput, sponsorEmail);
                            _this.hideShoppingWithBanner();
                            _this.checkWebAlias();
                        } else {
                            if (_this_1.retryWebAliasFetch) {
                                _this_1.retryWebAliasFetch = false;
                                _this_1.getSponsorInfo(_features_config_10.defaultWebAlias, ++retryCount);
                                _this.hideShoppingWithBanner();
                            }
                        }
                    } catch (error) {
                        _this.hideShoppingWithBanner();
                        console.log(error);
                        //_this_1.getSponsorInfo(_features_config_10.defaultWebAlias, ++retryCount);
                    }
                });
            };
            _this_1.checkWebAlias = function() {
                var url = new URL(window.location.href);
                var urlParam = url.searchParams.get("u");
                var checkboxes = document.querySelectorAll(".sc_toggle-consultant_JS");
                var sponsorsName = document.querySelectorAll(".sc_shopping-with-wrp_JS");
                if (!!checkboxes) {
                    checkboxes.forEach(function(checkbox) {
                        if (urlParam == _features_config_10.defaultWebAlias || !urlParam) {
                            checkbox.checked = false;
                            sponsorsName.forEach(function(sponsorName) {
                                //sponsorName.classList.add("st_hidden");
                            });
                        } else {
                            checkbox.checked = true;
                            sponsorsName.forEach(function(sponsorName) {
                                sponsorName.classList.remove("st_hidden");
                            });
                        }
                    });
                }
            };
            _this_1.appendValueToFields = function(fields, value) {
                fields.forEach(function(field) {
                    if (field.tagName.toLowerCase() === "input") {
                        field.value = value;
                    } else if (field.tagName.toLowerCase() === "a") {
                        field.setAttribute("href", value);
                    } else {
                        field.innerHTML = value;
                    }
                });
            };
            _this_1.hideShoppingWithBanner = function() {
                var url = new URL(window.location.href);
                var urlParam = url.searchParams.get("cref");
                var webAlias = localStorage.getItem("webAlias");
                var bannerWrapper = document.querySelectorAll(".st_representative-banner--wrapper_JS");
                if (!!bannerWrapper) {
                    if (webAlias == 'shop' || (webAlias == _features_config_10.defaultWebAlias && !urlParam)) {
                        bannerWrapper.forEach(function(wrp) {
                            return wrp.classList.add("st_hidden");
                        });
                    } else {
                        bannerWrapper.forEach(function(wrp) {
                            return wrp.classList.remove("st_hidden");
                        });
                    }
                }
            };
            _this_1.loadersOnForSponsorInfo = function() {
                var sponsorsData = document.querySelectorAll(_this_1.classConfig.selectorSponsorData);
                var svg = '<svg width="15" height="15" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#222" class="st_loader">\n                        <g fill="none" fill-rule="evenodd">\n                            <g transform="translate(1 1)" stroke-width="2">\n                                <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>\n                                <path d="M36 18c0-9.94-8.06-18-18-18">\n                                    <animateTransform\n                                            attributeName="transform"\n                                            type="rotate"\n                                            from="0 18 18"\n                                            to="360 18 18"\n                                            dur="1s"\n                                            repeatCount="indefinite"/>\n                                </path>\n                            </g>\n                        </g>\n                    </svg>';
                sponsorsData === null || sponsorsData === void 0 ? void 0 : sponsorsData.forEach(function(sponsorData) {
                    sponsorData.innerHTML = svg;
                });
            };
            _this_1.injectSponsorInfo = function(sponsorInformation) {
                var sponsorIdFields = document.querySelectorAll(_this_1.classConfig.selectorSponsorId);
                var sponsorAliasFields = document.querySelectorAll(_this_1.classConfig.selectorSponsorAlias);
                var sponsorFullNameFields = document.querySelectorAll(_this_1.classConfig.selectorSponsorFullName);
                var sponsorInitialsFields = document.querySelectorAll(_this_1.classConfig.selectorSponsorInitials);
                var sponsorAddressFields = document.querySelectorAll(_this_1.classConfig.selectorSponsorAddress);
                _this_1.injectTextIntoFields(sponsorIdFields, sponsorInformation.repId);
                _this_1.injectTextIntoFields(sponsorAliasFields, sponsorInformation.webAlias);
                _this_1.injectTextIntoFields(sponsorFullNameFields, "".concat(sponsorInformation.firstName, " ").concat(sponsorInformation.lastName));
                _this_1.injectTextIntoFields(sponsorInitialsFields, "".concat(sponsorInformation.firstName.charAt(0)).concat(sponsorInformation.lastName.charAt(0)));
                var address = sponsorInformation.address.state && sponsorInformation.address.state !== "" ? sponsorInformation.address.state + ", " + sponsorInformation.address.city : sponsorInformation.address.city;
                _this_1.injectTextIntoFields(sponsorAddressFields, address);
            };
            _this_1.searchSponsors = function(searchWrapper) {
                var input = searchWrapper.querySelector(_this_1.classConfig.selectorSearchSponsor);
                if (!!input) {
                    input.addEventListener("keyup", function(e) {
                        _this_1.getSponsors(input);
                    });
                    input.addEventListener("input", function(e) {
                        _this_1.getSponsors(input);
                    });
                    input.addEventListener("paste", function(e) {
                        _this_1.getSponsors(input);
                    });
                }
            };
            _this_1.getSponsors = function(input) {
                var value = input.value;
                if (_this_1.inputValue === value) return;
                if (value.length < _this_1.MIN_CHAR_SEARCH_REQUIREMENT) {
                    var searchSponsorInputWrapper = _this_1.generalMethods.getClosestByClass(input, _this_1.classConfig.classNameSearchInput);
                    _this_1.clearSponsorSuggestions(searchSponsorInputWrapper);
                    _this_1.enableRadioButtons(input);
                    return;
                }
                _this_1.inputValue = value;
                var requestType = _this_1.getCurrentRoute(input);
                _this_1.loaderOn(input);
                _this_1.disableRadioButtons(input);
                if (requestType === SponsorRequestType.GET_BY_ID_OR_ALIAS) {
                    _this_1.subscribeToTimeout(input, function() {
                        _this_1.sponsorService.getSponsorInfo(value, function(request) {
                            return _this_1.handleGetSponsorsResponse(request, input);
                        });
                    });
                }
                if (requestType === SponsorRequestType.GET_BY_PERSONAL_INFORMATION) {
                    _this_1.subscribeToTimeout(input, function() {
                        _this_1.sponsorService.getSponsorByPersonalInfo(value, function(request) {
                            return _this_1.handleGetSponsorsResponse(request, input);
                        });
                    });
                }
            };
            _this_1.getCurrentRoute = function(input) {
                var route;
                var sponsorWrapper = _this_1.generalMethods.getClosestByClass(input, _this_1.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper === null || sponsorWrapper === void 0 ? void 0 : sponsorWrapper.querySelectorAll(_this_1.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton, index) {
                    if (radioButton.classList.contains("st_checked")) {
                        route = index;
                    }
                });
                return route;
            };
            _this_1.enableRadioButtons = function(input) {
                var sponsorWrapper = _this_1.generalMethods.getClosestByClass(input, _this_1.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper === null || sponsorWrapper === void 0 ? void 0 : sponsorWrapper.querySelectorAll(_this_1.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                    radioButton.removeAttribute("disabled");
                });
            };
            _this_1.disableRadioButtons = function(input) {
                var sponsorWrapper = _this_1.generalMethods.getClosestByClass(input, _this_1.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper === null || sponsorWrapper === void 0 ? void 0 : sponsorWrapper.querySelectorAll(_this_1.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                    radioButton.setAttribute("disabled", "disabled");
                });
            };
            _this_1.initRadioButtons = function() {
                var radioButtonsWrappers = document.querySelectorAll(_this_1.classConfig.selectorSearchInput);
                radioButtonsWrappers === null || radioButtonsWrappers === void 0 ? void 0 : radioButtonsWrappers.forEach(function(radioButtonsWrapper) {
                    var radioButtons = radioButtonsWrapper.querySelectorAll(_this_1.classConfig.selectorSearchSponsorBy);
                    radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(input) {
                        input.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this_1.handleRadioButtonStatusChange(radioButtons, radioButtonsWrapper);
                            _this_1.clearSearchSponsorInputValueAndSuggestions(input);
                        });
                    });
                });
            };
            _this_1.setChecked = function(element) {
                if (!element.classList.contains("st_checked")) {
                    element.classList.add("st_checked");
                }
                element.setAttribute("checked", "checked");
            };
            _this_1.removeChecked = function(element) {
                if (element.classList.contains("st_checked")) {
                    element.classList.remove("st_checked");
                }
                element.removeAttribute("checked");
            };
            _this_1.renderPlaceholderText = function(radioButton, wrapper) {
                var label = _this_1.generalMethods.getClosestByTag(radioButton, "label");
                var text = label.querySelector(_this_1.classConfig.selectorRadioText).textContent;
                var placeholder = wrapper.querySelector(".st_search-input .st_placeholder-text");
                placeholder.innerHTML = text;
            };
            _this_1.clearSearchSponsorInputValueAndSuggestions = function(input) {
                var searchSponsorWrapper = _this_1.generalMethods.getClosestByClass(input, _this_1.classConfig.classNameSearchInput);
                if (!!searchSponsorWrapper) {
                    _this_1.clearSearchSponsorInputValue(searchSponsorWrapper);
                    _this_1.clearSponsorSuggestions(searchSponsorWrapper);
                }
            };
            _this_1.clearSearchSponsorInputValue = function(searchSponsorWrapper) {
                var searchSponsorInput = searchSponsorWrapper === null || searchSponsorWrapper === void 0 ? void 0 : searchSponsorWrapper.querySelector(_this_1.classConfig.selectorSearchSponsor);
                if (!!searchSponsorInput) {
                    searchSponsorInput.value = "";
                    searchSponsorInput.replaceChildren();
                }
            };
            _this_1.clearSponsorSuggestions = function(searchSponsorWrapper) {
                var searchSponsorResult = searchSponsorWrapper === null || searchSponsorWrapper === void 0 ? void 0 : searchSponsorWrapper.querySelector(_this_1.classConfig.selectorFoundSponsor);
                searchSponsorResult === null || searchSponsorResult === void 0 ? void 0 : searchSponsorResult.replaceChildren();
            };
            _this_1.renderSuggestionsWrapper = function(sponsorsList, input) {
                var sponsorsInputWrapper = _this_1.generalMethods.getClosestByClass(input, _this_1.classConfig.classNameSearchInput);
                if (!!sponsorsInputWrapper) {
                    var sponsorsWrapper_1 = sponsorsInputWrapper.querySelector(_this_1.classConfig.selectorFoundSponsor);
                    if (!!sponsorsWrapper_1) {
                        sponsorsWrapper_1.classList.remove("st_hidden");
                        sponsorsWrapper_1.replaceChildren();
                        sponsorsList === null || sponsorsList === void 0 ? void 0 : sponsorsList.forEach(function(sponsor) {
                            var sponsorJson = JSON.stringify(sponsor);
                            var buttonWithSponsorInfo = _this_1.createDOMElement("button", "st_search-sponsor-button--result st_choose-sponsor_JS", sponsorsWrapper_1);
                            buttonWithSponsorInfo.setAttribute("type", "button");
                            buttonWithSponsorInfo.setAttribute("data-sponsor-info", sponsorJson);
                            var leftPart = _this_1.createDOMElement("span", "st_result-left-part", buttonWithSponsorInfo);
                            var addressPart = _this_1.createDOMElement("span", "st_result-address", buttonWithSponsorInfo);
                            var credentialsSection = _this_1.createDOMElement("span", "st_account-sponsor-credentials-section", leftPart);
                            var sponsorResultName = _this_1.createDOMElement("span", "st_result-name", leftPart);
                            var addressPartData = _this_1.createDOMElement("span", "st_sponsor-address_JS", addressPart);
                            var state = sponsor.address.state;
                            var city = sponsor.address.city;
                            var address = state && state !== "" ? state + ", " + city : city;
                            addressPartData.innerHTML = address;
                            var initialsSection = _this_1.createDOMElement("span", "st_account-sponsor-initials", credentialsSection);
                            var initialsJSSection = _this_1.createDOMElement("span", "st_sponsor-initials_JS", initialsSection);
                            initialsJSSection.innerHTML = "".concat(sponsor.firstName.charAt(0)).concat(sponsor.lastName.charAt(0));
                            var colWrapper = _this_1.createDOMElement("span", "st_span-full-width", sponsorResultName);
                            var fullName = _this_1.createDOMElement("span", "st_sponsor-fullname_JS", colWrapper);
                            fullName.innerHTML = sponsor.firstName + " " + sponsor.lastName;
                            var sponsorIdWrapper = _this_1.createDOMElement("span", "st_sponsor-id", colWrapper);
                            var sponsorIdNumber = _this_1.createDOMElement("span", "st_sponsor-id_JS", sponsorIdWrapper);
                            sponsorIdNumber.innerHTML = " (ID: " + sponsor.repId + ")";
                            var aliasWrapper = _this_1.createDOMElement("span", "st_sponsor-alias", sponsorResultName);
                            var aliasWrapperData = _this_1.createDOMElement("span", "st_sponsor-alias_JS", aliasWrapper);
                            aliasWrapperData.innerHTML = sponsor.webAlias;
                        });
                    }
                    _this_1.chooseSponsor(sponsorsInputWrapper);
                }
            };
            _this_1.createDOMElement = function(element, classNames, parentElement) {
                var newElement = document.createElement(element);
                newElement.className = classNames;
                parentElement.appendChild(newElement);
                return newElement;
            };
            _this_1.chooseSponsor = function(sponsorsInputWrapper) {
                var sponsorButtons = sponsorsInputWrapper.querySelectorAll(_this_1.classConfig.selectorChooseSponsor);
                sponsorButtons === null || sponsorButtons === void 0 ? void 0 : sponsorButtons.forEach(function(sponsor) {
                    sponsor.addEventListener("click", function(e) {
                        e.preventDefault();
                        var newSponsorJson = sponsor.getAttribute("data-sponsor-info");
                        var newSponsor = JSON.parse(newSponsorJson);
                        var sponsorWrappers = document.querySelectorAll(_this_1.classConfig.selectorSearchSponsorWrapperPage);
                        sponsorWrappers === null || sponsorWrappers === void 0 ? void 0 : sponsorWrappers.forEach(function(sponsorWrapper) {
                            _this_1.defaultVisibility(sponsorWrapper);
                        });
                        _this_1.updateUrl(newSponsor.webAlias);
                        _this_1.clearSearchSponsorInputValueAndSuggestions(e.target);
                        _this_1.injectSponsorInfo(newSponsor);
                        _this_1.setRepCookies(newSponsor);
                        _this_1.setSponsorWebAliasToForm(newSponsor.webAlias);
                        _this_1.setNewSponsorInfoToHeader(newSponsor.firstName, newSponsor.lastName, newSponsor.webAlias);
                        window.dispatchEvent(new Event("sponsorChange"));
                    });
                });
            };
            _this_1.setNewSponsorInfoToHeader = function(repFirstName, repLastName, webAlias) {
                var repFullNameFields = document.querySelectorAll(_this_1.classConfig.selectorRepresentativeFullName);
                var fullName = _this_1.getFullName(repFirstName, repLastName, webAlias);
                repFullNameFields === null || repFullNameFields === void 0 ? void 0 : repFullNameFields.forEach(function(field) {
                    _this_1.appendValueToField(field, fullName);
                });
            };
            _this_1.appendValueToField = function(field, value) {
                if (field.tagName.toLowerCase() === "input") {
                    field.value = value;
                } else {
                    field.innerHTML = value;
                }
            };
            _this_1.hideSuggestionsWrapper = function(input) {
                var sponsorsInputWrapper = _this_1.generalMethods.getClosestByClass(input, _this_1.classConfig.classNameSearchInput);
                var sponsorsWrapper = sponsorsInputWrapper === null || sponsorsInputWrapper === void 0 ? void 0 : sponsorsInputWrapper.querySelector(_this_1.classConfig.selectorFoundSponsor);
                sponsorsWrapper === null || sponsorsWrapper === void 0 ? void 0 : sponsorsWrapper.replaceChildren();
                sponsorsWrapper === null || sponsorsWrapper === void 0 ? void 0 : sponsorsWrapper.classList.add("st_hidden");
            };
            _this_1.generalMethods = generalMethods;
            _this_1.objectFormatting = objectFormatting;
            _this_1.browserHistory = browserHistory;
            _this_1.classConfig = classConfig;
            _this_1.cookies = cookies;
            _this_1.cart = cart;
            _this_1.sponsorService = sponsorService;
            return _this_1;
        }
        StSearchSponsor.prototype.hideSearchResults = function(searchWrapper) {
            var searchResult = searchWrapper.querySelector(this.classConfig.selectorSearchResult);
            if (!(searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.contains("st_hidden"))) {
                searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.add("st_hidden");
            }
        };
        StSearchSponsor.prototype.showSearchResults = function(searchWrapper) {
            var searchResult = searchWrapper.querySelector(this.classConfig.selectorSearchResult);
            if (searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.contains("st_hidden")) {
                searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.remove("st_hidden");
            }
        };
        StSearchSponsor.prototype.hideSearchInput = function(searchWrapper) {
            var searchInput = searchWrapper.querySelector(this.classConfig.selectorSearchInput);
            if (!(searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.contains("st_hidden"))) {
                searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.add("st_hidden");
            }
        };
        StSearchSponsor.prototype.showSearchInput = function(searchWrapper) {
            var searchInput = searchWrapper.querySelector(this.classConfig.selectorSearchInput);
            if (searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.contains("st_hidden")) {
                searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.remove("st_hidden");
            }
        };
        StSearchSponsor.prototype.initSearchBoxFunctionality = function() {
            var _this_1 = this;
            var searchWrappers = document.querySelectorAll(this.classConfig.selectorSearchSponsorWrapperPage);
            if (searchWrappers.length > 0) {
                var customerID = window.customerInfoMetafields.customerId;
                var sponsorRepID = window.customerInfoMetafields.representativeId;
                var customerType = window.customerInfoMetafields.customerType;
                var repSite = void 0;
                if (!!customerID && _features_config_10.lockedRepresentativeSite && customerType !== _features_config_10.ECustomerType.noType) {
                    repSite = customerType === _features_config_10.ECustomerType.representative ? customerID : sponsorRepID;
                } else {
                    var webAlias = this.objectFormatting.convertQueryStringToObject(window.location.search);
                    if (!!webAlias.u) {
                        repSite = webAlias.u;
                    } else {
                        if (!!this.cookies.getCookie("webAlias")) {
                            repSite = this.cookies.getCookie("webAlias");
                        }
                    }
                }
                this.getSponsorInfo(repSite);
            }
            searchWrappers === null || searchWrappers === void 0 ? void 0 : searchWrappers.forEach(function(wrapper) {
                _this_1.searchSponsors(wrapper);
            });
        };
        StSearchSponsor.prototype.injectTextIntoFields = function(fields, text) {
            fields === null || fields === void 0 ? void 0 : fields.forEach(function(field) {
                field.innerHTML = text;
            });
        };
        StSearchSponsor.prototype.subscribeToTimeout = function(input, request) {
            var value = input.value;
            if (value.length > 1) {
                clearTimeout(this.requestTimeout);
                this.requestTimeout = setTimeout(request, this.REQUEST_DELAY);
            } else {
                var searchSponsorInputWrapper = this.generalMethods.getClosestByClass(input, this.classConfig.classNameSearchInput);
                this.clearSponsorSuggestions(searchSponsorInputWrapper);
                this.enableRadioButtons(input);
            }
        };
        StSearchSponsor.prototype.handleGetSponsorsResponse = function(request, input) {
            var res = JSON.parse(request.response);
            if (res.status === 200) {
                var sponsorsList = res.data.sponsors;
                if (sponsorsList.length > 0) {
                    this.loaderOff(input);
                    this.enableRadioButtons(input);
                    this.renderSuggestionsWrapper(sponsorsList, input);
                } else {
                    this.loaderOff(input);
                    this.enableRadioButtons(input);
                    this.hideSuggestionsWrapper(input);
                }
            } else {
                this.loaderOff(input);
                this.enableRadioButtons(input);
                this.hideSuggestionsWrapper(input);
            }
        };
        StSearchSponsor.prototype.handleRadioButtonStatusChange = function(radioButtons, radioButtonsWrapper) {
            var _this_1 = this;
            radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                if (!!radioButton.checked) {
                    _this_1.setChecked(radioButton);
                } else {
                    _this_1.removeChecked(radioButton);
                }
            });
        };
        StSearchSponsor.prototype.getFullName = function(repFirstName, repLastName, webAlias) {
            var fullName = !!repLastName ? repFirstName : "";
            fullName = !!repLastName ? fullName.concat(" ".concat(repLastName)) : fullName;
            if (webAlias === _features_config_10.defaultWebAlias) fullName = _features_config_10.corporationName;
            return fullName;
        };
        return StSearchSponsor;
    }(st_module_23.StModule);
    exports.StSearchSponsor = StSearchSponsor;
});

define("extension/shopify-app/st-modules/search-sponsor/sponsor-search-class-config", [ "require", "exports", "core/shopify-app/st-modules/search-sponsor/sponsor-search-class-config" ], function(require, exports, sponsor_search_class_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorClassConfigExtended = void 0;
    var StSearchSponsorClassConfigExtended = function(_super) {
        __extends(StSearchSponsorClassConfigExtended, _super);
        function StSearchSponsorClassConfigExtended() {
            var _this = _super.call(this) || this;
            _this.className = "SearchSponsorClassConfigExtended";
            _this.classNameSearchSponsorButton = "st_change-consultant_JS";
            _this.selectorSearchSponsorButton = "." + _this.classNameSearchSponsorButton;
            _this.classNameModalWrp = "st_search-sponsor-modal-wrp_JS";
            _this.selectorModalWrp = "." + _this.classNameModalWrp;
            _this.classNameModalClose = "st_search-sponsor-modal-close_JS";
            _this.selectorModalClose = "." + _this.classNameModalClose;
            return _this;
        }
        return StSearchSponsorClassConfigExtended;
    }(sponsor_search_class_config_1.StSearchSponsorClassConfig);
    exports.StSearchSponsorClassConfigExtended = StSearchSponsorClassConfigExtended;
});

define("extension/shopify-app/st-modules/search-sponsor/search-sponsor", [ "require", "exports", "core/shopify-app/st-modules/search-sponsor/search-sponsor", "_features.config" ], function(require, exports, search_sponsor_1, _features_config_11) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorExtended = void 0;
    var SponsorRequestType;
    (function(SponsorRequestType) {
        SponsorRequestType[SponsorRequestType["GET_BY_ID_OR_ALIAS"] = 0] = "GET_BY_ID_OR_ALIAS";
        SponsorRequestType[SponsorRequestType["GET_BY_PERSONAL_INFORMATION"] = 1] = "GET_BY_PERSONAL_INFORMATION";
    })(SponsorRequestType || (SponsorRequestType = {}));
    var StSearchSponsorExtended = function(_super) {
        __extends(StSearchSponsorExtended, _super);
        function StSearchSponsorExtended(generalMethods, objectFormatting, browserHistory, classConfig, cookies, cart, sponsorService) {
            var _this_1 = _super.call(this, generalMethods, objectFormatting, browserHistory, classConfig, cookies, cart, sponsorService) || this;
            _this_1.className = "SearchSponsorExtended";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.onSearchSponsorBtnClick();
                    _this_1.onModalClose();
                    _this_1.initSearchBoxFunctionality();
                    _this_1.initRadioButtons();
                    _this_1.windowClick();
                    _this_1.triggerVisibilityOfSection();
                    _this_1.cart.subscribeRenderCart(function(callback) {
                        _this_1.changeCartEvents();
                    });
                    _this_1.expandCart();
                });
            };
            _this_1.onSearchSponsorBtnClick = function() {
                var searchSponsorButtons = document.querySelectorAll(_this_1.classConfig.selectorSearchSponsorButton);
                var modalWrp = document.querySelector(_this_1.classConfig.selectorModalWrp);
                if (!!searchSponsorButtons) {
                    searchSponsorButtons.forEach(function(button) {
                        button.addEventListener("click", function(e) {
                            e.preventDefault();
                            if (!!modalWrp) {
                                modalWrp.classList.remove("st_hidden");
                                var body = document.querySelector("body");
                                body.classList.add("st_hide-scroll");
                            }
                        });
                    });
                }
            };
            _this_1.onModalClose = function() {
                var _this = _this_1;
                var modalCloseBtn = document.querySelectorAll(_this_1.classConfig.selectorModalClose);
                if (!!modalCloseBtn) {
                    modalCloseBtn.forEach(function(button) {
                        button.addEventListener("click", function(e) {
                            e.preventDefault();
                            var modalWrp = document.querySelector(_this_1.classConfig.selectorModalWrp);
                            if (modalWrp) {
                                modalWrp.classList.add("st_hidden");
                                var body = document.querySelector("body");
                                body.classList.remove("st_hide-scroll");
                                _this.clearConsultantsList();
                            }
                        });
                    });
                }
            };
            _this_1.updateUrl = function(newAlias) {
                var _a;
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var u = urlParams.u;
                if (u !== newAlias) {
                    urlParams = __assign(__assign({}, urlParams), (_a = {}, _a[_features_config_11.aliasQueryParam] = newAlias, 
                    _a));
                    var newURL = window.location.href.replace(window.location.search, "");
                    _this_1.cart.updateCartItemsProperies(newAlias);
                    _this_1.browserHistory.pushHistory(newURL, urlParams);
                }
            };
            _this_1.expandCart = function() {
                var _a, _b;
                (_a = document.querySelectorAll(".st_expand-btn")) === null || _a === void 0 ? void 0 : _a.forEach(function(btn) {
                    btn === null || btn === void 0 ? void 0 : btn.addEventListener("click", function(e) {
                        var _a, _b;
                        e.preventDefault();
                        (_a = document.querySelectorAll(".st_consultant-card")) === null || _a === void 0 ? void 0 : _a.forEach(function(card) {
                            return card.classList.remove("expanded");
                        });
                        var id = this.getAttribute("data-id");
                        (_b = document.querySelector('.st_consultant-card[data-id="'.concat(id, '"]'))) === null || _b === void 0 ? void 0 : _b.classList.add("expanded");
                    });
                });
                (_b = document.querySelectorAll(".st_close-btn")) === null || _b === void 0 ? void 0 : _b.forEach(function(btn) {
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var id = this.getAttribute("data-id");
                        document.querySelector('.st_consultant-card[data-id="'.concat(id, '"]')).classList.remove("expanded");
                    });
                });
            };
            _this_1.searchSponsors = function(searchWrapper) {
                var _this = _this_1;
                var input = searchWrapper.querySelector(".st_search-sponsor-input_JS");
                var btn = searchWrapper.querySelector(".st_search-sponsor-search-btn_JS");
                if (!!input) {
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.clearConsultantsList();
                        _this.disableSearchBtn();
                        _this.getSponsors(input);
                    });
                }
            };
            _this_1.disableSearchBtn = function() {
                var btns = document.querySelectorAll(".st_search-sponsor-search-btn_JS");
                if (!!btns) {
                    btns.forEach(function(btn) {
                        btn.setAttribute("disabled", "disabled");
                        btn.style.opacity = "0.6";
                        btn.innerHTML = '<span class="sc_loader-search"></span>';
                    });
                }
            };
            _this_1.getCurrentRoute = function(input) {
                var route;
                var radioButtons = document.querySelectorAll(_this_1.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton, index) {
                    if (radioButton.classList.contains("st_checked")) {
                        route = index;
                    }
                });
                return route;
            };
            _this_1.getSponsors = function(input) {
                var value = input.value;
                if (value.length < _this_1.MIN_CHAR_SEARCH_REQUIREMENT || input.value == "" || input.value == null) {
                    _this_1.showCharacterMessage();
                    _this_1.enableRadioButtons(input);
                    _this_1.enableSearchBtn();
                    return;
                }
                _this_1.inputValue = value;
                var requestType = _this_1.getCurrentRoute(input);
                _this_1.loaderOn(input);
                _this_1.hideMessage();
                if (requestType === SponsorRequestType.GET_BY_ID_OR_ALIAS) {
                    _this_1.subscribeToTimeout(input, function() {
                        _this_1.sponsorService.getSponsorInfo(value, function(request) {
                            return _this_1.handleGetSponsorsResponse(request, input);
                        });
                    });
                }
                if (requestType === SponsorRequestType.GET_BY_PERSONAL_INFORMATION) {
                    _this_1.subscribeToTimeout(input, function() {
                        _this_1.sponsorService.getSponsorByPersonalInfo(value, function(request) {
                            return _this_1.handleGetSponsorsResponse(request, input);
                        });
                    });
                }
            };
            _this_1.showMessage = function() {
                var messages = document.querySelectorAll(".sc_search-sponsor-message_JS");
                if (!!messages) {
                    messages.forEach(function(msg) {
                        msg.classList.remove("st_hidden");
                        msg.innerHTML = "Consultant not found";
                    });
                }
            };
            _this_1.showCharacterMessage = function() {
                var messages = document.querySelectorAll(".sc_search-sponsor-message_JS");
                if (!!messages) {
                    messages.forEach(function(msg) {
                        msg.classList.remove("st_hidden");
                        msg.innerHTML = "Please enter at least 2 characters to search.";
                    });
                }
            };
            _this_1.hideMessage = function() {
                var messages = document.querySelectorAll(".sc_search-sponsor-message_JS");
                if (!!messages) {
                    messages.forEach(function(msg) {
                        msg.classList.add("st_hidden");
                    });
                }
            };
            _this_1.enableSearchBtn = function() {
                var btns = document.querySelectorAll(".st_search-sponsor-search-btn_JS");
                if (!!btns) {
                    btns.forEach(function(btn) {
                        btn.removeAttribute("disabled");
                        btn.style.opacity = "1";
                        btn.innerHTML = '<span class="search-icon">&#128269;</span>';
                    });
                }
            };
            _this_1.consultantCards = function(consultants) {
                var _this = _this_1;
                _this_1.enableSearchBtn();
                var output = [];
                consultants.forEach(function(consultant, index) {
                    var oneOfConsultants = _this.generatorConsultantCard(consultant, index);
                    output.push(oneOfConsultants);
                });
                return output;
            };
            _this_1.generatorConsultantCard = function(consultantData, index) {
                var cardID = index;
                var img = consultantData.imageUrl;
                if (!img || img == "") {
                    img = "https://" + location.host + "/cdn/shop/t/6/assets/search-consultant-placeholder-img.png";
                }
                var firstName = consultantData.firstName;
                var lastName = consultantData.lastName;
                var fullName = firstName + " " + lastName;
                if (!fullName || firstName == "" && lastName == "") {
                    fullName = "Name not found";
                }
                var address = consultantData.address.city + ", " + consultantData.address.state + ", " + consultantData.address.country;
                var email = consultantData.email;
                var phone = consultantData.phone;
                var webAlias = consultantData.webAlias;
                var url = new URL(window.location.href);
                var urlParamCref = url.searchParams.get("cref");
                var shoppingWith = "";
                var enrollUnder = "";
                if (urlParamCref == null || urlParamCref == "") {
                    shoppingWith = "https://" + location.host + "/?u=" + webAlias;
                    enrollUnder = "https://" + location.host + "/pages/join-as-a-consultant?u=" + webAlias;
                } else {
                    shoppingWith = "https://" + location.host + "/?cref=" + urlParamCref + "&u=" + webAlias;
                    enrollUnder = "https://" + location.host + "/pages/join-as-a-consultant?cref=" + urlParamCref + "&u=" + webAlias;
                }
                var isEnrollment = _this_1.checkIsCustomerOnEnrollment();
                if (isEnrollment) {
                    enrollUnder = "https://" + location.host + "/pages/consultant-signup?u=" + webAlias;
                }
                var description = consultantData.description;
                if (!description || description == "") {
                    description = "No description provided";
                }
                var consultantCard = document.createElement("div");
                consultantCard.classList.add("st_consultant-card");
                consultantCard.setAttribute("data-id", cardID);
                var consultant = '\n           \x3c!-- <div class="st_consultant-card" data-id="'.concat(cardID, '"> --\x3e\n                <div class="st_consultant-photo">\n                    <img src="').concat(img, '" />\n                    <button class="st_expand-btn" data-id="').concat(cardID, '">\n                        <svg xmlns="http://www.w3.org/2000/svg" class="st_expand-btn-arrow-svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#111111">\n                            <path d="m216-160-56-56 464-464H360v-80h400v400h-80v-264L216-160Z"/>\n                        </svg> \n                    </button>\n                </div>\n                <div class="st_consultant-info">\n                    <h3>').concat(fullName, '</h3>\n                    <p class="st_consultant-location"><span>&#128205;</span> ').concat(address, '</p>\n                    <div class="st_consultant-contact">\n                        <a href="').concat(email, '">\n                            <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                <path d="M2.33317 13.6668C1.87484 13.6668 1.48248 13.5036 1.15609 13.1772C0.829698 12.8509 0.666504 12.4585 0.666504 12.0002V2.00016C0.666504 1.54183 0.829698 1.14947 1.15609 0.823079C1.48248 0.496691 1.87484 0.333496 2.33317 0.333496H15.6665C16.1248 0.333496 16.5172 0.496691 16.8436 0.823079C17.17 1.14947 17.3332 1.54183 17.3332 2.00016V12.0002C17.3332 12.4585 17.17 12.8509 16.8436 13.1772C16.5172 13.5036 16.1248 13.6668 15.6665 13.6668H2.33317ZM8.99984 7.8335L2.33317 3.66683V12.0002H15.6665V3.66683L8.99984 7.8335ZM8.99984 6.16683L15.6665 2.00016H2.33317L8.99984 6.16683ZM2.33317 3.66683V2.00016V12.0002V3.66683Z" fill="#2E3A3C"/>\n                            </svg>\n                         </a>\n                        <a href="').concat(phone, '">\n                            <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                <path d="M1.83317 19.1668C1.37484 19.1668 0.982476 19.0036 0.656087 18.6772C0.329698 18.3509 0.166504 17.9585 0.166504 17.5002V2.50016C0.166504 2.04183 0.329698 1.64947 0.656087 1.32308C0.982476 0.996691 1.37484 0.833496 1.83317 0.833496H10.1665C10.6248 0.833496 11.0172 0.996691 11.3436 1.32308C11.67 1.64947 11.8332 2.04183 11.8332 2.50016V17.5002C11.8332 17.9585 11.67 18.3509 11.3436 18.6772C11.0172 19.0036 10.6248 19.1668 10.1665 19.1668H1.83317ZM1.83317 15.0002V17.5002H10.1665V15.0002H1.83317ZM5.99984 17.0835C6.23595 17.0835 6.43387 17.0036 6.59359 16.8439C6.75331 16.6842 6.83317 16.4863 6.83317 16.2502C6.83317 16.0141 6.75331 15.8161 6.59359 15.6564C6.43387 15.4967 6.23595 15.4168 5.99984 15.4168C5.76373 15.4168 5.56581 15.4967 5.40609 15.6564C5.24637 15.8161 5.1665 16.0141 5.1665 16.2502C5.1665 16.4863 5.24637 16.6842 5.40609 16.8439C5.56581 17.0036 5.76373 17.0835 5.99984 17.0835ZM1.83317 13.3335H10.1665V5.00016H1.83317V13.3335ZM1.83317 3.3335H10.1665V2.50016H1.83317V3.3335Z" fill="#2E3A3C"/>\n                            </svg>\n                        </a>\n                    </div>\n                    <div class="st_consultant-actions">\n                        <a class="st_shop-btn" href="').concat(shoppingWith, '">Shop With</a>\n                        <a class="st_enroll-btn st_enroll-under-btn_JS" href="').concat(enrollUnder, '" data-webAlias="').concat(webAlias, '">Enroll Under</a>\n                    </div>\n                </div>\n                \x3c!-- Hidden expanded details --\x3e\n                <div class="st_consultant-details">\n                    <div class="st_expanded-consultant-card">\n                        <div class="st_consultant-image">\n                            <img src="').concat(img, '" alt="').concat(fullName, '" />\n                        </div>\n                        <div class="st_consultant-details">\n                            <button class="st_close-btn" data-id="').concat(cardID, '">×</button>\n                            <h6>').concat(fullName, '</h6>\n                            <div class="st_consultant-location">\n                                <span class="st_icon">\n                                    <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                        <path d="M7.00016 8.50016C7.4585 8.50016 7.85086 8.34513 8.17725 8.03506C8.50363 7.72499 8.66683 7.35225 8.66683 6.91683C8.66683 6.48141 8.50363 6.10867 8.17725 5.7986C7.85086 5.48853 7.4585 5.3335 7.00016 5.3335C6.54183 5.3335 6.14947 5.48853 5.82308 5.7986C5.49669 6.10867 5.3335 6.48141 5.3335 6.91683C5.3335 7.35225 5.49669 7.72499 5.82308 8.03506C6.14947 8.34513 6.54183 8.50016 7.00016 8.50016ZM7.00016 14.3189C8.69461 12.8411 9.95155 11.4986 10.771 10.2913C11.5904 9.08402 12.0002 8.01197 12.0002 7.07516C12.0002 5.63697 11.5175 4.45936 10.5522 3.54235C9.58697 2.62534 8.40294 2.16683 7.00016 2.16683C5.59738 2.16683 4.41336 2.62534 3.44808 3.54235C2.4828 4.45936 2.00016 5.63697 2.00016 7.07516C2.00016 8.01197 2.40988 9.08402 3.22933 10.2913C4.04877 11.4986 5.30572 12.8411 7.00016 14.3189ZM7.00016 16.4168C4.76405 14.6092 3.09391 12.9302 1.98975 11.3799C0.885579 9.8295 0.333496 8.39461 0.333496 7.07516C0.333496 5.096 1.00363 3.51926 2.34391 2.34495C3.68419 1.17065 5.23627 0.583496 7.00016 0.583496C8.76405 0.583496 10.3161 1.17065 11.6564 2.34495C12.9967 3.51926 13.6668 5.096 13.6668 7.07516C13.6668 8.39461 13.1147 9.8295 12.0106 11.3799C10.9064 12.9302 9.23627 14.6092 7.00016 16.4168Z" fill="#2E3A3C"/>\n                                    </svg>\n                                </span>\n                                ').concat(address, '\n                            </div>\n                            <div class="st_consultant-contact">\n                                <span class="st_icon">\n                                    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                        <path d="M2.33317 13.6663C1.87484 13.6663 1.48248 13.5031 1.15609 13.1768C0.829698 12.8504 0.666504 12.458 0.666504 11.9997V1.99967C0.666504 1.54134 0.829698 1.14898 1.15609 0.822591C1.48248 0.496202 1.87484 0.333008 2.33317 0.333008H15.6665C16.1248 0.333008 16.5172 0.496202 16.8436 0.822591C17.17 1.14898 17.3332 1.54134 17.3332 1.99967V11.9997C17.3332 12.458 17.17 12.8504 16.8436 13.1768C16.5172 13.5031 16.1248 13.6663 15.6665 13.6663H2.33317ZM8.99984 7.83301L2.33317 3.66634V11.9997H15.6665V3.66634L8.99984 7.83301ZM8.99984 6.16634L15.6665 1.99967H2.33317L8.99984 6.16634ZM2.33317 3.66634V1.99967V11.9997V3.66634Z" fill="#2E3A3C"/>\n                                    </svg>\n                                </span>\n                                <a href="').concat(email, '">').concat(email, '</a>\n                            </div>\n                            <div class="st_consultant-contact">\n                                <span class="st_icon">\n                                    <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                        <path d="M2.08995 17.75C1.66898 17.75 1.31266 17.6042 1.021 17.3125C0.729329 17.0208 0.583496 16.6645 0.583496 16.2435V1.75646C0.583496 1.33549 0.729329 0.979167 1.021 0.6875C1.31266 0.395833 1.66898 0.25 2.08995 0.25H9.91037C10.3313 0.25 10.6877 0.395833 10.9793 0.6875C11.271 0.979167 11.4168 1.33549 11.4168 1.75646V16.2435C11.4168 16.6645 11.271 17.0208 10.9793 17.3125C10.6877 17.6042 10.3313 17.75 9.91037 17.75H2.08995ZM1.8335 13.8077V16.2435C1.8335 16.3077 1.86023 16.3665 1.9137 16.4198C1.96704 16.4733 2.02579 16.5 2.08995 16.5H9.91037C9.97454 16.5 10.0333 16.4733 10.0866 16.4198C10.1401 16.3665 10.1668 16.3077 10.1668 16.2435V13.8077H1.8335ZM6.00016 15.891C6.20419 15.891 6.37808 15.8192 6.52183 15.6754C6.66544 15.5318 6.73725 15.3579 6.73725 15.1538C6.73725 14.9497 6.66544 14.7759 6.52183 14.6323C6.37808 14.4885 6.20419 14.4167 6.00016 14.4167C5.79613 14.4167 5.62225 14.4885 5.4785 14.6323C5.33488 14.7759 5.26308 14.9497 5.26308 15.1538C5.26308 15.3579 5.33488 15.5318 5.4785 15.6754C5.62225 15.8192 5.79613 15.891 6.00016 15.891ZM1.8335 12.5577H10.1668V3.79167H1.8335V12.5577ZM1.8335 2.54167H10.1668V1.75646C10.1668 1.69229 10.1401 1.63354 10.0866 1.58021C10.0333 1.52674 9.97454 1.5 9.91037 1.5H2.08995C2.02579 1.5 1.96704 1.52674 1.9137 1.58021C1.86023 1.63354 1.8335 1.69229 1.8335 1.75646V2.54167Z" fill="#2E3A3C"/>\n                                    </svg>\n                                </span>\n                                <a href="').concat(phone, '">').concat(phone, '</a>\n                            </div>\n                            <div class="st_about-section">\n                                <div class="st_about-title">About Me</div>\n                                <div class="st_about-text" >\n                                     ').concat(description, '\n                                </div>\n                            </div>\n                            <div class="st_consultant-actions">\n                                <a class="st_shop-btn" href="').concat(shoppingWith, '">Shop With</a>\n                                <a class="st_enroll-btn st_enroll-under-btn_JS " href="').concat(enrollUnder, '" data-webAlias="').concat(webAlias, '">Enroll Under</a>\n                            </div>\n                        </div>\n                    </div>\n    \n                </div>\n           \x3c!-- </div> --\x3e\n            ');
                consultantCard.innerHTML = consultant;
                var consultantListWrp = document.querySelector(".st_consultant-list_JS");
                consultantListWrp.appendChild(consultantCard);
                _this_1.expandCart();
                var shopWithBtn = document.querySelectorAll(".st_shop-btn");
                if (isEnrollment) {
                    if (!!shopWithBtn) {
                        shopWithBtn.forEach(function(btn) {
                            btn.classList.add("st_hidden");
                        });
                    }
                } else {
                    if (!!shopWithBtn) {
                        shopWithBtn.forEach(function(btn) {
                            btn.classList.remove("st_hidden");
                        });
                    }
                }
                if (isEnrollment) {
                    _this_1.eventEnrollUnder();
                }
                return consultantCard;
            };
            _this_1.eventEnrollUnder = function() {
                var _this = _this_1;
                var enrollUnderButtons = document.querySelectorAll(".st_enroll-under-btn_JS");
                if (!!enrollUnderButtons) {
                    enrollUnderButtons.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            var getAlias = btn.getAttribute("data-webAlias");
                            _this.updateURLParam("u", getAlias);
                            var modalWrp = document.querySelector(_this_1.classConfig.selectorModalWrp);
                            if (modalWrp) {
                                modalWrp.classList.add("st_hidden");
                                var body = document.querySelector("body");
                                body.classList.remove("st_hide-scroll");
                                _this.clearConsultantsList();
                            }
                        });
                    });
                }
            };
            _this_1.clearConsultantsList = function() {
                var consultantListWrp = document.querySelector(".st_consultant-list_JS");
                if (!!consultantListWrp) {
                    consultantListWrp.innerHTML = " ";
                }
            };
            _this_1.checkIsCustomerOnEnrollment = function() {
                var url = window.location.href;
                var isOnEnrollmentPage = false;
                if (url.includes("/pages/consultant-signup") || url.includes("/pages/enrollment")) {
                    isOnEnrollmentPage = true;
                }
                return isOnEnrollmentPage;
            };
            _this_1.updateURLParam = function(key, value) {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var u = urlParams.u;
                if (u !== value) {
                    urlParams = __assign(__assign({}, urlParams), {
                        u: value
                    });
                    var newURL = window.location.href.replace(window.location.search, "");
                    _this_1.cart.updateCartItemsProperies(value);
                    _this_1.browserHistory.pushHistory(newURL, urlParams);
                }
            };
            return _this_1;
        }
        StSearchSponsorExtended.prototype.initSearchBoxFunctionality = function() {
            var searchWrappers = document.querySelectorAll(".st_consultant-banner-wrapper_JS");
            var _this = this;
            if (searchWrappers.length > 0) {
                var customerID = window.customerInfoMetafields.customerId;
                var sponsorRepID = window.customerInfoMetafields.representativeId;
                var customerType = window.customerInfoMetafields.customerType;
                var repSite = void 0;
                if (!!customerID && _features_config_11.lockedRepresentativeSite && customerType !== _features_config_11.ECustomerType.noType) {
                    repSite = customerType === _features_config_11.ECustomerType.representative ? customerID : sponsorRepID;
                } else {
                    var webAlias = this.objectFormatting.convertQueryStringToObject(window.location.search);
                    if (!!webAlias.u) {
                        repSite = webAlias.u;
                    } else {
                        if (!!this.cookies.getCookie("webAlias")) {
                            repSite = this.cookies.getCookie("webAlias");
                        }
                    }
                }
                this.getSponsorInfo(repSite);
            }
            searchWrappers === null || searchWrappers === void 0 ? void 0 : searchWrappers.forEach(function(wrapper) {
                _this.searchSponsors(wrapper);
            });
        };
        StSearchSponsorExtended.prototype.handleGetSponsorsResponse = function(request, input) {

            var res = JSON.parse(request.response);
            if (res.status === 200 && res.data.sponsors && res.data.sponsors.length > 0) {
                var sponsorsList = res.data.sponsors;
                if (!!sponsorsList) {
                    this.consultantCards(sponsorsList);
                }
                if (sponsorsList.length > 0) {
                    this.enableSearchBtn();
                    this.loaderOff(input);
                    this.enableRadioButtons(input);
                } else {
                    this.enableSearchBtn();
                    this.loaderOff(input);
                    this.enableRadioButtons(input);
                }
            } else {
                this.showMessage();
                this.enableSearchBtn();
                this.loaderOff(input);
                this.enableRadioButtons(input);
            }
        };
        return StSearchSponsorExtended;
    }(search_sponsor_1.StSearchSponsor);
    exports.StSearchSponsorExtended = StSearchSponsorExtended;
});

define("extension/shopify-app/st-modules/webalias/webalias-class-config", [ "require", "exports", "core/shopify-app/st-modules/webalias/webalias-class-config" ], function(require, exports, webalias_class_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAliasClassConfigExtended = void 0;
    var StWebAliasClassConfigExtended = function(_super) {
        __extends(StWebAliasClassConfigExtended, _super);
        function StWebAliasClassConfigExtended() {
            var _this = _super.call(this) || this;
            _this.className = "StWebAliasClassConfig";
            _this.classNameRepImage = "st_rep-image_JS";
            _this.selectorRepImage = "." + _this.classNameRepImage;
            _this.classNameRepImageWrp = "st_rep-photo-wrp_JS";
            _this.selectorRepImageWrp = "." + _this.classNameRepImageWrp;
            return _this;
        }
        return StWebAliasClassConfigExtended;
    }(webalias_class_config_1.StWebAliasClassConfig);
    exports.StWebAliasClassConfigExtended = StWebAliasClassConfigExtended;
});

define("extension/shopify-app/st-modules/webalias/inject-representative-info", [ "require", "exports", "_features.config", "core/shopify-app/st-modules/webalias/inject-representative-info" ], function(require, exports, _features_config_12, inject_representative_info_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInjectRepresentativeInfoExtended = void 0;
    var StInjectRepresentativeInfoExtended = function(_super) {
        __extends(StInjectRepresentativeInfoExtended, _super);
        function StInjectRepresentativeInfoExtended(classConfig, searchSponsor) {
            var _this_1 = _super.call(this, classConfig) || this;
            _this_1.className = "InjectRepresentativeInfoExtended";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setInitState();
                    _this_1.shopWithConsultantEventListener();
                    _this_1.removeShopping();
                    _this_1.checkWebAlias();
                    _this_1.handlingBanners();
                });
            };
            _this_1.appendRepBioToField = function(imageUrl) {
                var repImageWrp = document.querySelector(_this_1.classConfig.selectorRepImageWrp);
                if (repImageWrp) {
                    var repImage = repImageWrp.querySelector(_this_1.classConfig.selectorRepImage);
                    if (!!repImage) {
                        repImage.src = imageUrl;
                        repImageWrp.classList.remove("st_hidden");
                    }
                }
            };
            _this_1.isCheckedConsultant = function(parentWrp) {
                var checkbox = parentWrp.querySelector(".sc_toggle-consultant_JS");
                var isChecked = true;
                if (!!checkbox) {
                    isChecked = checkbox.checked;
                }
                return isChecked;
            };
            _this_1.shopWithConsultantEventListener = function() {
                var _a;
                var _this = _this_1;
                var checkbox = (_a = document.querySelector(_this_1.getWrpSelectorByScreenWidth())) === null || _a === void 0 ? void 0 : _a.querySelector(".sc_toggle-consultant_JS");
                if (!!checkbox) {
                    checkbox.addEventListener("change", function(e) {
                        _this.removeAlias();
                        _this.removeShopping();
                    });
                }
            };
            _this_1.checkWebAlias = function() {
                var url = new URL(window.location.href);
                var urlParam = url.searchParams.get("u");
                var checkboxes = document.querySelectorAll(".sc_toggle-consultant_JS");
                if (!!checkboxes) {
                    checkboxes.forEach(function(checkbox) {
                        if (urlParam == _features_config_12.defaultWebAlias || !urlParam) {
                            checkbox.checked = false;
                        } else {
                            checkbox.checked = true;
                        }
                    });
                }
            };
            _this_1.removeAlias = function() {
                var isChecked = _this_1.isCheckedConsultant(document.querySelector(_this_1.getWrpSelectorByScreenWidth()));
                if (!isChecked) {
                    var url = new URL(window.location.href);
                    var urlParam = url.searchParams.get("u");
                    if (urlParam !== _features_config_12.defaultWebAlias) {
                        var old = url.searchParams.get("u");
                        var firstName = localStorage.getItem("firstName");
                        var lastName = localStorage.getItem("lastName");
                        localStorage.setItem("oldWebAlias", old);
                        localStorage.setItem("oldFirstName", firstName);
                        localStorage.setItem("oldLastName", lastName);
                    }
                    url.searchParams.set("u", _features_config_12.defaultWebAlias);
                    localStorage.setItem("webAlias", _features_config_12.defaultWebAlias);
                    window.history.replaceState({}, document.title, url.toString());
                } else {
                    _this_1.switchLocalStorage();
                }
            };
            _this_1.switchLocalStorage = function() {
                var oldWebAlias = localStorage.getItem("oldWebAlias");
                localStorage.setItem("webAlias", oldWebAlias);
                var oldFirstName = localStorage.getItem("oldFirstName");
                var oldLastName = localStorage.getItem("oldLastName");
                localStorage.setItem("firstName", oldFirstName);
                localStorage.setItem("lastName", oldLastName);
                var url = new URL(window.location.href);
                url.searchParams.set("u", oldWebAlias);
                window.history.replaceState({}, document.title, url.toString());
                _this_1.searchSponsor.setNewSponsorInfoToHeader(oldFirstName, oldLastName, oldWebAlias);
            };
            _this_1.removeShopping = function() {
                var url = new URL(window.location.href);
                var urlParam = url.searchParams.get("u");
                var shoppingWithBanners = document.querySelectorAll(".sc_shopping-with-wrp_JS");
                if (!!shoppingWithBanners) {
                    shoppingWithBanners.forEach(function(shoppingWith) {
                        if (urlParam == _features_config_12.defaultWebAlias || !urlParam) {
                            //shoppingWith.classList.add("st_hidden");
                        } else {
                            shoppingWith.classList.remove("st_hidden");
                        }
                    });
                }
            };
            _this_1.getScreenWidth = function() {
                return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            };
            _this_1.handlingBanners = function() {
                var _this = _this_1;
                _this_1.getScreenWidth();
                window.addEventListener("resize", function() {
                    _this.getScreenWidth();
                });
                var mobile = document.querySelector(".sc_shopping-with-mobile-manu_JS");
                if (!!mobile) {
                    if (_this_1.getScreenWidth() <= 990) {
                        mobile.classList.remove("st_hidden");
                    } else {
                        mobile.classList.add("st_hidden");
                    }
                }
            };
            _this_1.getWrpSelectorByScreenWidth = function() {
                if (_this_1.getScreenWidth() <= 990) {
                    return ".sc_shopping-with-mobile-manu_JS";
                } else {
                    return ".sc_shopping-with-desktop-screens_JS";
                }
            };
            _this_1.setInitState = function() {
                var bannerWrp = document.querySelector(_this_1.getWrpSelectorByScreenWidth());
                if (!!bannerWrp) {
                    var checkbox = bannerWrp.querySelector(".sc_toggle-consultant_JS");
                    if (!!checkbox) {
                        var currentAlias = localStorage.getItem("webAlias");
                        checkbox.checked = currentAlias !== _features_config_12.defaultWebAlias;
                    }
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.searchSponsor = searchSponsor;
            return _this_1;
        }
        return StInjectRepresentativeInfoExtended;
    }(inject_representative_info_1.StInjectRepresentativeInfo);
    exports.StInjectRepresentativeInfoExtended = StInjectRepresentativeInfoExtended;
});

define("extension/shopify-app/st-modules/share-cart/share-cart-general", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_24, _features_config_13) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShareCartGeneral = void 0;
    var StShareCartGeneral = function(_super) {
        __extends(StShareCartGeneral, _super);
        function StShareCartGeneral(generalTable) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StShareCartGeneral";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {});
            };
            _this.getColumnIndexFromClass = function(element) {
                for (var _i = 0, _a = element.classList; _i < _a.length; _i++) {
                    var className = _a[_i];
                    if (className.startsWith("st_table-column--")) {
                        var numberPart = className.split("--")[1];
                        return parseInt(numberPart, 10);
                    }
                }
                return null;
            };
            _this.getRowIndexFromClass = function(element) {
                for (var _i = 0, _a = element.classList; _i < _a.length; _i++) {
                    var className = _a[_i];
                    if (className.startsWith("st_table-row--")) {
                        var numberPart = className.split("--")[1];
                        return parseInt(numberPart, 10);
                    }
                }
                return null;
            };
            _this.parseAllDatesToDateString = function(tableData, fieldKey) {
                return tableData.map(function(rowData) {
                    var _a, _b;
                    if (rowData[fieldKey] === "") {
                        return __assign(__assign({}, rowData), (_a = {}, _a[fieldKey] = "date missing", 
                        _a));
                    } else {
                        var parsedDate = new Date(rowData[fieldKey]);
                        return __assign(__assign({}, rowData), (_b = {}, _b[fieldKey] = _this.formatDateToCustomDateString(parsedDate), 
                        _b));
                    }
                });
            };
            _this.formatDateToCustomDateString = function(date) {
                var dateString = date.toDateString();
                return dateString.slice(3, dateString.length - 5) + "," + dateString.slice(dateString.length - 5);
            };
            _this.getWrbAlias = function(alias) {
                return alias;
            };
            _this.copyShareCartLink = function(tableData, fieldKey) {
                return tableData.map(function(rowData) {
                    var _a, _b;
                    var _c, _d, _e, _f;
                    if (rowData[fieldKey] === "") {
                        return __assign(__assign({}, rowData), (_a = {}, _a[fieldKey] = "link missing", 
                        _a));
                    } else {
                        var alias = "";
                        var cref = "";
                        var shareCartLink = "";
                        if (!!((_c = rowData === null || rowData === void 0 ? void 0 : rowData.share_cart_attributes) === null || _c === void 0 ? void 0 : _c.cref)) {
                            cref = (_d = rowData === null || rowData === void 0 ? void 0 : rowData.share_cart_attributes) === null || _d === void 0 ? void 0 : _d.cref;
                            shareCartLink = location.origin + "/pages/share-cart-loading?".concat(_features_config_13.refQueryParam, "=").concat(cref, "&").concat(_features_config_13.sc_tokenURLKey, "=").concat(rowData["cart_token"]);
                        } else if (!!((_e = rowData === null || rowData === void 0 ? void 0 : rowData.share_cart_attributes) === null || _e === void 0 ? void 0 : _e.sponsorWebAlias)) {
                            alias = (_f = rowData === null || rowData === void 0 ? void 0 : rowData.share_cart_attributes) === null || _f === void 0 ? void 0 : _f.sponsorWebAlias;
                            shareCartLink = location.origin + "/pages/share-cart-loading?".concat(_features_config_13.aliasQueryParam, "=").concat(alias, "&").concat(_features_config_13.sc_tokenURLKey, "=").concat(rowData["cart_token"]);
                        } else {
                            console.error("NO WEBALIAS");
                        }
                        return __assign(__assign({}, rowData), (_b = {}, _b[fieldKey] = shareCartLink, 
                        _b));
                    }
                });
            };
            _this.paintRows = function(row, rowIndex, colorOdd, colorEven) {
                if (!!row) {
                    if (rowIndex % 2 === 0) {
                        row.style.backgroundColor = colorEven;
                    } else {
                        row.style.backgroundColor = colorOdd;
                    }
                }
            };
            _this.generalTable = generalTable;
            return _this;
        }
        return StShareCartGeneral;
    }(st_module_24.StModule);
    exports.StShareCartGeneral = StShareCartGeneral;
});

define("extension/shopify-app/st-modules/share-cart/share-cart-table", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_25, _features_config_14) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShareCartTable = void 0;
    var StShareCartTable = function(_super) {
        __extends(StShareCartTable, _super);
        function StShareCartTable(generalTable, shareCartGeneral) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StShareCartTable";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    if (_features_config_14.sc_isShareCartEnabled === true) {
                        if (window.location.pathname.includes("/account")) {
                            _this_1.getInitialPageCount();
                            _this_1.getAllSharedCarts();
                            _this_1.saveSingleCartUpdateEventListener();
                            _this_1.clickOnClose();
                        }
                    }
                });
            };
            _this_1.renderShareCartTable = function(data) {
                var _this = _this_1;
                var shareCartTable = document.querySelector(".st_render--table_JS");
                if (!!shareCartTable) {
                    _this_1.shareCartGeneral.getWrbAlias(data.data);
                    shareCartTable.replaceChildren();
                    _this_1.generalTable.renderTableTitle("Shared Carts", shareCartTable);
                    if (data.length === 0) {
                        var noSharedCarts = _this_1.generalTable.renderDOMElement("p", "", shareCartTable);
                        if (window.customerInfoMetafields.customerType !== _features_config_14.ECustomerType.retail) {
                            noSharedCarts.innerText = "There are no shared carts.";
                        }
                        return;
                    }
                    // truncates the description field to 25 chars ending in ellipsis
                    data = data.map(item => {
                        if(!item.description) {
                            return item;
                        }
                        return {
                            ...item,
                            description: item.description.length > 25 
                                ? `${item.description.substring(0,25)}...`
                                :  item.description
                        }
                    });
                    var shareCartColumnMap = _this_1.returnSHareCartTableColumnMap();
                    var parsedData_1 = _this_1.shareCartGeneral.parseAllDatesToDateString(data, "created_at");
                    parsedData_1 = _this_1.shareCartGeneral.parseAllDatesToDateString(parsedData_1, "expiration_date");
                    parsedData_1 = _this_1.shareCartGeneral.copyShareCartLink(parsedData_1, "copyLink");
                    _this_1.generalTable.renderTable(shareCartColumnMap, parsedData_1, shareCartTable);
                    var shareCartRowList = document.querySelectorAll(".st_table-row");
                    shareCartRowList.forEach(function(row, index) {
                        var rowIndex = _this.shareCartGeneral.getRowIndexFromClass(row);
                        var columns = row.querySelectorAll(".st_table-column");
                        columns.forEach(function(column) {
                            _this.copyLinkBtn(column);
                            _this.shareCartDetails(column, parsedData_1[rowIndex].cart_token);
                        });
                    });
                }
            };
            _this_1.shareCartDetails = function(column, shareCartToken) {
                var _this = _this_1;
                var columnIndex = _this.shareCartGeneral.getColumnIndexFromClass(column);
                if (columnIndex !== 8) return;
                if (column.querySelector(".st_single-share-cart_JS")) return;
                column.innerHTML = '\n        <div data-token=""></div>\n            <svg class="st_single-share-cart st_single-share-cart_JS" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path d="M2.58822 16.75C2.08405 16.75 1.65245 16.5705 1.29342 16.2115C0.934397 15.8524 0.754883 15.4208 0.754883 14.9167V2.08333C0.754883 1.57917 0.934397 1.14757 1.29342 0.788542C1.65245 0.429514 2.08405 0.25 2.58822 0.25H9.00488V2.08333H2.58822V14.9167H15.4215V8.5H17.2549V14.9167C17.2549 15.4208 17.0754 15.8524 16.7163 16.2115C16.3573 16.5705 15.9257 16.75 15.4215 16.75H2.58822ZM6.89655 11.8917L5.61322 10.6083L14.1382 2.08333H10.8382V0.25H17.2549V6.66667H15.4215V3.36667L6.89655 11.8917Z" fill="#2e3a3c"/>\n            </svg>';
                var btn = column.querySelector(".st_single-share-cart_JS");
                if (btn) {
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.openSingleShareCart();
                        _this.getSingleSharedCarts(shareCartToken);
                    });
                }
            };
            _this_1.copyLinkBtn = function(column) {
                var link = column.textContent;
                if (link === null || link === void 0 ? void 0 : link.startsWith("http")) {
                    column.innerHTML = '\n                            <span class="st_copy-icon st_copy-icon_JS" title="Click to copy">\n                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                  <path d="M8 8H6C4.9 8 4 8.9 4 10V18C4 19.1 4.9 20 6 20H14C15.1 20 16 19.1 16 18V16" stroke="#2e3a3c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n                                  <rect x="8" y="4" width="12" height="12" rx="2" stroke="#2e3a3c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n                                </svg>\n                            </span>';
                    var icon_1 = column.querySelector(".st_copy-icon_JS");
                    icon_1 === null || icon_1 === void 0 ? void 0 : icon_1.addEventListener("click", function(e) {
                        e.stopPropagation();
                        navigator.clipboard.writeText(link).then(function() {
                            icon_1.innerHTML = "✔";
                            setTimeout(function() {
                                icon_1.innerHTML = "\n                            <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>\n                                <path d='M8 8H6C4.9 8 4 8.9 4 10V18C4 19.1 4.9 20 6 20H14C15.1 20 16 19.1 16 18V16' stroke='#2e3a3c' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/>\n                                <rect x='8' y='4' width='12' height='12' rx='2' stroke='#2e3a3c' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/>\n                            </svg>";
                            }, 1500);
                        });
                    });
                }
            };
            _this_1.getAllSharedCarts = function(nextPage) {
                var _this = _this_1;
                var customerId = window.customerShopifyId;
                var sc_serverURL = window === null || window === void 0 ? void 0 : window.stAppConfig.sc_serverURL;
                _this_1.ajax.send({
                    endpoint: sc_serverURL + "share-cart/getAllShareCarts/".concat(customerId, "?page=").concat(nextPage !== null && nextPage !== void 0 ? nextPage : 1, "&itemsPerPage=").concat(_features_config_14.sc_shareCartItemsPerPage),
                    method: "get",
                    contentType: "json",
                    callback: function(response) {
                        try {
                            var shareCartData = JSON.parse(response.response);
                            if (shareCartData.statusCode === 200) {
                                _this.renderShareCartTable(shareCartData.data.items);
                            }
                        } catch (error) {
                            console.error(error);
                        }
                    }
                });
            };
            _this_1.getSingleSharedCarts = function(share_token) {
                var _this = _this_1;
                var customerId = window.customerShopifyId;
                try {
                    var sc_serverURL = window === null || window === void 0 ? void 0 : window.stAppConfig.sc_serverURL;
                    _this_1.ajax.send({
                        endpoint: sc_serverURL + "share-cart/getShareCartByToken/".concat(share_token, "?shopifyCustomerId=").concat(customerId),
                        method: "get",
                        contentType: "json",
                        callback: function(response) {
                            try {
                                if (response.status === 200) {
                                    var singleShareCartData = JSON.parse(response.response);
                                    if (singleShareCartData.statusCode === 200) {
                                        _this.openCartData = singleShareCartData.data;
                                        var result = _this_1.extractLineItemDetails(singleShareCartData);
                                        _this_1.renderItemsTable(result, singleShareCartData.data);
                                        _this_1.clickOnCopyLinkEventListener();
                                    }
                                }
                            } catch (error) {
                                console.log("getShareCartInfo-response Response Error ------\x3e" + error);
                            }
                        }
                    });
                } catch (error) {
                    console.log("getShareCartInfo Request Error ------\x3e" + error);
                }
            };
            _this_1.updateSharedCarts = function(cartData, isChecked) {
                var customerId = window.customerShopifyId;
                var sc_serverURL = window === null || window === void 0 ? void 0 : window.stAppConfig.sc_serverURL;
                _this_1.ajax.send({
                    endpoint: sc_serverURL + "share-cart/updateShareCart/".concat(cartData.cartId, "?customerShopifyId=").concat(customerId),
                    method: "PATCH",
                    contentType: "json",
                    data: {
                        optional: {
                            name: cartData.name,
                            description: cartData.description,
                            never_expires: isChecked
                        }
                    },
                    callback: function(response) {
                        try {
                            var shareCartData = JSON.parse(response.response);
                            if (shareCartData.status === 200) {}
                        } catch (error) {
                            console.error(error);
                        }
                    }
                });
            };
            _this_1.openSingleShareCart = function() {
                var singleShareCartWrp = document.querySelector(".st_single-share-cart-wrapper_JS");
                if (!!singleShareCartWrp) {
                    singleShareCartWrp.classList.remove("st_hidden");
                }
                var copyLinkButton = document.querySelector(".st_copy-link-block_JS");
                if (!!copyLinkButton) {
                    copyLinkButton.classList.remove("st_hidden");
                }
            };
            _this_1.closeSingleShareCart = function() {
                var singleShareCartWrp = document.querySelector(".st_single-share-cart-wrapper_JS");
                if (!!singleShareCartWrp) {
                    singleShareCartWrp.classList.add("st_hidden");
                }
                var itemsTable = document.querySelector(".st_single-share-cart-items-table_JS");
                if (!itemsTable) return;
                itemsTable.replaceChildren();
                var cssClassForLoaderReplacementArray = [ ".st_share-cart-name_JS", ".st_single-share-cart-info-creation-date_JS", ".st_single-share-cart-info-expiration-date_JS", ".st_single-share-cart-info-status_JS", ".st_single-share-cart-items-table_JS", ".st_share-cart-total_JS", ".st_number-of-items_JS" ];
                cssClassForLoaderReplacementArray.forEach(function(classNameItem) {
                    var item = document.querySelector(classNameItem);
                    if (!!item) {
                        item.innerHTML = '<span class="sc_loader-search"></span>';
                    }
                });
                var popupShareCartIdItem = document.querySelector(".st_share-cart-title-id_JS");
                if (!!popupShareCartIdItem) {
                    popupShareCartIdItem.innerHTML = "";
                }
                var copyLinkButton = document.querySelector(".st_copy-link-block_JS");
                if (!!copyLinkButton) {
                    copyLinkButton.classList.add("st_hidden");
                }
                var sliderItem = document.querySelector(".st_share-cart-switch-expired_JS");
                if (!!sliderItem) {
                    sliderItem.checked = false;
                }
            };
            _this_1.clickOnClose = function() {
                var _this = _this_1;
                var closeBtn = document.querySelector(".st_close-share-cart_JS");
                if (!!closeBtn) {
                    closeBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.openCartData = null;
                        _this.closeSingleShareCart();
                    });
                }
            };
            _this_1.extractLineItemDetails = function(sharedCartData) {
                var items = sharedCartData.data.line_items;
                return items.map(function(item) {
                    var _a, _b, _c, _d, _e, _f;
                    var variant = (_a = item.shopify_details) === null || _a === void 0 ? void 0 : _a.productVariant;
                    var product = variant === null || variant === void 0 ? void 0 : variant.product;
                    var quantity = item.quantity;
                    return {
                        url: ((_f = (_e = (_d = (_c = (_b = product === null || product === void 0 ? void 0 : product.media) === null || _b === void 0 ? void 0 : _b.nodes) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.preview) === null || _e === void 0 ? void 0 : _e.image) === null || _f === void 0 ? void 0 : _f.url) || "",
                        title: (product === null || product === void 0 ? void 0 : product.title) || "",
                        price: "$" + (variant === null || variant === void 0 ? void 0 : variant.price) || "",
                        quantity: quantity || "",
                        total: "$" + (variant === null || variant === void 0 ? void 0 : variant.price) * quantity || ""
                    };
                });
            };
            _this_1.renderItemsTable = function(singleCartData, allData) {
                var _this = _this_1;
                var itemsTable = document.querySelector(".st_single-share-cart-items-table_JS");
                if (!itemsTable) return;
                itemsTable.replaceChildren();
                _this_1.generalTable.renderTableTitle(" ", itemsTable);
                if (singleCartData.length === 0) {
                    var noSharedCarts = _this_1.generalTable.renderDOMElement("p", "", itemsTable);
                    noSharedCarts.innerText = "There are no items in cart.";
                    return;
                }
                var shareCartColumnMap = _this_1.returnItemsTableColumnMap();
                _this_1.generalTable.renderTable(shareCartColumnMap, singleCartData, itemsTable);
                var shareCartRowList = itemsTable.querySelectorAll(".st_table-row");
                shareCartRowList.forEach(function(row, index) {
                    var rowIndex = _this.shareCartGeneral.getRowIndexFromClass(row);
                    var columns = row.querySelectorAll(".st_table-column");
                    columns.forEach(function(column) {
                        var columnIndex = _this.shareCartGeneral.getColumnIndexFromClass(column);
                        if (columnIndex === 0) {
                            column.innerHTML = '<img class="st_item-img" src="'.concat(singleCartData[rowIndex].url, '">');
                        }
                    });
                });
                var sum = _this_1.summarizeCart(allData.line_items);
                _this_1.renderSumDataInSingleCart(sum.totalPrice, sum.totalQuantity);
                _this_1.renderShareCartInfo(allData.cart_status, allData.expiration_date, allData.created_at, allData.cartId, allData.name, allData.share_cart_attributes.never_expires);
                _this_1.registerSharedCartToggleListener();
            };
            _this_1.summarizeCart = function(lineItems) {
                var totalQuantity = 0;
                var totalPrice = 0;
                lineItems.forEach(function(item) {
                    var _a;
                    var quantity = item.quantity || 0;
                    var variant = (_a = item.shopify_details) === null || _a === void 0 ? void 0 : _a.productVariant;
                    var compareAt = parseFloat(variant === null || variant === void 0 ? void 0 : variant.price);
                    var actualPrice = parseFloat(variant === null || variant === void 0 ? void 0 : variant.price);
                    var usedPrice = !isNaN(compareAt) ? compareAt : actualPrice;
                    totalQuantity += quantity;
                    totalPrice += usedPrice * quantity;
                });
                return {
                    totalQuantity: totalQuantity,
                    totalPrice: totalPrice.toFixed(2)
                };
            };
            _this_1.renderSumDataInSingleCart = function(total, numberOfItems) {
                var totalDiv = document.querySelector(".st_number-of-items_JS");
                var numOfItemsDiv = document.querySelector(".st_share-cart-total_JS");
                if (!!total && totalDiv) {
                    totalDiv.innerHTML = "Shared Cart Value $" + total;
                }
                if (!!numberOfItems && numOfItemsDiv) {
                    numOfItemsDiv.innerHTML = "Shared cart items: " + numberOfItems;
                }
            };
            _this_1.renderShareCartInfo = function(status, expiration, creation, cartId, name, neverEnd) {
                var formatedCreationDate = _this_1.shareCartGeneral.formatDateToCustomDateString(new Date(creation));
                var formatedExpirationDate = _this_1.shareCartGeneral.formatDateToCustomDateString(new Date(expiration));
                var switchNeverEnds = document.querySelector(".st_share-cart-switch-expired_JS");
                if (!!switchNeverEnds) {
                    if (neverEnd === "1" || neverEnd === "true") {
                        switchNeverEnds.checked = true;
                    } else {
                        switchNeverEnds.checked = false;
                    }
                }
                var cartIdDiv = document.querySelector(".st_share-cart-title-id_JS");
                if (!!cartIdDiv) {
                    cartIdDiv.innerHTML = "#".concat(cartId);
                }
                var nameDiv = document.querySelector(".st_share-cart-name_JS");
                if (!!nameDiv) {
                    nameDiv.innerHTML = name;
                }
                var creationDateInfo = document.querySelector(".st_single-share-cart-info-creation-date_JS");
                if (!!creationDateInfo) {
                    creationDateInfo.innerHTML = formatedCreationDate;
                }
                var expirationDateInfo = document.querySelector(".st_single-share-cart-info-expiration-date_JS");
                if (!!expirationDateInfo) {
                    expirationDateInfo.innerHTML = formatedExpirationDate;
                }
                var statusInfo = document.querySelector(".st_single-share-cart-info-status_JS");
                if (!!statusInfo) {
                    statusInfo.innerHTML = status;
                }
            };
            _this_1.registerSharedCartToggleListener = function() {
                var toggle = document.querySelector(".st_share-cart-switch-expired_JS");
                if (!toggle) return;
                var isChecked = toggle.checked;
                toggle.addEventListener("change", function(e) {
                    if (!isChecked) {
                        console.log("Cart set to never expire");
                    } else {
                        console.log("Cart will expire as normal");
                    }
                    return e.target.checked;
                });
                return isChecked;
            };
            _this_1.saveSingleCartUpdateEventListener = function() {
                var _this = _this_1;
                var saveBtn = document.querySelector(".st_single-share-cart-save-btn_JS");
                if (!!saveBtn) {
                    saveBtn.removeEventListener("click", _this.handleOnClickSaveChanges);
                    saveBtn.addEventListener("click", _this.handleOnClickSaveChanges);
                }
            };
            _this_1.handleOnClickSaveChanges = function() {
                var cartData = _this_1.openCartData;
                var switchElement = document.querySelector(".st_share-cart-switch-expired_JS");
                if (!switchElement) return;
                var isChecked = switchElement.checked;
                var stateBeforeChangeToggle = !isChecked;
                if (cartData.share_cart_attributes["never_expires"]) {
                    stateBeforeChangeToggle = cartData.share_cart_attributes["never_expires"] === "true" || cartData.share_cart_attributes["never_expires"] === "1";
                } else if (cartData.share_cart_miscfields["never_expires"]) {
                    stateBeforeChangeToggle = cartData.share_cart_miscfields["never_expires"] === "true" || cartData.share_cart_miscfields["never_expires"] === "1";
                } else {
                    stateBeforeChangeToggle = false;
                }
                if (stateBeforeChangeToggle !== isChecked) {
                    _this_1.updateSharedCarts(cartData, isChecked);
                }
                _this_1.closeSingleShareCart();
            };
            _this_1.clickOnCopyLinkEventListener = function() {
                var _this = _this_1;
                var copyLinkShareCartDetails = document.querySelector(".st_copy-share-cart_JS");
                if (!!copyLinkShareCartDetails) {
                    copyLinkShareCartDetails.removeEventListener("click", _this.handleClickOnCopyLink);
                    copyLinkShareCartDetails.addEventListener("click", _this.handleClickOnCopyLink);
                }
            };
            _this_1.handleClickOnCopyLink = function() {
                var _this = _this_1;
                var token = _this.openCartData.cart_token;
                var webAlias = _this.openCartData.share_cart_attributes.sponsorWebAlias;
                var cref = _this.openCartData.share_cart_attributes.cref;
                var shareCartLink = location.origin + "/pages/share-cart-loading?".concat(_features_config_14.aliasQueryParam, "=").concat(webAlias, "&").concat(_features_config_14.sc_tokenURLKey, "=").concat(token);
                if (!!cref) {
                    shareCartLink = location.origin + "/pages/share-cart-loading?".concat(_features_config_14.refQueryParam, "=").concat(cref, "&").concat(_features_config_14.sc_tokenURLKey, "=").concat(token);
                }
                navigator.clipboard.writeText(shareCartLink).then(function() {
                    return alert("Link copied to clipboard!");
                }).catch(function() {
                    return alert("Failed to copy link");
                });
            };

            // TODO This should do nothing if Referrals are hidden
            _this_1.getInitialPageCount = function() {
                return;
                // var _this = _this_1;
                // var customerId = window.customerShopifyId;
                // var sc_serverURL = window === null || window === void 0 ? void 0 : window.stAppConfig.sc_serverURL;
                // try {
                //     _this_1.ajax.send({
                //         endpoint: sc_serverURL + "share-cart/getMaxPageCount/".concat(customerId, "?itemsPerPage=").concat(_features_config_14.sc_shareCartItemsPerPage),
                //         method: "get",
                //         contentType: "json",
                //         callback: function(response) {
                //             try {
                //                 if (response.status === 200) {
                //                     var shareCartData = JSON.parse(response.response);
                //                     _this.totalPageCount = shareCartData.data;
                //                     _this.renderPaginationButtons();
                //                 }
                //             } catch (error) {
                //                 console.log("getInitialPageCount-response Response Error ------\x3e" + error);
                //             }
                //         }
                //     });
                // } catch (error) {
                //     console.log("getInitialPageCount Request Error ------\x3e" + error);
                // }
            };
            // END This should do nothing if Referrals are hidden

            _this_1.renderPaginationButtons = function() {
                var _this = _this_1;
                var tableContainerElement = document.querySelector(".st_share-cart-table-and-pagination-wrapper");
                if (document.querySelectorAll(".st_share-cart-pagination-wrapper")[0]) return;
                var paginationButtonsWrapper = document.createElement("div");
                paginationButtonsWrapper.className = "st_share-cart-table-and-pagination-wrapper";
                if (!tableContainerElement) return;
                var _loop_2 = function(i) {
                    var pageBtnElement = document.createElement("button");
                    pageBtnElement.id = "st_share-cart-pagination-btn-page-".concat(i);
                    pageBtnElement.innerHTML = "".concat(i);
                    pageBtnElement.classList.add("st_share-cart-table-pagination-btn");
                    if (i === _this.currentPage) {
                        pageBtnElement.classList.add("st_active-page-highlight");
                    }
                    pageBtnElement.addEventListener("click", function() {
                        _this.getAllSharedCarts(i);
                        _this.currentPage = i;
                        var paginationButtons = document.querySelectorAll(".st_share-cart-table-pagination-btn");
                        paginationButtons === null || paginationButtons === void 0 ? void 0 : paginationButtons.forEach(function(paginationButton) {
                            if (paginationButton.innerHTML === "".concat(i)) {
                                paginationButton.classList.add("st_active-page-highlight");
                            } else {
                                paginationButton.classList.remove("st_active-page-highlight");
                            }
                        });
                    });
                    paginationButtonsWrapper.appendChild(pageBtnElement);
                };
                for (var i = 1; i <= _this_1.totalPageCount; i++) {
                    _loop_2(i);
                }
                tableContainerElement.appendChild(paginationButtonsWrapper);
            };
            _this_1.generalTable = generalTable;
            _this_1.shareCartGeneral = shareCartGeneral;
            _this_1.totalPageCount = -1;
            _this_1.currentPage = 1;
            _this_1.openCartData = null;
            return _this_1;
        }
        StShareCartTable.prototype.returnSHareCartTableColumnMap = function() {
            return [ {
                displayText: "Shared Cart Name",
                key: "name"
            }, {
                displayText: "Description",
                key: "description"
            }, {
                displayText: "Shared Cart ID",
                key: "cartId"
            }, {
                displayText: "Creation Date",
                key: "created_at"
            }, {
                displayText: "Expiration Date",
                key: "expiration_date"
            }, {
                displayText: "Times Opened",
                key: "impressions"
            }, {
                displayText: "Times Ordered",
                key: "completed_purchases"
            }, {
                displayText: "Copy Link",
                key: "copyLink"
            }, {
                displayText: "Preview",
                key: "preview"
            } ];
        };
        StShareCartTable.prototype.returnItemsTableColumnMap = function() {
            return [ {
                displayText: "Items",
                key: "url"
            }, {
                displayText: "",
                key: "title"
            }, {
                displayText: "Quantity",
                key: "quantity"
            }, {
                displayText: "Price",
                key: "price"
            }, {
                displayText: "Total",
                key: "total"
            } ];
        };
        return StShareCartTable;
    }(st_module_25.StModule);
    exports.StShareCartTable = StShareCartTable;
});

define("extension/shopify-app/st-modules/_share-cart/share-cart-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_26) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShareCartClassConfig = void 0;
    var StShareCartClassConfig = function(_super) {
        __extends(StShareCartClassConfig, _super);
        function StShareCartClassConfig(generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StShareCartClassConfig";
            _this.classNameEnrollmentWrapper = "st_enrollment_JS";
            _this.selectorEnrollmentWrapper = "." + _this.classNameEnrollmentWrapper;
            _this.classNameEnrollmentPage = "st_enrollment--page_JS";
            _this.selectorEnrollmentPage = "." + _this.classNameEnrollmentPage;
            _this.cartDrawer = function(current) {
                if (current) {
                    if (current.classList.contains("sd-sidebar-container")) {
                        return current;
                    } else {
                        return _this.generalMethods.getClosestByClass(current, "sd-sidebar-container");
                    }
                } else {
                    return document.querySelector(".sd-sidebar-container");
                }
            };
            _this.shareCartMainWrapper = function(current) {
                if (current) {
                    if (current.classList.contains("sc_share-cart-main-wrapper_JS")) {
                        return current;
                    } else {
                        return _this.generalMethods.getClosestByClass(current, "sc_share-cart-main-wrapper_JS");
                    }
                } else {
                    return document.querySelector(".sc_share-cart-main-wrapper_JS");
                }
            };
            _this.shareCartForm = function(current) {
                if (current) {
                    if (current.classList.contains("sc_share-cart-form_JS")) {
                        return current;
                    } else {
                        return _this.generalMethods.getClosestByClass(current, "sc_share-cart-form_JS");
                    }
                } else {
                    return document.querySelector(".sc_share-cart-form_JS");
                }
            };
            _this.shareCartFormName = function() {
                return document.querySelector("#share_cart_name");
            };
            _this.shareCartFormDescription = function() {
                return document.querySelector("#share_cart_description");
            };
            _this.shareCartFormEndDate = function() {
                return document.querySelector("#share_cart_end-date");
            };
            _this.selectShareCartButton = function(current) {
                if (current) {
                    if (current.classList.contains("sc_share-cart-btn_JS")) {
                        return current;
                    } else {
                        return _this.generalMethods.getClosestByClass(current, "sc_share-cart-btn_JS");
                    }
                } else {
                    return document.querySelector(".sc_share-cart-btn_JS");
                }
            };
            _this.shareCartEndDate = function(current) {
                if (current) {
                    if (current.classList.contains("sc_share-cart-end-date_JS")) {
                        return current;
                    } else {
                        return _this.generalMethods.getClosestByClass(current, "sc_share-cart-end-date_JS");
                    }
                } else {
                    return document.querySelector(".sc_share-cart-end-date_JS");
                }
            };
            _this.shareCartCreateButton = function(current) {
                if (current) {
                    if (current.classList.contains("sc_share-cart-btn-create_JS")) {
                        return current;
                    } else {
                        return _this.generalMethods.getClosestByClass(current, "sc_share-cart-btn-create_JS");
                    }
                } else {
                    return document.querySelector(".sc_share-cart-btn-create_JS");
                }
            };
            _this.shareCartButtonText = function(current) {
                if (current) {
                    if (current.classList.contains("sc_share-cart-btn-text_JS")) {
                        return current;
                    } else {
                        return _this.generalMethods.getClosestByClass(current, "sc_share-cart-btn-text_JS");
                    }
                } else {
                    return document.querySelector(".sc_share-cart-btn-text_JS");
                }
            };
            _this.shareCartLoader = function(current) {
                if (current) {
                    if (current.classList.contains("sc_share-cart-loader_JS")) {
                        return current;
                    } else {
                        return _this.generalMethods.getClosestByClass(current, "sc_share-cart-loader_JS");
                    }
                } else {
                    return document.querySelector(".sc_share-cart-loader_JS");
                }
            };
            _this.shareCartCopyWrapperInner = function(current) {
                if (current) {
                    if (current.classList.contains("sc_share-cart-ulr-link-wrapper_JS")) {
                        return current;
                    } else {
                        return _this.generalMethods.getClosestByClass(current, "sc_share-cart-ulr-link-wrapper_JS");
                    }
                } else {
                    return document.querySelector(".sc_share-cart-ulr-link-wrapper_JS");
                }
            };
            _this.shareCartCopyWrapper = function(current) {
                if (current) {
                    if (current.classList.contains("sc_share-cart-copy-wrapper_JS")) {
                        return current;
                    } else {
                        return _this.generalMethods.getClosestByClass(current, "sc_share-cart-copy-wrapper_JS");
                    }
                } else {
                    return document.querySelector(".sc_share-cart-copy-wrapper_JS");
                }
            };
            _this.shareCartCopyInput = function(current) {
                if (current) {
                    if (current.classList.contains("sc_share-cart-ulr-link_JS")) {
                        return current;
                    } else {
                        return _this.generalMethods.getClosestByClass(current, "sc_share-cart-ulr-link_JS");
                    }
                } else {
                    return document.querySelector(".sc_share-cart-ulr-link_JS");
                }
            };
            _this.shareCartCopyButton = function(current) {
                if (current) {
                    if (current.classList.contains("sc_share-cart-ulr-link-copy_JS")) {
                        return current;
                    } else {
                        return _this.generalMethods.getClosestByClass(current, "sc_share-cart-ulr-link-copy_JS");
                    }
                } else {
                    return document.querySelector(".sc_share-cart-ulr-link-copy_JS");
                }
            };
            _this.selectShareCartCloseButton = function(current) {
                if (current) {
                    if (current.classList.contains("sc_share-cart-form-cancel_JS")) {
                        return current;
                    } else {
                        return _this.generalMethods.getClosestByClass(current, "sc_share-cart-form-cancel_JS");
                    }
                } else {
                    return document.querySelector(".sc_share-cart-form-cancel_JS");
                }
            };
            _this.newShareCartButton = function(current) {
                if (current) {
                    if (current.classList.contains("sc_share-cart-new_JS")) {
                        return current;
                    } else {
                        return _this.generalMethods.getClosestByClass(current, "sc_share-cart-new_JS");
                    }
                } else {
                    return document.querySelector(".sc_share-cart-new_JS");
                }
            };
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StShareCartClassConfig;
    }(st_module_26.StModule);
    exports.StShareCartClassConfig = StShareCartClassConfig;
});

define("extension/shopify-app/st-modules/_share-cart/share-cart-drawer/share-cart-drawer", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_27, _features_config_15, notification_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShareCartDrawer = void 0;
    var StShareCartDrawer = function(_super) {
        __extends(StShareCartDrawer, _super);
        function StShareCartDrawer(classConfig, generalMethods, cartComponent, objectFormatting, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StShareCartDrawer";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    if (_this_1.isShareCartEnabled) {
                        _this_1.tryToSetupDrawer();
                        _this_1.cartComponent.subscribeChangeCart(function(cartObject) {
                            var _a;
                            if (!!(cartObject === null || cartObject === void 0 ? void 0 : cartObject.items) && ((_a = cartObject === null || cartObject === void 0 ? void 0 : cartObject.items) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                                _this_1.tryToSetupDrawer();
                            }
                        });
                    }
                });
            };
            _this_1.tryToSetupDrawer = function() {
                var shareCartMainWrapper = _this_1.classConfig.shareCartMainWrapper();
                if (!!shareCartMainWrapper) {
                    _this_1.addEventListenersForShareCartNavigation();
                    _this_1.handleClickOnShareCart();
                    _this_1.setupQuantityWatcher();
                } else {
                    var cartDrawer = _this_1.classConfig.cartDrawer();
                    _this_1.onElementLoaded(cartDrawer, function(mutationList, observer) {
                        return __awaiter(_this_1, void 0, void 0, function() {
                            var shouldUpdate, newShareCartMainWrapper;
                            var _this_1 = this;
                            return __generator(this, function(_a) {
                                shouldUpdate = false;
                                mutationList.forEach(function(mutationRecord) {
                                    var newShareCartMainWrapper = _this_1.classConfig.shareCartMainWrapper();
                                    if (!!newShareCartMainWrapper) {
                                        shouldUpdate = true;
                                    }
                                });
                                if (shouldUpdate) {
                                    newShareCartMainWrapper = this.classConfig.shareCartMainWrapper();
                                    if (!!newShareCartMainWrapper) {
                                        this.addEventListenersForShareCartNavigation();
                                        this.handleClickOnShareCart();
                                    } else {
                                        console.error("MUTATION Observer found nothing", newShareCartMainWrapper);
                                    }
                                }
                                return [ 2 ];
                            });
                        });
                    }, {
                        childList: true,
                        subtree: true,
                        attributeOldValue: true,
                        attributes: true
                    });
                }
            };
            _this_1.shareCartBtnClickHandle = function() {
                if (window.isRep) {
                    _this_1.displayShareCartForm();
                }
                _this_1.shareCartExpireDateFormValue();
                if (!window.isRep) {
                    var shareCartFormWrapper = document.querySelector(".sc_share-cart-wrapper-two_JS");
                    var mainShareCartWrapper = document.querySelector(".sc_share-cart-wrapper-one_JS");
                    var bottomCart = document.querySelector(".sc_bottom-cart_JS");
                    var formInputsWrapper = document.querySelector(".sc_share-cart-form_JS");
                    var createNewShareCartLink = document.querySelector(".sc_share-cart-btn-create_JS");
                    if (!!createNewShareCartLink) {
                        createNewShareCartLink.classList.add("st_hidden");
                    }
                    if (!!formInputsWrapper) {
                        formInputsWrapper.classList.add("st_hidden");
                    }
                    var footerVisibilityElements = document.querySelectorAll(".sc_footer_visibility_JS");
                    if (!!footerVisibilityElements) {
                        footerVisibilityElements.forEach(function(element) {
                            element.classList.add("st_hidden");
                        });
                    }
                    if (!!shareCartFormWrapper && !!mainShareCartWrapper && !!bottomCart) {
                        mainShareCartWrapper.classList.add("st_hidden");
                        shareCartFormWrapper.classList.remove("st_hidden");
                        bottomCart.style.backgroundColor = "#DAD6D4";
                    }
                    _this_1.createShareCartBtnClickedHandler();
                }
            };
            _this_1.shareCartExpireDateFormValue = function() {
                var shareCartEndDate = _this_1.classConfig.shareCartEndDate();
                if (!!shareCartEndDate) {
                    var dateNow = new Date();
                    var monthFromNowDate = new Date();
                    monthFromNowDate.setMonth(monthFromNowDate.getMonth() + 1);
                    shareCartEndDate.value = monthFromNowDate.toISOString().split("T")[0];
                    shareCartEndDate.min = dateNow.toISOString().split("T")[0];
                    shareCartEndDate.max = monthFromNowDate.toISOString().split("T")[0];
                    shareCartEndDate.addEventListener("change", _this_1.shareCartEndDateChangeHandle);
                    shareCartEndDate.addEventListener("change", _this_1.shareCartEndDateChangeHandle);
                }
                var shareCartFormName = _this_1.classConfig.shareCartFormName();
                if (!!shareCartFormName) {
                    var dateNow = new Date();
                    shareCartFormName.setAttribute("default-name-value", dateNow.toISOString());
                }
            };
            _this_1.shareCartEndDateChangeHandle = function(e) {
                var inputtedDate = new Date(e.target.value);
                var shareCartEndDate = _this_1.classConfig.shareCartEndDate();
                var dateNow = new Date();
                var monthFromNowDate = new Date();
                monthFromNowDate.setMonth(monthFromNowDate.getMonth() + 1);
                if (inputtedDate > monthFromNowDate) {
                    shareCartEndDate.value = monthFromNowDate.toISOString().split("T")[0];
                } else if (dateNow > inputtedDate) {
                    shareCartEndDate.value = dateNow.toISOString().split("T")[0];
                }
            };
            _this_1.displayShareCartForm = function() {
                var shareCartFormWrapper = document.querySelector(".sc_share-cart-wrapper-two_JS");
                var mainShareCartWrapper = document.querySelector(".sc_share-cart-wrapper-one_JS");
                var bottomCart = document.querySelector(".sc_bottom-cart_JS");
                if (!!shareCartFormWrapper && !!mainShareCartWrapper && !!bottomCart) {
                    shareCartFormWrapper.classList.remove("st_hidden");
                    mainShareCartWrapper.classList.add("st_hidden");
                    bottomCart.style.backgroundColor = "#DAD6D4";
                }
                var footerVisibilityElements = document.querySelectorAll(".sc_footer_visibility_JS");
                if (!!footerVisibilityElements) {
                    footerVisibilityElements.forEach(function(element) {
                        element.classList.add("st_hidden");
                    });
                }
            };
            _this_1.hideShareCartForm = function() {
                var shareCartFormWrapper = document.querySelector(".sc_share-cart-wrapper-two_JS");
                var mainShareCartWrapper = document.querySelector(".sc_share-cart-wrapper-one_JS");
                var bottomCart = document.querySelector(".sc_bottom-cart_JS");
                if (!!shareCartFormWrapper && !!mainShareCartWrapper && !!bottomCart) {
                    shareCartFormWrapper.classList.add("st_hidden");
                    mainShareCartWrapper.classList.remove("st_hidden");
                    bottomCart.style.backgroundColor = "";
                }
                var footerVisibilityElements = document.querySelectorAll(".sc_footer_visibility_JS");
                if (!!footerVisibilityElements) {
                    footerVisibilityElements.forEach(function(element) {
                        element.classList.remove("st_hidden");
                    });
                }
                _this_1.newShareCartFormModal();
            };
            _this_1.addEventListenersForShareCartNavigation = function() {
                var shareCartBtn = _this_1.classConfig.selectShareCartButton();
                if (!!shareCartBtn) {
                    shareCartBtn.removeEventListener("click", _this_1.shareCartBtnClickHandle);
                    shareCartBtn.addEventListener("click", _this_1.shareCartBtnClickHandle);
                }
                var closeShareCartBtn = _this_1.classConfig.selectShareCartCloseButton();
                if (!!closeShareCartBtn) {
                    closeShareCartBtn.removeEventListener("click", _this_1.hideShareCartForm);
                    closeShareCartBtn.addEventListener("click", _this_1.hideShareCartForm);
                }
            };
            _this_1.handleClickOnShareCart = function() {
                var hideableElementsCollection = _this_1.getHideableElementsCollection();
                if (!!hideableElementsCollection.createShareCart) {
                    hideableElementsCollection.createShareCart.removeEventListener("click", _this_1.createShareCartBtnClickedHandler);
                    hideableElementsCollection.createShareCart.addEventListener("click", _this_1.createShareCartBtnClickedHandler);
                }
                if (!!hideableElementsCollection.newShareCartButton) {
                    hideableElementsCollection.newShareCartButton.removeEventListener("click", _this_1.resetValuesOnShareCart);
                    hideableElementsCollection.newShareCartButton.addEventListener("click", _this_1.resetValuesOnShareCart);
                }
            };
            _this_1.resetValuesOnShareCart = function() {
                var shareCartEndDate = _this_1.classConfig.shareCartEndDate();
                if (!!shareCartEndDate) {
                    var dateNow = new Date();
                    var monthFromNowDate = new Date();
                    monthFromNowDate.setDate(monthFromNowDate.getDate() + 30);
                    shareCartEndDate.value = monthFromNowDate.toISOString().split("T")[0];
                    shareCartEndDate.min = dateNow.toISOString().split("T")[0];
                    shareCartEndDate.max = monthFromNowDate.toISOString().split("T")[0];
                }
                var shareCartFormName = _this_1.classConfig.shareCartFormName();
                if (!!shareCartFormName) {
                    var dateNow = new Date();
                    shareCartFormName.value = "";
                    shareCartFormName.setAttribute("default-name-value", dateNow.toISOString());
                }
                var shareCartFormDescription = _this_1.classConfig.shareCartFormDescription();
                if (!!shareCartFormDescription) {
                    shareCartFormDescription.value = "";
                }
                _this_1.newShareCartFormModal();
            };
            _this_1.getHideableElementsCollection = function() {
                var shareCartForm = _this_1.classConfig.shareCartForm();
                var createShareCart = _this_1.classConfig.shareCartCreateButton();
                var shareCartCopyWrapper = _this_1.classConfig.shareCartCopyWrapper();
                var shareCartLoader = _this_1.classConfig.shareCartLoader();
                var shareCartButtonText = _this_1.classConfig.shareCartButtonText();
                var newShareCartButton = _this_1.classConfig.newShareCartButton();
                return {
                    shareCartForm: shareCartForm,
                    createShareCart: createShareCart,
                    shareCartCopyWrapper: shareCartCopyWrapper,
                    shareCartLoader: shareCartLoader,
                    shareCartButtonText: shareCartButtonText,
                    newShareCartButton: newShareCartButton
                };
            };
            _this_1.createShareCartBtnClickedHandler = function() {
                var _this = _this_1;
                if (window.isRep) {
                    _this_1.newShareCartFormModal();
                }
                _this_1.cartComponent.getCart(function(cartObj) {
                    var createShareCartData = _this.assembleSCData(cartObj);
                    _this.generateShareCartURL(createShareCartData, function(shareCartInfo) {
                        if (shareCartInfo === null || !(shareCartInfo === null || shareCartInfo === void 0 ? void 0 : shareCartInfo.data)) {
                            _this_1.newShareCartFormModal();
                        } else {
                            _this_1.copyLinkToShareCartModal();
                            var cartToken = shareCartInfo === null || shareCartInfo === void 0 ? void 0 : shareCartInfo.data;
                            _this.handleCopyToClipboard(cartToken, cartObj.attributes.sponsorWebAlias);
                        }
                    });
                });
            };
            _this_1.newShareCartFormModal = function() {
                var hideableElementsCollection = _this_1.getHideableElementsCollection();
                hideableElementsCollection.shareCartCopyWrapper.classList.add("st_hidden");
                hideableElementsCollection.shareCartLoader.classList.add("st_hidden");
                hideableElementsCollection.newShareCartButton.classList.add("st_hidden");
                hideableElementsCollection.shareCartForm.classList.remove("st_hidden");
                hideableElementsCollection.createShareCart.classList.remove("st_hidden");
                hideableElementsCollection.shareCartButtonText.classList.remove("st_hidden");
            };
            _this_1.copyLinkToShareCartModal = function() {
                var hideableElementsCollection = _this_1.getHideableElementsCollection();
                hideableElementsCollection.shareCartForm.classList.add("st_hidden");
                hideableElementsCollection.createShareCart.classList.add("st_hidden");
                hideableElementsCollection.shareCartLoader.classList.add("st_hidden");
                hideableElementsCollection.shareCartCopyWrapper.classList.remove("st_hidden");
                hideableElementsCollection.shareCartButtonText.classList.remove("st_hidden");
                hideableElementsCollection.newShareCartButton.classList.remove("st_hidden");
            };
            _this_1.assembleSCData = function(cartObj) {
                var createShareCartData = {
                    optional: {
                        name: "",
                        description: ""
                    },
                    default: {
                        owner_shopify_id: "",
                        owner_shopify_email: "",
                        expiration_date: "",
                        share_cart_attributes: {},
                        discount_codes: [],
                        line_items: []
                    }
                };
                var scInputName = _this_1.classConfig.shareCartFormName();
                if (scInputName.value !== "") {
                    createShareCartData.optional.name = scInputName.value;
                } else {
                    createShareCartData.optional.name = scInputName.getAttribute("default-name-value");
                }
                var scInputDescription = _this_1.classConfig.shareCartFormDescription();
                createShareCartData.optional.description = scInputDescription.value;
                var scInputEndDate = _this_1.classConfig.shareCartFormEndDate();
                createShareCartData.default.expiration_date = scInputEndDate.value;
                createShareCartData.default.owner_shopify_id = window === null || window === void 0 ? void 0 : window.customerShopifyId;
                createShareCartData.default.owner_shopify_email = window === null || window === void 0 ? void 0 : window.customerEmail;
                createShareCartData.default.discount_codes = cartObj.discount_codes;
                createShareCartData.default.share_cart_attributes = cartObj.attributes;
                var lineItems = [];
                var lineItem;
                cartObj.items.forEach(function(item) {
                    lineItem = {
                        sku: item.sku,
                        shopify_variant_id: item.variant_id,
                        quantity: item.quantity,
                        line_item_properties: item.properties
                    };
                    lineItems.push(lineItem);
                });
                createShareCartData.default.line_items = lineItems;
                return createShareCartData;
            };
            _this_1.handleCopyToClipboard = function(cartToken, sponsorWebAlias) {
                var shareCartLink = location.origin + "/pages/share-cart-loading?".concat(_features_config_15.aliasQueryParam, "=").concat(sponsorWebAlias, "&").concat(_features_config_15.sc_tokenURLKey, "=").concat(cartToken);
                var shareCartCopyInput = _this_1.classConfig.shareCartCopyInput();
                shareCartCopyInput.value = shareCartLink;
                var shareCartCopyButton = _this_1.classConfig.shareCartCopyButton();
                if (!!shareCartCopyButton) {
                    shareCartCopyButton.removeEventListener("click", function() {
                        _this_1.shareCartCopyButtonClickHandle(shareCartLink);
                    });
                    shareCartCopyButton.addEventListener("click", function() {
                        _this_1.shareCartCopyButtonClickHandle(shareCartLink);
                    });
                }
            };
            _this_1.shareCartCopyButtonClickHandle = function(shareCartLink) {
                var shareCartCopyInput = _this_1.classConfig.shareCartCopyInput();
                var shareCartCopyButton = _this_1.classConfig.shareCartCopyButton();
                var shareCartCopyWrapperInner = _this_1.classConfig.shareCartCopyWrapperInner();
                shareCartCopyInput.select();
                shareCartCopyInput.setSelectionRange(0, 99999);
                navigator.clipboard.writeText(shareCartLink);
                shareCartCopyInput.style.backgroundColor = "rgb(217, 218, 220)";
                shareCartCopyButton.style.backgroundColor = "#bbbbbb";
                shareCartCopyWrapperInner.style.backgroundColor = "#bbbbbb";
                shareCartCopyInput.style.transition = "0.2s";
                shareCartCopyButton.style.transition = "0.2s";
                shareCartCopyWrapperInner.style.transition = "0.2s";
                setTimeout(function() {
                    shareCartCopyInput.style.backgroundColor = "white";
                    shareCartCopyButton.style.backgroundColor = "#dddddd";
                    shareCartCopyWrapperInner.style.backgroundColor = "#dddddd";
                }, 1e3);
            };
            _this_1.setupQuantityWatcher = function() {
                var quantityInputElemets = document.querySelectorAll(".st_quantity-share-cart-watcher_JS");
                if (quantityInputElemets.length === 0) return;
                quantityInputElemets.forEach(function(el) {
                    el.addEventListener("input", function(e) {
                        e.target.blur();
                    });
                });
            };
            _this_1.handleShorthendURLCLick = function() {};
            _this_1.generateShareCartURL = function(data, handleResponse) {
                var _this = _this_1;
                try {
                    var sc_serverURL = window === null || window === void 0 ? void 0 : window.stAppConfig.sc_serverURL;
                    _this_1.ajax.send({
                        endpoint: sc_serverURL + "share-cart/createShareCart",
                        method: "post",
                        contentType: "json",
                        data: data,
                        callback: function(response) {
                            try {
                                var shareCartInfoRes = JSON.parse(response.response);
                                if (shareCartInfoRes.statusCode !== 201) {
                                    _this.notification.showNotification(notification_3.ENotificationType.error, "Share Cart Error", shareCartInfoRes.message);
                                }
                                handleResponse(shareCartInfoRes);
                            } catch (error) {
                                console.error("getShareCartInfo-response Response Error ------\x3e" + error);
                                _this.notification.showNotification(notification_3.ENotificationType.error, "Share Cart Error");
                                handleResponse(null);
                            }
                        }
                    });
                } catch (error) {
                    console.error("getShareCartInfo Request Error ------\x3e" + error);
                }
            };
            _this_1.isShareCartEnabled = function() {
                return _features_config_15.sc_isShareCartEnabled;
            };
            _this_1.isNameEnabled = function() {
                return _features_config_15.sc_isNameEnabled;
            };
            _this_1.isLinkShorteningEnabled = function() {
                return _features_config_15.sc_isLinkShorteningEnabled;
            };
            _this_1.isPromoCodeEnabled = function() {
                return _features_config_15.sc_isPromoCodeEnabled;
            };
            _this_1.isEditCartEnabled = function() {
                return _features_config_15.sc_isEditCartEnabled;
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.cartComponent = cartComponent;
            _this_1.objectFormatting = objectFormatting;
            _this_1.notification = notification;
            return _this_1;
        }
        StShareCartDrawer.prototype.onElementLoaded = function(elementToObserve, callback, options) {
            var MutationObserver = window.MutationObserver;
            if (!elementToObserve || elementToObserve.nodeType !== 1) return;
            if (MutationObserver) {
                var observer = new MutationObserver(callback);
                var observerOptions = void 0;
                if (!options) {
                    observerOptions = {
                        childList: true,
                        attributeFilter: [ "innerHTML" ]
                    };
                } else {
                    observerOptions = options;
                }
                observer.observe(elementToObserve, observerOptions);
                return observer;
            }
        };
        return StShareCartDrawer;
    }(st_module_27.StModule);
    exports.StShareCartDrawer = StShareCartDrawer;
});

define("extension/shopify-app/st-modules/_share-cart/share-cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_28, _features_config_16, notification_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShareCart = void 0;
    var StShareCart = function(_super) {
        __extends(StShareCart, _super);
        function StShareCart(classConfig, cartComponent, objectFormatting, shareCartDrawer, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StShareCart";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    if (_this_1.isShareCartEnabled) {
                        _this_1.getShareCartFromUrl();
                        _this_1.showNotificationForExpiredCart();
                        _this_1.openCartDrawer();
                    }
                });
            };
            _this_1.getShareCartFromUrl = function() {
                var _this = _this_1;
                var sc_redirectToPage = window === null || window === void 0 ? void 0 : window.stAppConfig.sc_redirectToPage;
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentToken = urlParams[_features_config_16.sc_tokenURLKey];
                if (!currentToken) return;
                var checkoutData = {
                    cartToken: currentToken,
                    shopifyCustomerId: window.customerShopifyId
                };
                _this_1.getShareCartInfo(checkoutData, function(shareCartInfo) {
                    var shareCartData = shareCartInfo === null || shareCartInfo === void 0 ? void 0 : shareCartInfo.data;
                    if (shareCartInfo.statusCode === 451 || shareCartInfo.statusCode === 410) {
                        var urlParams_1 = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                        urlParams_1 = __assign(__assign({}, urlParams_1), {
                            shareCartHasExpired: "true"
                        });
                        var stringifiedUrlParams = _this.objectFormatting.convertObjectToQueryString(urlParams_1);
                        if (!window.location.pathname.includes("/collections/all")) {
                            window.location.href = "".concat(window.location.origin, "/collections/all-wines").concat(stringifiedUrlParams);
                        }
                        return;
                    }
                    if (!shareCartData && !window.location.pathname.includes("/collections/all")) {
                        window.location.pathname = "/collections/all-wines";
                        return;
                    }
                    _this.cartComponent.clearCart(function(clearedCart) {
                        var _a = _this.prepareLineItemsForInsertToCart(shareCartData), updateCartData = _a.updateCartData, toUpdateLineItems = _a.toUpdateLineItems;
                        _this.cartComponent.addCart(toUpdateLineItems, function(addedToCart) {
                            _this.cartComponent.updateCart(updateCartData, function(updatedCart) {
                                window.location.href = "".concat(window.location.protocol, "//").concat(window.location.hostname).concat(sc_redirectToPage, "?").concat(_features_config_16.sc_OpenCartDrawerUrlParam, "=true");
                            });
                        });
                    });
                });
            };
            _this_1.showNotificationForExpiredCart = function() {
                if (!window.location.pathname.includes("/collections/all")) return;
                var searchQueryParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                if (!searchQueryParams["shareCartHasExpired"]) return;
                if (searchQueryParams["shareCartHasExpired"] === "true") {
                    _this_1.notification.showNotification(notification_4.ENotificationType.info, "Shared Cart has expired", "This Shared Cart has expired and is no longer available.", 5e3);
                }
            };
            _this_1.prepareLineItemsForInsertToCart = function(shareCartData) {
                var addLineItems = [];
                shareCartData === null || shareCartData === void 0 ? void 0 : shareCartData.line_items.forEach(function(lineItem) {
                    var assembledLineItem = {
                        id: parseInt(lineItem.shopify_variant_id),
                        quantity: lineItem.quantity
                    };
                    if (!!lineItem.line_item_properties) {
                        if (Array.isArray(lineItem.line_item_properties)) {
                            if (lineItem.line_item_properties.length !== 0) {
                                assembledLineItem["properties"] = lineItem.line_item_properties;
                            }
                        }
                    }
                    addLineItems.push(assembledLineItem);
                });
                var toUpdateLineItems = {
                    items: addLineItems
                };
                var updateCartData = {
                    attributes: shareCartData === null || shareCartData === void 0 ? void 0 : shareCartData.share_cart_attributes
                };
                return {
                    updateCartData: updateCartData,
                    toUpdateLineItems: toUpdateLineItems
                };
            };
            _this_1.getShareCartInfo = function(getCheckoutData, handleResponse) {
                var _this = _this_1;
                try {
                    var sc_serverURL = window === null || window === void 0 ? void 0 : window.stAppConfig.sc_serverURL;
                    _this_1.ajax.send({
                        endpoint: sc_serverURL + "share-cart/getShareCartByToken/".concat(getCheckoutData.cartToken, "?shopifyCustomerId=").concat(getCheckoutData.shopifyCustomerId),
                        method: "get",
                        contentType: "json",
                        callback: function(response) {
                            try {
                                var shareCartInfo = JSON.parse(response.response);
                                if (response.status === 200) {
                                    handleResponse(shareCartInfo);
                                } else {
                                    _this.notification.showNotification(notification_4.ENotificationType.error, "Share Cart Error", shareCartInfo.message);
                                }
                            } catch (error) {
                                console.error("getShareCartInfo-response Response Error ------\x3e" + error);
                                _this.notification.showNotification(notification_4.ENotificationType.error, "Share Cart Error");
                            }
                        }
                    });
                } catch (error) {
                    console.error("getShareCartInfo Request Error ------\x3e" + error);
                }
            };
            _this_1.isShareCartEnabled = function() {
                return _features_config_16.sc_isShareCartEnabled;
            };
            _this_1.isNameEnabled = function() {
                return _features_config_16.sc_isNameEnabled;
            };
            _this_1.isLinkShorteningEnabled = function() {
                return _features_config_16.sc_isLinkShorteningEnabled;
            };
            _this_1.isPromoCodeEnabled = function() {
                return _features_config_16.sc_isPromoCodeEnabled;
            };
            _this_1.isEditCartEnabled = function() {
                return _features_config_16.sc_isEditCartEnabled;
            };
            _this_1.openCartDrawer = function() {
                setTimeout(function() {
                    var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                    if (urlParams[_features_config_16.sc_OpenCartDrawerUrlParam]) {
                        document.dispatchEvent(new Event("st_share-cart-loaded"));
                    }
                }, 500);
            };
            _this_1.classConfig = classConfig;
            _this_1.cartComponent = cartComponent;
            _this_1.objectFormatting = objectFormatting;
            _this_1.shareCartDrawer = shareCartDrawer;
            _this_1.notification = notification;
            return _this_1;
        }
        return StShareCart;
    }(st_module_28.StModule);
    exports.StShareCart = StShareCart;
});

define("core/shopify-app/st-modules/account-register/account-register", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, st_module_29, notification_5, _features_config_17) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountRegister = void 0;
    var StAccountRegister = function(_super) {
        __extends(StAccountRegister, _super);
        function StAccountRegister(form, notification, buttonActions, classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountRegister";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                });
            };
            _this_1.onSubmit = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorAccountRegisterForm);
                if (!!form) {
                    form.addEventListener("submit", function(e) {
                        _this.validateAccountCreation(this, e);
                    });
                }
            };
            _this_1.prepareErrorArray = function(validationData) {
                var validationDataKeys = Object.keys(validationData);
                var errorArray = [];
                validationDataKeys.forEach(function(key) {
                    if (!validationData[key].isValid) {
                        errorArray.push(validationData[key].message);
                    }
                });
                return errorArray;
            };
            
            // TODO Remove if goaffpro handles Customer creation
            // _this_1.loginCustomer = function(formData) {
            //     var _this = _this_1;
            //     var loginPayload = {};
            //     loginPayload.form_type = "customer_login";
            //     loginPayload["customer[email]"] = formData.email;
            //     loginPayload["customer[password]"] = formData.password;
            //     _this.ajax.send({
            //         endpoint: window.location.protocol + "//" + window.location.hostname + "/account/login",
            //         method: "post",
            //         contentType: "form",
            //         data: loginPayload,
            //         callback: function(response) {
            //             try {
            //                 if (response.status == 200) {
            //                     var redirectUrlResponse = response.responseURL.toString();
            //                     if (redirectUrlResponse.includes("/account/login")) {
            //                         window.location.reload();
            //                         _this.revertSubmitButtonToDefault();
            //                         _this.notification.showNotification(notification_5.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
            //                     } else {
            //                         window.location.assign(redirectUrlResponse);
            //                     }
            //                 } else {
            //                     window.location.reload();
            //                     _this.revertSubmitButtonToDefault();
            //                     _this.notification.showNotification(notification_5.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
            //                 }
            //             } catch (error) {
            //                 console.error(error);
            //                 _this.revertSubmitButtonToDefault();
            //                 _this.notification.showNotification(notification_5.ENotificationType.error, "Server Error", error);
            //             }
            //         }
            //     });
            // };
            // _this_1.registerCustomer = function(customerPayload) {
            //     var _this = _this_1;
            //     _this_1.ajax.send({
            //         endpoint: _this_1.endpoint["enrollment"]["createAccount"],
            //         method: "post",
            //         contentType: "json",
            //         data: customerPayload,
            //         callback: function(response) {
            //             try {
            //                 _this.loginCustomer(customerPayload);
            //             } catch (error) {
            //                 console.error(error);
            //                 _this.notification.showNotification(notification_5.ENotificationType.error, "Server Error", error);
            //                 _this.revertSubmitButtonToDefault();
            //             }
            //         }
            //     });
            // };
            // END Remove if goaffpro handles Customer creation

            _this_1.validateAccountCreation = function(form, submitEvent) {
                var _this = _this_1;
                if (form.classList.contains(_this_1.classConfig.classAccountRegisterFormPreventDefault)) {
                    //submitEvent.preventDefault();
                    //var formData = _this.form.collectFormData(form);
                    var hiddenAlsInput = form.querySelector(_this_1.classConfig.selectorRepresentativeAlias);
                    if (!(hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) || !_features_config_17.canGoUnderCorporateSite && (hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) === _features_config_17.defaultWebAlias) {
                        _this.notification.showNotification(notification_5.ENotificationType.error, "Validation Error", "Web alias not entered or invalid");
                        submitEvent.preventDefault();
                        _this.revertSubmitButtonToDefault();
                    } else {
                        // var payload_1 = {
                        //     email: formData["customer[email]"],
                        //     firstName: formData["customer[first_name]"],
                        //     lastName: formData["customer[last_name]"],
                        //     password: formData["customer[password]"],
                        //     sponsorsWebAlias: formData["customer[note][sponsorWebAlias]"]
                        // };
                        var passwordInputElement = document.querySelector('input[name="customer[password]"]');
                        var repeatPasswordInputElement = document.querySelector('input[name="repeatPassword"]');
                        if (passwordInputElement.value.length > 40) {
                            _this.notification.showNotification(notification_5.ENotificationType.error, "Validation Error", "Password cannot contain more than 40 characters!");
                            submitEvent.preventDefault();
                            _this.revertSubmitButtonToDefault();
                        } else if (passwordInputElement.value === (repeatPasswordInputElement === null || repeatPasswordInputElement === void 0 ? void 0 : repeatPasswordInputElement.value) || !repeatPasswordInputElement) {
                            // TODO Remove if user->consultant relationship is handled later by goaffpro
                            // _this.ajax.send({
                            //     endpoint: _this.endpoint["enrollment"]["validate-data"],
                            //     method: "post",
                            //     contentType: "json",
                            //     data: payload_1,
                            //     callback: function(response) {
                            //         try {
                            //             var validationResponse = JSON.parse(response.response);
                            //             var validationErrors = _this.prepareErrorArray(validationResponse.data);
                            //             if (validationErrors.length !== 0) {
                            //                 _this.notification.showNotification(notification_5.ENotificationType.error, "Validation Error", validationErrors);
                            //                 _this.revertSubmitButtonToDefault();
                            //             } else {
                            //                 _this.registerCustomer(payload_1);
                            //             }
                            //         } catch (error) {
                            //             console.error(error);
                            //             _this.notification.showNotification(notification_5.ENotificationType.error, "Server Error", error);
                            //             _this.revertSubmitButtonToDefault();
                            //         }
                            //     }
                            // });
                        } else {
                            _this.notification.showNotification(notification_5.ENotificationType.error, "Validation Error", "Passwords not matching!");
                            submitEvent.preventDefault();
                            _this.revertSubmitButtonToDefault();
                        }
                    }
                } else {
                    form.classList.add(_this.classConfig.classAccountRegisterFormPreventDefault);
                }
            };
            _this_1.revertSubmitButtonToDefault = function() {
                var submitBtn = document.querySelector('[type="submit"]');
                if (!!submitBtn) {
                    submitBtn.removeAttribute("aria-busy");
                }
            };

            _this_1.togglePassword = function() {
                var _this = _this_1;
                var passwordEyeIcons = document.querySelectorAll(_this_1.classConfig.selectorPasswordVisibilityButton);
                if (!passwordEyeIcons) {
                    return;
                }
                passwordEyeIcons.forEach(function(icon) {
                    icon.addEventListener("click", function(e) {
                        e.preventDefault();
                        var passwordLabel = _this.generalMethods.getClosestByTag(this, "div");
                        var passwordInput = passwordLabel.querySelector(_this.classConfig.selectorRegisterPasswordInput);
                        if (!!passwordInput) {
                            if (passwordInput.getAttribute("type") === "password") {
                                passwordInput.setAttribute("type", "text");
                                this.classList.add("st_password-visible");
                            } else {
                                passwordInput.setAttribute("type", "password");
                                this.classList.remove("st_password-visible");
                            }
                        }
                    });
                });
            };
            _this_1.form = form;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountRegister;
    }(st_module_29.StModule);
    exports.StAccountRegister = StAccountRegister;
});

define("extension/shopify-app/st-modules/enrollment/error-modal/enrollment-error-modal", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_30) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentErrorModal = void 0;
    var StEnrollmentErrorModal = function(_super) {
        __extends(StEnrollmentErrorModal, _super);
        function StEnrollmentErrorModal(objectFormatting) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentErrorModal";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.onEnrollmentErrorModalBtnClick();
                    _this.checkIfEnrollmentAcknowledged();
                });
            };
            _this.closeEnrollmentErrorModal = function() {
                var enrollmentErrorModal = document.querySelector(".st_enrollment-error-modal_JS");
                if (!!enrollmentErrorModal) {
                    enrollmentErrorModal.classList.add("st_hidden");
                }
            };
            _this.onEnrollmentErrorModalBtnClick = function() {
                var closeEnrollmentErrorModalBtn = document.querySelector(".st_close-enrollment-error-modal_JS");
                if (!!closeEnrollmentErrorModalBtn) {
                    closeEnrollmentErrorModalBtn.addEventListener("click", function() {
                        _this.closeEnrollmentErrorModal();
                        sessionStorage.setItem("enrollment-error-acknowledged", "true");
                    });
                }
            };
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        StEnrollmentErrorModal.prototype.checkIfEnrollmentAcknowledged = function() {
            if (!sessionStorage.getItem("enrollment-error-acknowledged") || sessionStorage.getItem("enrollment-error-acknowledged") == "false") {
                var enrollmentErrorModal = document.querySelector(".st_enrollment-error-modal_JS");
                if (!!enrollmentErrorModal) {
                    enrollmentErrorModal.classList.remove("st_hidden");
                }
            }
        };
        return StEnrollmentErrorModal;
    }(st_module_30.StModule);
    exports.StEnrollmentErrorModal = StEnrollmentErrorModal;
});

define("extension/shopify-app/st-modules/enrollment/enrollment", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_31, _features_config_18) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollment = void 0;
    var StEnrollment = function(_super) {
        __extends(StEnrollment, _super);
        function StEnrollment(cart, generalMethod) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StEnrollment";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    var _a;
                    _this_1.dateValidation();
                    _this_1.stateValidation();
                    _this_1.taxIdFormat();
                    _this_1.clickOnSubmit();
                    _this_1.zipCodeFormat();
                    _this_1.formatPhoneUS();
                    _this_1.setupRealtimeValidation();
                    _this_1.initCheckboxChangeListener();
                    var _this = _this_1;
                    (_a = document.querySelector(".sc_enrollment-file-input")) === null || _a === void 0 ? void 0 : _a.addEventListener("change", function() {
                        _this.uploadProfilePhoto();
                    });
                });
            };
            _this_1.clickOnSubmit = function() {
                var _this = _this_1;
                var submitBtn = document.querySelector(".sc_enrollment-form-submit-btn_JS");
                var emailErrorElement = document.querySelector("#enrollment_email_error");
                if(emailErrorElement) emailErrorElement.classList.add('hidden');

                if (!!submitBtn) {
                    if (_this.enrollmentValidationFE()) {
                        submitBtn.removeAttribute("disabled");
                    } else {
                        submitBtn.setAttribute("disabled", "disabled");
                    }
                    submitBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.enrollmentValidationBE();
                    });
                }
            };
            _this_1.replaceWineItemsWithCoffeeInCart = function(cb) {
                var _this = _this_1;
                _this_1.cart.getCart(function(currCart) {
                    var changeCartObj = [];
                    var newCartVariantIds = __spreadArray([ _features_config_18.replacementItemVariantId ], _features_config_18.irreplaceableItemsOnEnrollment, true);
                    newCartVariantIds.forEach(function(itemVariantId) {
                        changeCartObj.push({
                            id: itemVariantId,
                            quantity: 1
                        });
                    });
                    _this.cart.clearCart(function(clearedCart) {
                        _this.cart.addCart(changeCartObj, function(addedCart) {
                            cb();
                        });
                    });
                });
            };
            _this_1.getFormData = function() {
                var _a, _b;
                var form = document.querySelector(".sc_enrollment-form");
                if (!form) return null;
                var data = {};
                var inputCheckbox = form.querySelectorAll("input.sc_enrollment-input:not([type='checkbox']):not([type='file'])");
                inputCheckbox.forEach(function(input) {
                    var label = input.name;
                    data[label] = input.value;
                });
                var emailInput = form.querySelector(".sc_enrollment-input-email_JS");
                if (emailInput) {
                    data["email"] = emailInput.value;
                }
                var sponsorEmailInput = form.querySelector(".st_representative-sponsorEmail_JS");
                if (emailInput) {
                    data["sponsorEmail"] = sponsorEmailInput.value;
                }
                var firstNameInput = form.querySelector(".sc_enrollment-input-first-name_JS");
                if (firstNameInput) {
                    data["firstName"] = firstNameInput.value;
                }
                var lastNameInput = form.querySelector(".sc_enrollment-input-last-name_JS");
                if (lastNameInput) {
                    data["lastName"] = lastNameInput.value;
                }
                var stateSelect = form.querySelector(".sc_enrollment-state_JS");
                if (stateSelect) {
                    data["state"] = stateSelect.value;
                }
                var countrySelect = form.querySelector("select[disabled]");
                if (countrySelect) {
                    data["country"] = countrySelect.value;
                }
                var fileInput = form.querySelector("input[type='file']");
                if (fileInput && fileInput.files.length > 0) {
                    data["image"] = fileInput.files[0];
                } else {
                    data["image"] = null;
                }
                var phoneInput = form.querySelector("input[type='tel']");
                if (phoneInput) {
                    data["phone"] = phoneInput.value;
                }
                var checkboxes = form.querySelectorAll(".sc_enrollment-input-checkbox");
                data["consultant_agreement"] = ((_a = checkboxes[0]) === null || _a === void 0 ? void 0 : _a.checked) || false;
                data["policies_and_procedures"] = ((_b = checkboxes[1]) === null || _b === void 0 ? void 0 : _b.checked) || false;
                var urlInput = document.querySelector(".sc_enrollment-file-input_JS");
                if (!!urlInput) {
                    data["image"] = urlInput.getAttribute("data-image-url");
                }
                return data;
            };
            _this_1.enrollmentValidationBE = function() {

                // The shapetech api call will randomly lock up. It also doesn't actually
                // validate, since when it does respond, it always says status: 200.
                // So just continue without validation.

                var _this = _this_1;
                var customerEmail = document.querySelector(".sc_enrollment-input-email_JS");
                var emailErrorElement = document.querySelector("#enrollment_email_error");
                var emailParam = customerEmail === null || customerEmail === void 0 ? void 0 : customerEmail.value;
                if (emailParam) {
                    emailParam = encodeURIComponent(emailParam);
                }
                var validationRequest = {
                    email: emailParam
                };
                _this_1.ajax.send({
                    //endpoint: _this_1.endpoint["customer"]["customer-validation"],
                    endpoint: `https://t1l4iwe5jb.execute-api.us-east-2.amazonaws.com/sc-test?email=${emailParam}`,
                    method: "GET",
                    contentType: "json",
                    data: '',
                    callback: function(response) {
                        try {
                            //console.log(response.status);
                            // this was previously looking at enrollmentResponse.status, which was copied in from response i guess?
                            if (response.status === 200) {
                                var enrollmentResponse = JSON.parse(response.response);
                                if (enrollmentResponse.data && enrollmentResponse.data.canCreateCustomerAccount == true) {
                                    _this.updateCart();
                                } else {
                                    console.log("backend validation failed with status: " + enrollmentResponse.status);
                                    if(emailErrorElement) emailErrorElement.classList.remove('hidden');
                                }
                            } else {
                                console.log("backend validation failed with status: " + response.status);
                                if(emailErrorElement) emailErrorElement.classList.remove('hidden');
                            }
                        } catch (error) {
                            console.error(error);
                        }
                    }
                });
            };
            _this_1.enrollmentValidationFE = function() {
                var valid = false;
                var isCheckedTC = _this_1.checkboxValidation();
                var checkFields = _this_1.validateEnrollmentFields();
                if (isCheckedTC && checkFields) {
                    valid = true;
                }
                return valid;
            };
            _this_1.initCheckboxChangeListener = function() {
                var _this = _this_1;
                var submitBtn = document.querySelector(".sc_enrollment-form-submit-btn_JS");
                var checkboxes = document.querySelectorAll(".sc_enrollment-input-checkbox");
                checkboxes.forEach(function(checkbox) {
                    checkbox.removeEventListener("change", function() {
                        _this.checkboxOnChange(submitBtn);
                    });
                    checkbox.addEventListener("change", function() {
                        _this.checkboxOnChange(submitBtn);
                    });
                });
            };
            _this_1.checkboxOnChange = function(submitBtn) {
                if (_this_1.checkboxValidation() && _this_1.validateEnrollmentFields()) {
                    submitBtn.removeAttribute("disabled");
                } else {
                    var isDisabled = !!submitBtn.getAttribute("disabled");
                    if (!isDisabled) {
                        submitBtn.setAttribute("disabled", "disabled");
                    }
                }
            };
            _this_1.dateValidation = function() {
                var dobInput = document.querySelector(".sc_enrollment-dob_JS");
                var warning = document.querySelector(".sc_dob-warning");
                if (dobInput) {
                    var today = new Date();
                    var year = today.getFullYear() - 21;
                    var month = (today.getMonth() + 1).toString().padStart(2, "0");
                    var day = today.getDate().toString().padStart(2, "0");
                    var maxDate = "".concat(year, "-").concat(month, "-").concat(day);
                    dobInput.max = maxDate;
                    dobInput.addEventListener("change", function() {
                        var selectedDate = new Date(this.value);
                        var today = new Date();
                        var ageDate = new Date(today.getFullYear() - 21, today.getMonth(), today.getDate());
                        if (selectedDate > ageDate) {
                            warning.textContent = "You must be at least 21 years old.";
                            this.setCustomValidity("You must be at least 21 years old.");
                        } else {
                            warning.textContent = "";
                            this.setCustomValidity("");
                        }
                    });
                }
            };
            _this_1.stateValidation = function() {
                var states = _features_config_18.stateList;
                var restrictedStates = _features_config_18.restrictedStateList;
                var select = document.querySelector(".sc_enrollment-state_JS");
                if (select) {
                    select.innerHTML = "";
                    var defaultOption = document.createElement("option");
                    defaultOption.value = "";
                    defaultOption.textContent = "Select a state";
                    select.appendChild(defaultOption);
                    states.forEach(function(state) {
                        var option = document.createElement("option");
                        option.value = state;
                        option.textContent = state;
                        select.appendChild(option);
                    });
                    var warning_1 = document.createElement("div");
                    warning_1.classList.add("sc_state-warning");
                    warning_1.style.color = "red";
                    warning_1.style.marginTop = "4px";
                    warning_1.style.fontSize = "10px";
                    select.parentElement.appendChild(warning_1);
                    select.addEventListener("change", function() {
                        if (restrictedStates.includes(select.value)) {
                            warning_1.textContent = "Wine shipping isn't available in your selected state. If you sign up, your cart will be updated with coffee.";
                        } else {
                            warning_1.textContent = "";
                        }
                    });
                }
            };
            _this_1.updateCart = function() {
                var updateData = _this_1.getFormData();
                try {
                    var data = Array.isArray(updateData) ? {
                        updates: updateData
                    } : updateData;
                    _this_1.ajax.send({
                        endpoint: "/cart/update.js",
                        method: "POST",
                        contentType: "json",
                        data: {
                            attributes: data
                        },
                        callback: function(res) {
                            if (_features_config_18.restrictedStateList.includes(updateData["state"])) {
                                _this_1.replaceWineItemsWithCoffeeInCart(function() {
                                    window.location.href = "/checkout";
                                });
                            } else {
                                window.location.href = "/checkout";
                            }
                        }
                    });
                } catch (err) {
                    console.log("Update Cart ---\x3e Error:", err);
                }
            };
            _this_1.taxIdFormat = function() {
                var ssnInput = document.querySelector(".sc_enrollment-ssn_JS");
                if (ssnInput) {
                    ssnInput.addEventListener("input", function(e) {
                        var input = e.target;
                        var rawValue = input.value.replace(/\D/g, "").slice(0, 9);
                        var cursorPosition = input.selectionStart || 0;
                        var formatted = "";
                        if (rawValue.length > 5) {
                            formatted = "".concat(rawValue.slice(0, 3), "-").concat(rawValue.slice(3, 5), "-").concat(rawValue.slice(5));
                        } else if (rawValue.length > 3) {
                            formatted = "".concat(rawValue.slice(0, 3), "-").concat(rawValue.slice(3));
                        } else {
                            formatted = rawValue;
                        }
                        input.value = formatted;
                        var nextCursorPosition = formatted.length;
                        if (document.activeElement === input) {
                            window.requestAnimationFrame(function() {
                                input.setSelectionRange(nextCursorPosition, nextCursorPosition);
                            });
                        }
                    });
                }
            };
            _this_1.checkboxValidation = function() {
                var checkboxes = document.querySelectorAll(".sc_enrollment-input-checkbox");
                if (checkboxes.length < 2) return false;
                return Array.from(checkboxes).every(function(cb) {
                    return cb.checked;
                });
            };
            _this_1.zipCodeFormat = function() {
                var zipInput = document.querySelector(".sc_enrollment-zip_JS");
                if (!!zipInput) {
                    zipInput.addEventListener("input", function(e) {
                        var digits = zipInput.value.replace(/\D/g, "");
                        if (digits.length > 5) digits = digits.slice(0, 5);
                        zipInput.value = digits;
                    });
                }
                if (zipInput) {
                    zipInput.addEventListener("keypress", function(e) {
                        var isNumber = /[0-9]/.test(e.key);
                        if (!isNumber) {
                            e.preventDefault();
                        }
                    });
                    zipInput.addEventListener("paste", function(e) {
                        var _a, _b;
                        var pasted = (_b = (_a = e.clipboardData) === null || _a === void 0 ? void 0 : _a.getData("text")) !== null && _b !== void 0 ? _b : "";
                        if (!/^\d+$/.test(pasted)) {
                            e.preventDefault();
                        }
                    });
                    zipInput.addEventListener("input", function(e) {
                        zipInput.value = zipInput.value.replace(/\D/g, "").slice(0, 5);
                    });
                }
            };
            _this_1.formatPhoneUS = function() {
                var phoneInput = document.querySelector(".sc_enrollment-phone_JS");
                if (phoneInput) {
                    var COUNTRY_CODE_1 = "+1";
                    phoneInput.addEventListener("input", function(e) {
                        var input = e.target;
                        var raw = input.value.replace(/[^\d]/g, "");
                        if (raw.startsWith("1")) {
                            raw = raw.substring(1);
                        }
                        raw = raw.slice(0, 10);
                        var formatted = COUNTRY_CODE_1;
                        if (raw.length > 0) {
                            formatted += " (".concat(raw.slice(0, 3));
                        }
                        if (raw.length >= 4) {
                            formatted += ") ".concat(raw.slice(3, 6));
                        }
                        if (raw.length >= 7) {
                            formatted += "-".concat(raw.slice(6, 10));
                        }
                        input.value = formatted;
                    });
                    phoneInput.addEventListener("focus", function() {
                        if (phoneInput.value.trim() === "") {
                            phoneInput.value = "+1 ";
                        }
                    });
                }
            };
            _this_1.validateEnrollmentFields = function() {
                var form = document.querySelector(".sc_enrollment-form");
                if (!form) return false;
                var requiredFieldNames = [ "email", "firstName", "lastName", "dateOfBirth", "address1", "city", "zipCode", "taxId" ];
                var isValid = true;
                requiredFieldNames.forEach(function(name) {
                    var input = form.querySelector('[name="'.concat(name, '"]'));
                    if (!input || input.value.trim() === "") {
                        input === null || input === void 0 ? void 0 : input.classList.add("has-error");
                        isValid = false;
                    } else {
                        input.classList.remove("has-error");
                    }
                });
                var stateSelect = form.querySelector(".sc_enrollment-state_JS");
                if (!stateSelect || !stateSelect.value || stateSelect.value === "") {
                    stateSelect === null || stateSelect === void 0 ? void 0 : stateSelect.classList.add("has-error");
                    isValid = false;
                } else {
                    stateSelect.classList.remove("has-error");
                }
                return isValid;
            };
            _this_1.setupRealtimeValidation = function() {
                var form = document.querySelector(".sc_enrollment-form");
                var _this = _this_1;
                if (!form) return;
                var inputs = form.querySelectorAll('input[name="email"] ,input[name="firstName"], input[name="lastName"], input[name="dateOfBirth"], input[name="address1"], input[name="city"], input[name="zipCode"], input[name="country"], input[name="taxId"], select.sc_enrollment-state_JS');
                var submitBtn = document.querySelector(".sc_enrollment-form-submit-btn_JS");
                inputs.forEach(function(el) {
                    el.addEventListener("input", function() {
                        _this.validateEnrollmentFields();
                        if (_this.enrollmentValidationFE()) {
                            submitBtn.removeAttribute("disabled");
                        } else {
                            submitBtn.setAttribute("disabled", "disabled");
                        }
                    });
                    el.addEventListener("change", function() {
                        _this.validateEnrollmentFields();
                        if (_this.enrollmentValidationFE()) {
                            submitBtn.removeAttribute("disabled");
                        } else {
                            submitBtn.setAttribute("disabled", "disabled");
                        }
                    });
                });
            };
            _this_1.uploadProfilePhoto = function() {
                var _a;
                var fileInput = document.querySelector(".sc_enrollment-file-input");
                var file = (_a = fileInput === null || fileInput === void 0 ? void 0 : fileInput.files) === null || _a === void 0 ? void 0 : _a[0];
                if (!file) {
                    alert("Please select a file first.");
                    return;
                }
                var _this = _this_1;
                _this.ajax.send({
                    endpoint: _this_1.endpoint["customer"]["generate-upload-url"],
                    method: "post",
                    contentType: "json",
                    data: {
                        fileName: file.name
                    },
                    callback: function(response) {
                        try {
                            var result_1 = JSON.parse(response.response);
                            var formData_1 = new FormData();
                            Object.keys(result_1.data.fields).forEach(function(key) {
                                formData_1.append(key, result_1.data.fields[key]);
                            });
                            formData_1.append("Content-Type", file.type);
                            formData_1.append("file", file);
                            var xhr_1 = new XMLHttpRequest();
                            xhr_1.open("POST", result_1.data.url, true);
                            xhr_1.onreadystatechange = function() {
                                if (xhr_1.readyState === 4) {
                                    if (xhr_1.status === 204) {
                                        var uploadedUrl = "https://".concat(result_1.data.fields.bucket, "/").concat(result_1.data.fields.key);
                                        var urlInput = document.querySelector(".sc_enrollment-file-input_JS");
                                        if (!!urlInput) {
                                            urlInput.setAttribute("data-image-url", uploadedUrl);
                                        }
                                    } else {
                                        console.error("S3 upload failed with status:", xhr_1.status);
                                    }
                                }
                            };
                            xhr_1.send(formData_1);
                        } catch (err) {
                            console.error("Error parsing preSignedUrl response:", err);
                        }
                    }
                });
            };
            _this_1.cart = cart;
            _this_1.generalMethod = generalMethod;
            return _this_1;
        }
        return StEnrollment;
    }(st_module_31.StModule);
    exports.StEnrollment = StEnrollment;
});

define("_shopify.app.di.container", [ "require", "exports", "core/shopify-app/st-modules/_static/static", "core/shopify-app/st-modules/webalias/webalias", "core/shopify-app/st-modules/_general-methods/browser-history", "core/shopify-app/st-modules/_general-methods/cookies/cookies", "core/shopify-app/st-modules/_general-methods/form/customer-type", "core/shopify-app/st-modules/_general-methods/general-methods", "core/shopify-app/st-modules/_general-methods/button/button-actions", "core/shopify-app/st-modules/_general-methods/form/form", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/_general-methods/object-formatting", "core/shopify-app/st-modules/_di-container/di.container.public", "core/shopify-app/st-modules/_general-methods/form/fields/date-input", "core/shopify-app/st-modules/_general-methods/form/form-class-config", "core/shopify-app/st-modules/account/_general/account-class-config", "core/shopify-app/st-modules/account-register/account-register-class-config", "core/shopify-app/st-modules/search-sponsor/search-sponsor-guard", "core/shopify-app/st-modules/search-sponsor/search-sponsor-service", "extension/shopify-app/st-modules/account/blocks/personal-site/personal-site", "extension/shopify-app/st-modules/referral/referral", "extension/shopify-app/st-modules/cart/cart", "extension/shopify-app/st-modules/search-sponsor/search-sponsor", "extension/shopify-app/st-modules/search-sponsor/sponsor-search-class-config", "extension/shopify-app/st-modules/webalias/inject-representative-info", "extension/shopify-app/st-modules/webalias/webalias-class-config", "extension/shopify-app/st-modules/general-table/general-table", "extension/shopify-app/st-modules/share-cart/share-cart-table", "extension/shopify-app/st-modules/share-cart/share-cart-general", "extension/shopify-app/st-modules/_share-cart/share-cart", "extension/shopify-app/st-modules/_share-cart/share-cart-drawer/share-cart-drawer", "extension/shopify-app/st-modules/_share-cart/share-cart-class-config", "core/shopify-app/st-modules/account-register/account-register", "extension/shopify-app/st-modules/enrollment/error-modal/enrollment-error-modal", "extension/shopify-app/st-modules/enrollment/enrollment" ], function(require, exports, static_2, webalias_1, browser_history_1, cookies_1, customer_type_1, general_methods_1, button_actions_1, form_1, notification_6, object_formatting_1, di_container_public_1, date_input_1, form_class_config_1, account_class_config_1, account_register_class_config_1, search_sponsor_guard_1, search_sponsor_service_1, personal_site_2, referral_2, cart_2, search_sponsor_2, sponsor_search_class_config_2, inject_representative_info_2, webalias_class_config_2, general_table_1, share_cart_table_1, share_cart_general_1, share_cart_1, share_cart_drawer_1, share_cart_class_config_1, account_register_1, enrollment_error_modal_1, enrollment_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAppDIConfig = void 0;
    var StAppDIConfig = function() {
        function StAppDIConfig() {
            var _this = this;
            this.className = "AppDIConfig";
            this.init = function() {};
            this.components = function() {
                _this.StStaticComponent = static_2.StStatic.Instance();
                _this.DiContainerPublicComponent = new di_container_public_1.DiContainerPublic();
                _this.StObjectFormattingComponent = new object_formatting_1.StObjectFormatting();
                _this.StBrowserHistoryComponent = new browser_history_1.StBrowserHistory(_this.StObjectFormattingComponent);
                _this.StCookiesComponent = new cookies_1.StCookies();
                _this.StCustomerTypeComponent = new customer_type_1.StCustomerType();
                _this.StButtonActionsComponent = new button_actions_1.StButtonActions();
                _this.StNotificationComponent = new notification_6.StNotification();
                _this.StFormConfigComponent = new form_class_config_1.StFormClassConfig();
                _this.StGeneralMethodsComponent = new general_methods_1.StGeneralMethods();
                _this.StCartComponent = new cart_2.StCartExtended(_this.StObjectFormattingComponent);
                _this.StAccountClassConfigComponent = new account_class_config_1.StAccountClassConfig();
                _this.StSearchSponsorClassConfigComponent = new sponsor_search_class_config_2.StSearchSponsorClassConfigExtended();
                _this.StDateInputComponent = new date_input_1.StDateInput(_this.StFormConfigComponent);
                _this.StFormComponent = new form_1.StForm(_this.StFormConfigComponent, _this.StDateInputComponent);
                _this.StSearchSponsorGuardComponent = new search_sponsor_guard_1.StSearchSponsorGuard(_this.StSearchSponsorClassConfigComponent, _this.StBrowserHistoryComponent, _this.StObjectFormattingComponent, _this.StGeneralMethodsComponent, _this.StCartComponent);
                _this.StAccountPersonalSiteComponent = new personal_site_2.StAccountPersonalSiteExtended(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StSearchSponsorService = new search_sponsor_service_1.StSearchSponsorService();
                _this.StSearchSponsorComponent = new search_sponsor_2.StSearchSponsorExtended(_this.StGeneralMethodsComponent, _this.StObjectFormattingComponent, _this.StBrowserHistoryComponent, _this.StSearchSponsorClassConfigComponent, _this.StCookiesComponent, _this.StCartComponent, _this.StSearchSponsorService);
                _this.StWebAliasClassConfigComponent = new webalias_class_config_2.StWebAliasClassConfigExtended();
                _this.StInjectRepresentativeInfoComponent = new inject_representative_info_2.StInjectRepresentativeInfoExtended(_this.StWebAliasClassConfigComponent, _this.StSearchSponsorComponent);
                _this.StWebAliasComponent = new webalias_1.StWebAlias(_this.StWebAliasClassConfigComponent, _this.StBrowserHistoryComponent, _this.StObjectFormattingComponent, _this.StCookiesComponent, _this.StCustomerTypeComponent, _this.StGeneralMethodsComponent, _this.StInjectRepresentativeInfoComponent, _this.StCartComponent, _this.StSearchSponsorGuardComponent, _this.StAccountPersonalSiteComponent);
                _this.StAccountRegisterClassConfigComponent = new account_register_class_config_1.StAccountRegisterClassConfig();
                _this.StAccountRegisterComponent = new account_register_1.StAccountRegister(_this.StFormComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StAccountRegisterClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StGeneralTableComponent = new general_table_1.StGeneralTable();
                _this.StShareCartClassConfig = new share_cart_class_config_1.StShareCartClassConfig(_this.StGeneralMethodsComponent);
                _this.StReferralComponent = new referral_2.StReferralExtended(_this.StGeneralMethodsComponent, _this.StObjectFormattingComponent, _this.StNotificationComponent, _this.StCustomerTypeComponent, _this.StWebAliasComponent, _this.StCartComponent, _this.StGeneralTableComponent);
                _this.StShareCartDrawer = new share_cart_drawer_1.StShareCartDrawer(_this.StShareCartClassConfig, _this.StGeneralMethodsComponent, _this.StCartComponent, _this.StObjectFormattingComponent, _this.StNotificationComponent);
                _this.StShareCart = new share_cart_1.StShareCart(_this.StShareCartClassConfig, _this.StCartComponent, _this.StObjectFormattingComponent, _this.StShareCartDrawer, _this.StNotificationComponent);
                _this.StShareCartGeneralComponent = new share_cart_general_1.StShareCartGeneral(_this.StGeneralTableComponent);
                _this.StShareCartTableComponent = new share_cart_table_1.StShareCartTable(_this.StGeneralTableComponent, _this.StShareCartGeneralComponent);
                _this.StEnrollmentComponent = new enrollment_1.StEnrollment(_this.StCartComponent, _this.StGeneralMethodsComponent);
                _this.StEnrollmentErrorModal = new enrollment_error_modal_1.StEnrollmentErrorModal(_this.StObjectFormattingComponent);
            };
            this.hierarchy = function(appName) {
                var hierarchy = [ _this.DiContainerPublicComponent, _this.StStaticComponent, _this.StEnrollmentErrorModal ];
                switch (appName) {
                  case "main":
                    hierarchy = hierarchy.concat([ _this.StGeneralTableComponent, _this.StReferralComponent, _this.StWebAliasComponent, _this.StSearchSponsorGuardComponent, _this.StSearchSponsorComponent, _this.StAccountRegisterComponent, _this.StEnrollmentComponent ]);
                    break;

                  case "account-register":
                    hierarchy = hierarchy.concat([ _this.StAccountRegisterComponent ]);
                    break;

                  case "share-cart-init":
                    hierarchy = hierarchy.concat([ _this.StShareCart, _this.StShareCartDrawer, _this.StShareCartGeneralComponent, _this.StShareCartTableComponent ]);
                    break;

                  default:
                    console.error("Unrecognized app provided to st-app. App name: " + appName);
                }
                return hierarchy;
            };
            this.components();
        }
        Object.defineProperty(StAppDIConfig, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StAppDIConfig;
    }();
    exports.StAppDIConfig = StAppDIConfig;
});

define("core/shopify-app/st-modules/_di-container/di.container", [ "require", "exports", "_shopify.app.di.container", "core/shopify-app/st-modules/_di-container/di.container.setup" ], function(require, exports, _shopify_app_di_container_1, di_container_setup_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDIContainer = void 0;
    var StDIContainer = function() {
        function StDIContainer() {
            this.className = "DI";
        }
        StDIContainer.run = function(appName) {
            new di_container_setup_1.StDIContainerSetup(appName, _shopify_app_di_container_1.StAppDIConfig);
        };
        return StDIContainer;
    }();
    exports.StDIContainer = StDIContainer;
});

define("core/shopify-app/st-modules/_general-methods/currency", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_32) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCurrency = exports.EAmountType = exports.ECurrencyFormatType = void 0;
    var ECurrencyFormatType;
    (function(ECurrencyFormatType) {
        ECurrencyFormatType["withCurrency"] = "withCurrency";
        ECurrencyFormatType["withoutCurrency"] = "withoutCurrency";
    })(ECurrencyFormatType = exports.ECurrencyFormatType || (exports.ECurrencyFormatType = {}));
    var EAmountType;
    (function(EAmountType) {
        EAmountType["amount"] = "amount";
        EAmountType["amount_no_decimals"] = "amount_no_decimals";
        EAmountType["unknown"] = "unknown";
    })(EAmountType = exports.EAmountType || (exports.EAmountType = {}));
    var StCurrency = function(_super) {
        __extends(StCurrency, _super);
        function StCurrency() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Currency";
            _this.currencyFormat = window.stCurrencyFormat;
            _this.applyFormat = function(amount, formatType) {
                if (formatType === void 0) {
                    formatType = ECurrencyFormatType.withCurrency;
                }
                var format = _this.currencyFormat[formatType];
                var amountType = _this.determineAmountType(format);
                if (amountType !== EAmountType.unknown) {
                    return format.replace("{{" + amountType + "}}", "" + amount.toFixed(2));
                } else {
                    console.error("Unrecognized price format. Returning price without currency formatting.");
                    return "" + amount;
                }
            };
            _this.determineAmountType = function(format) {
                if (format.indexOf("{{amount}}") > -1) {
                    return EAmountType.amount;
                } else if (format.indexOf("{{amount_no_decimals}}") > -1) {
                    return EAmountType.amount_no_decimals;
                } else {
                    return EAmountType.unknown;
                }
            };
            return _this;
        }
        StCurrency.prototype.commaFormattedPrice = function(amount, decimalDelimiter, thousandsDelimiter) {
            if (decimalDelimiter === void 0) {
                decimalDelimiter = ".";
            }
            if (thousandsDelimiter === void 0) {
                thousandsDelimiter = ",";
            }
            var amountComponents = String(amount).split(".", 2);
            var wholeNumber = parseInt(amountComponents[0]);
            if (isNaN(wholeNumber)) {
                return "";
            }
            var decimal = amountComponents[1];
            var minus = wholeNumber < 0 ? "-" : "";
            wholeNumber = Math.abs(wholeNumber);
            var wholeString = String(wholeNumber);
            var amountSegmented = [];
            while (wholeString.length > 3) {
                amountSegmented.unshift(wholeString.substr(wholeString.length - 3));
                wholeString = wholeString.substr(0, wholeString.length - 3);
            }
            if (wholeString.length > 0) {
                amountSegmented.unshift(wholeString);
            }
            wholeString = amountSegmented.join(thousandsDelimiter);
            decimal = decimal.length < 1 ? "" : decimalDelimiter + decimal;
            return minus + wholeString + decimal;
        };
        return StCurrency;
    }(st_module_32.StModule);
    exports.StCurrency = StCurrency;
});

define("core/shopify-app/st-modules/_general-methods/form/cart-manipulation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_33) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCartManipulation = void 0;
    var StCartManipulation = function(_super) {
        __extends(StCartManipulation, _super);
        function StCartManipulation() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "CartManipulation";
            return _this;
        }
        return StCartManipulation;
    }(st_module_33.StModule);
    exports.StCartManipulation = StCartManipulation;
});

define("core/shopify-app/st-modules/_general-methods/form/formatting", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_34) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFormFormatting = void 0;
    var StFormFormatting = function(_super) {
        __extends(StFormFormatting, _super);
        function StFormFormatting() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Formatting";
            _this.setupFormatting = function(collectionToIterate, formattingFn, callbackFn) {
                if (callbackFn === void 0) {
                    callbackFn = function(value) {};
                }
                collectionToIterate.forEach(function(input) {
                    var formattedVal = formattingFn(input.value);
                    input.value = formattedVal;
                    input.setAttribute("value", formattedVal);
                    callbackFn(formattedVal);
                    input.addEventListener("input", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                    input.addEventListener("keyup", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                    input.addEventListener("paste", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                });
            };
            _this.formatPhoneNumber = function(phone) {
                var phoneString = ("" + phone).replace(/\D/g, "");
                var segment1 = phoneString.slice(0, 3);
                var segment2 = phoneString.slice(3, 6);
                var segment3 = phoneString.slice(6, 10);
                return segment1 + (segment2.length > 0 ? "-" + segment2 : "") + (segment3.length > 0 ? "-" + segment3 : "");
            };
            _this.formatWebAlias = function(webAlias) {
                return webAlias.replace(/[^A-Za-z0-9\-_]/g, "");
            };
            _this.formatSSN = function(ssn) {
                var phoneString = ("" + ssn).replace(/\D/g, "");
                var segment1 = phoneString.slice(0, 3);
                var segment2 = phoneString.slice(3, 5);
                var segment3 = phoneString.slice(5, 9);
                return segment1 + (segment2.length > 0 ? "-" + segment2 : "") + (segment3.length > 0 ? "-" + segment3 : "");
            };
            return _this;
        }
        return StFormFormatting;
    }(st_module_34.StModule);
    exports.StFormFormatting = StFormFormatting;
});

define("core/shopify-app/st-modules/_general-methods/form/loader", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_35) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StLoader = void 0;
    var StLoader = function(_super) {
        __extends(StLoader, _super);
        function StLoader() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Loader";
            _this.init = function() {};
            _this.on = function(triggerBtn) {
                if (!!triggerBtn && !triggerBtn.classList.contains("st_loader-active")) {
                    triggerBtn.classList.add("st_loader-active");
                }
            };
            _this.off = function(triggerBtn) {
                if (!!triggerBtn && triggerBtn.classList.contains("st_loader-active")) {
                    triggerBtn.classList.remove("st_loader-active");
                }
            };
            return _this;
        }
        return StLoader;
    }(st_module_35.StModule);
    exports.StLoader = StLoader;
});

define("core/shopify-app/st-modules/_general-methods/init-retry", [ "require", "exports", "core/shopify-app/st-modules/_static/static" ], function(require, exports, static_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInitRetry = void 0;
    var StInitRetry = function() {
        function StInitRetry() {
            var _this_1 = this;
            this.className = "InitRetry";
            this.recursiveInitRetry = 0;
            this.timeout = 200;
            this.init = function() {};
            this.initWithCondition = function(params) {
                var _this = _this_1;
                var def = {
                    conditionGeneratorParams: [],
                    callbackParams: [],
                    noOfRetries: 6
                };
                var completeParams = __assign(__assign({}, def), params);
                var initCondition = completeParams.conditionGenerator.apply(_this, completeParams.conditionGeneratorParams);
                if (initCondition) {
                    completeParams.callback.apply(_this, completeParams.callbackParams);
                } else {
                    setTimeout(function() {
                        if (_this.recursiveInitRetry < completeParams.noOfRetries) {
                            _this.recursiveInitRetry++;
                            _this.initWithCondition(completeParams);
                        }
                    }, _this_1.timeout);
                }
            };
            this.endpoint = static_3.StStatic.Instance().obtainStaticEndpoints();
        }
        StInitRetry.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        return StInitRetry;
    }();
    exports.StInitRetry = StInitRetry;
});

define("core/shopify-app/st-modules/_general-methods/shopify-ajax", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_36) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShopifyAjax = void 0;
    var StShopifyAjax = function(_super) {
        __extends(StShopifyAjax, _super);
        function StShopifyAjax() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ShopifyAjax";
            _this.updateCartAttributes = function(attributes, callback, callbackParams) {
                if (callback === void 0) {
                    callback = function() {};
                }
                if (callbackParams === void 0) {
                    callbackParams = [];
                }
                if (!!attributes) {
                    var fnReference_1 = _this;
                    var request_2 = new XMLHttpRequest();
                    request_2.open("POST", "/cart/update.js", true);
                    request_2.withCredentials = true;
                    request_2.setRequestHeader("Content-Type", "application/json");
                    request_2.onreadystatechange = function() {
                        if (request_2.readyState === 4) {
                            try {
                                var resp = JSON.parse(request_2.response);
                                callbackParams.unshift(resp);
                                callback.apply(fnReference_1, callbackParams);
                            } catch (e) {
                                console.error(e);
                                console.error("Failed to update shopify cart attributes!");
                            }
                        }
                    };
                    request_2.send(JSON.stringify({
                        attributes: attributes
                    }));
                }
            };
            return _this;
        }
        return StShopifyAjax;
    }(st_module_36.StModule);
    exports.StShopifyAjax = StShopifyAjax;
});

(function() {
    "use strict";
    class StApp extends HTMLElement {
        static get observedAttributes() {
            return [ "app" ];
        }
        constructor() {
            super();
        }
        attributeChangedCallback(name, oldValue, newValue) {
            if (name === "app" && oldValue !== newValue) {
                this.initApp(newValue);
            }
        }
        initApp(appName) {
            require([ "core/shopify-app/st-modules/_di-container/di.container" ], function(module) {
                module.StDIContainer.run(appName);
            });
        }
    }
    customElements.define("st-app", StApp);
})();

window.define = null;

window.stEnableLog = function() {
    console.log('enabling log for st app');
    localStorage.setItem("stLog", 'true');
}
window.stDisableLog = function() {
    console.log('disabling log for st app');
    localStorage.removeItem("stLog");
}

window.stLog = function() {
    return localStorage.getItem("stLog") == 'true';
}